import React,{createContext,useState,useEffect,useRef,useCallback,useReducer,useMemo,useContext,Fragment}from'react';import PropTypes,{PropTypes as PropTypes$1,oneOf,shape,string,arrayOf}from'prop-types';import {useLazyQuery,gql,useQuery,useMutation}from'@apollo/client';import*as DSComponents from'anf-core-react';import {Link,SwatchTile as SwatchTile$1,SwatchTileGroup as SwatchTileGroup$1,ProductImage,ProductName,ProductPrice,IconButton,Headline,Button,ProductDetail,Badge,Icon}from'anf-core-react';/**
 * @typedef {Object} RecommendedProduct
 * @property {string} kic - The product KIC (Key Item Code).
 * @property {number} quantity - The quantity of the product selected.
 * @property {string} price - The price of the product.
 */

/**
 * @typedef {Object} Variables
 * @property {string[]} cartItems - An array of strings that signifies the items within the
 * cart.
 * @property {string[]} categories - An array of strings, signifying the category breadcrumbs
 * for a particular product.
 * @property {string} categoryId - A string representing the category ID.
 * @property {boolean} hasUserConsent - A boolean that signifies whether the user has given
 * recommendations consent.
 * @property {string} orderId - A string representing the order ID.
 * @property {RecommendedProduct[]} products - An array of recommended products.
 * @property {string} searchString - A string representing a particular search string.
 */

/**
 * @typedef {Object} RecommendationsContextType
 * @property {string} [id] - Optional id of the particular context.
 * @property {boolean} isEventDriven - A boolean, signifying whether the given provider
 * recommendations call is tied to a data bridge event.
 * @property {Variables} variables - An object containing parameters for the recommendations
 * query
 */

/**
 * @type {React.Context<RecommendationsContextType>}
 */

var RecommendationsContext = /*#__PURE__*/createContext({
  id: undefined,
  isEventDriven: false,
  variables: {}
});function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}function useCategoryId() {
  var getCategoryId = function getCategoryId() {
    if (!window) return null;
    var currentUrl = new URL(window.location.href);
    return currentUrl.searchParams.get('categoryId');
  };
  return {
    getCategoryId: getCategoryId
  };
}function useDatabridge(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var get = function get() {
    var _window;
    if (!((_window = window) !== null && _window !== void 0 && _window.digitalData)) return defaultValue;
    return window.digitalData.get(key);
  };
  var set = function set(value) {
    var _window2;
    if (!((_window2 = window) !== null && _window2 !== void 0 && _window2.digitalData)) return;
    window.digitalData.set(key, value);
  };
  return [get, set];
}
var useDatabridgeSubscribe = function useDatabridgeSubscribe(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    var _window3;
    var digitalData = (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.digitalData;
    if (!digitalData) return;
    digitalData.subscribe(key, function (val) {
      if (val === undefined) return;
      setValue(val);
    });
  }, [key]);
  return value;
};/**
 * A custom hook that detects when an element comes into the viewport.
 *
 * This hook utilizes the `IntersectionObserver` API to observe whether a target element
 * intersects with the viewport (i.e., whether it's visible on the screen). It returns a ref
 * that should be attached to the target element and a boolean value that indicates whether
 * the element has been triggered (i.e., entered the viewport).
 *
 * @param {Object} options - Options for the `IntersectionObserver`.
 * @param {number} options.rootMargin - Margin around the root element (in pixels or percentage).
 * @param {number} options.threshold - A threshold at which the callback is triggered (0.0 - 1.0).
 *
 * @returns {[Object, boolean]} - An array containing the `ref` for the target element and a
 * boolean that indicates whether the element is currently in the viewport.
 *
 * @example
 * const [containerRef, isVisible] = useElementOnScreen({ threshold: 0.5 });
 *
 * return <div ref={containerRef}>{isVisible && "Visible on screen!"}</div>;
 */
var useElementOnScreen = function useElementOnScreen(options) {
  var containerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    wasTriggered = _useState2[0],
    setWasTriggered = _useState2[1];
  var callbackFunction = useCallback(function (entries) {
    var _entries = _slicedToArray(entries, 1),
      entry = _entries[0];
    setWasTriggered(entry.isIntersecting);
  }, []);
  useEffect(function () {
    var _window;
    // If the element has already been triggered, do nothing (optimization)
    if (wasTriggered) return function () {};
    if (!((_window = window) !== null && _window !== void 0 && _window.IntersectionObserver)) return function () {};

    // Create a new IntersectionObserver instance with the provided callback and options
    var observer = new IntersectionObserver(callbackFunction, options);
    var currentContainerRef = containerRef.current;

    // If the element exists, observe it
    observer.observe(currentContainerRef);
    return function () {
      observer.unobserve(currentContainerRef);
    };
  }, [callbackFunction, containerRef, options, wasTriggered]);

  // Return the element's ref and its visibility status
  return [containerRef, wasTriggered];
};function useFocusSource() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    focusSource = _useState2[0],
    setFocusSource = _useState2[1];
  useEffect(function () {
    var handleMouseDown = function handleMouseDown() {
      return setFocusSource('mouse');
    };
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Tab') setFocusSource('keyboard');
    };
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return focusSource;
}/**
 * @name useIsExternalUser
 * @description React hook to determine if the current user is considered external based
 * on URL parameters and feature flags.
 * @public
 * @returns {boolean|null} Returns true if the user is external and the feature flag is enabled,
 * false if not, or null while loading.
 */
function useIsExternalUser() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    isExternalUser = _useState2[0],
    setIsExternalUser = _useState2[1];
  var _useDatabridge = useDatabridge('flag.has-external-visitor-enabled', {}),
    _useDatabridge2 = _slicedToArray(_useDatabridge, 1),
    getHasExternalVisitorEnabled = _useDatabridge2[0];
  useEffect(function () {
    var _window;
    var pageKind = (_window = window) === null || _window === void 0 || (_window = _window.digitalData) === null || _window === void 0 ? void 0 : _window.get('page.pageKind');
    var flags = getHasExternalVisitorEnabled();
    var hasExternalVisitorEnabledOnPage = flags[pageKind] || false;
    var externalUserIdentifier = ['cmp', 'source', 'utm_source'];
    var searchParams = new URLSearchParams(window.location.search);
    var result = externalUserIdentifier.some(function (id) {
      return searchParams.has(id);
    });
    setIsExternalUser(result && hasExternalVisitorEnabledOnPage);
  }, [getHasExternalVisitorEnabled]);
  return isExternalUser;
}function useMyListItems() {
  var getMyListKICArray = function getMyListKICArray() {
    var _window$digitalData;
    if (!window.digitalData) return null;
    var myListItems = ((_window$digitalData = window.digitalData) === null || _window$digitalData === void 0 ? void 0 : _window$digitalData.get('page.myListProducts')) || [];
    var myListKICArray = myListItems.map(function (product) {
      return {
        kic: product.product.imageId
      };
    });
    return myListKICArray;
  };
  return {
    getMyListKICArray: getMyListKICArray
  };
}function useSearchTerm() {
  var getSearchTerm = function getSearchTerm() {
    if (!window) return null;
    var currentUrl = new URL(window.location.href);
    return currentUrl.searchParams.get('searchTerm');
  };
  return {
    getSearchTerm: getSearchTerm
  };
}/**
 * Calculates the total width of all children elements.
 *
 * @param {Array<HTMLElement>} children - An array of child elements whose widths will be
 * summed.
 *
 * @returns {number} The total width of all child elements.
 */
function sumWidthOfChildren(children) {
  return children === null || children === void 0 ? void 0 : children.reduce(function (width, _ref) {
    var _ref$offsetWidth = _ref.offsetWidth,
      offsetWidth = _ref$offsetWidth === void 0 ? 0 : _ref$offsetWidth;
    return width + offsetWidth;
  }, 0);
}

/**
 * Returns the children of the track that are either fully or partially visible
 * within the container.
 *
 * @param {HTMLElement} container - The container element that has the overflow hidden.
 * @param {HTMLElement} track - The track element that contains the slides.
 * @param {boolean} partialVisibility - If true, include children that are partially visible;
 *                                       if false, include only fully visible children.
 * @returns {Array<HTMLElement>} An array of child elements that are visible within
 * the container.
 */
function getVisibleChildren(container, track) {
  var partialVisibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!container) return [];
  if (!track) return [];
  var containerRect = container.getBoundingClientRect();
  return _toConsumableArray(track.children).reduce(function (acc, child) {
    var childRect = child.getBoundingClientRect();

    // Calculate child's position after applying translateX
    var left = childRect.left,
      right = childRect.right;
    if (partialVisibility) {
      // Check if the child is partially visible
      var isPartiallyVisible = left < containerRect.right && right > containerRect.left;
      if (isPartiallyVisible) acc.push(child);
      return acc;
    }

    // Check if the child is fully visible
    var isFullyVisible = left >= containerRect.left && right <= containerRect.right;
    if (isFullyVisible) acc.push(child);
    return acc;
  }, []);
}// variables
var DEFAULT_ASPECT_RATIO = 4 / 3;
var DEFAULT_DRAG_SNAP_THRESHOLD = 100;
var DEFAULT_DRAG_THRESHOLD = 15;
var DEFAULT_MINIMUM_SLIDE_WIDTH = 160;
var DEFAULT_SLIDE_TIMEOUT = 100;
var DEFAULT_SLIDES_TO_SHOW = 5;
var DEFAULT_SLIDES_TO_SHOW_TABLET = 3;
var DEFAULT_SWATCHES_TO_SHOW = 4;

// breakpoints
var DEFAULT_BREAKPOINTS = {
  desktop: 1025,
  tablet: 540
};/**
 * @typedef {Object} SliderState
 * @property {number} index - The current active slide index.
 * @property {number} offset - The current offset of the slider track in pixels.
 * @property {Object} slides - The stored slides.
 * @property {Boolean} shouldFocus - Flag to wether or not the active element should focus
 */

/**
 * Generates the default state object for a slider component.
 *
 * @param {Array} slides - An array of slide elements to be used in the slider.
 * @returns {SliderState} The default state object for the slider.
 * @returns {Array} return.slides - The array of slides provided as input.
 * @returns {number} return.index - The current index of the active slide, initialized to 0.
 * @returns {number} return.offset - The current offset of the slider track in pixels,
 * initialized to 0.
 */
var getDefaultState = function getDefaultState(slides) {
  return {
    slides: slides,
    index: 0,
    offset: 0,
    shouldFocus: false
  };
};

/**
 * Generate chunked indexes based on slide magnitude.
 *
 * @param {Array} slides - The list of slides.
 * @param {number} slideMagnitude - The number of slides in each chunk.
 * @returns {Array<number>} The array of chunked starting indexes.
 */
var getChunkedIndexes = function getChunkedIndexes(slides, slideMagnitude) {
  return Array(Math.ceil(slides.length / slideMagnitude)).fill().map(function (_, index) {
    return index * slideMagnitude;
  });
};

/**
 * Calculate the next index when sliding right by a given magnitude.
 *
 * @param {SliderState} state - The current state of the slider.
 * @param {number} slideMagnitude - The number of slides to move forward.
 * @returns {number} The next index to slide to.
 */
var calculateRightIndex = function calculateRightIndex(state, slideMagnitude) {
  var chunkedIndexes = getChunkedIndexes(state.slides, slideMagnitude);

  // Find the nearest chunked index that is greater than or equal to the current index
  var nextChunkIndex = chunkedIndexes.find(function (index) {
    return index > state.index;
  });

  // If no such index is found, loop back to the first chunk
  return nextChunkIndex !== undefined ? nextChunkIndex : chunkedIndexes[0];
};

/**
 * Calculate the next index when sliding left by a given magnitude.
 *
 * @param {SliderState} state - The current state of the slider.
 * @param {number} slideMagnitude - The number of slides to move backward.
 * @returns {number} The previous index to slide to.
 */
var calculateLeftIndex = function calculateLeftIndex(state, slideMagnitude) {
  var chunkedIndexes = getChunkedIndexes(state.slides, slideMagnitude);

  // Find the nearest chunked index that is less than or equal to the current index
  var prevChunkIndex = _toConsumableArray(chunkedIndexes).reverse().find(function (index) {
    return index < state.index;
  });

  // If no such index is found, loop back to the last chunk
  return prevChunkIndex !== undefined ? prevChunkIndex : chunkedIndexes[chunkedIndexes.length - 1];
};

/**
 * Ensure the offset does not exceed the visible portion of the container.
 *
 * @param {number} offset - The calculated new offset.
 * @param {number} containerWidth - The width of the container.
 * @param {number} trackWidth - The width of the track.
 * @returns {number} The adjusted offset within the visible bounds.
 */
var setLimitsOnOffset = function setLimitsOnOffset(offset, containerWidth, trackWidth) {
  var visibleGap = containerWidth - trackWidth;

  // Limit the offset by the visible portion of the container
  return Math.min(0, Math.max(offset, visibleGap));
};

/**
 * Calculate the offset required to correctly position the slider track based on the new index.
 *
 * @param {SliderState} state - The current state of the slider.
 * @param {number} index - The new index of the slide to move to.
 * @param {HTMLElement} container - The container element of the slider.
 * @param {HTMLElement} track - The track element that contains the slides.
 * @returns {number} The calculated offset in pixels.
 */
function calculateOffset(index, container, track) {
  var containerWidth = container === null || container === void 0 ? void 0 : container.offsetWidth;
  var trackWidth = track === null || track === void 0 ? void 0 : track.offsetWidth;
  var children = Array.from(track === null || track === void 0 ? void 0 : track.children);
  var offsetChildren = children.slice(0, index);
  var offsetWidth = sumWidthOfChildren(offsetChildren);
  return setLimitsOnOffset(-offsetWidth,
  // Note: Negative as the track will always translate in the -x direction
  containerWidth, trackWidth);
}

/**
 * Helper function to calculate the new index and offset when sliding.
 *
 * @param {SliderState} state - The current state of the slider.
 * @param {Function} indexHandler - The function to calculate the new index (left or right).
 * @param {HTMLElement} container - The container element of the slider.
 * @param {HTMLElement} track - The track element that contains the slides.
 * @param {boolean} shouldFocus - A boolean to denote whether to focus the new index.
 * @returns {Object} An object containing the new index and offset.
 */
function slide(state, indexHandler, container, track) {
  var shouldFocus = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var index = indexHandler(state);
  var offset = calculateOffset(index, container, track);
  return {
    index: index,
    offset: offset,
    shouldFocus: shouldFocus
  };
}

/**
 * Snap the slider to the closest slide based on the current drag delta.
 *
 * @param {SliderState} state - The current state of the slider.
 * @param {number} delta - The amount of drag movement in pixels.
 * @param {HTMLElement} container - The container element of the slider.
 * @param {HTMLElement} track - The track element that contains the slides.
 * @returns {SliderState} The new state of the slider after snapping to the nearest slide.
 */
function snap(state, delta, container, track) {
  var offset = state.offset;
  var children = Array.from(track.children);

  // If the drag delta is less than the scroll threshold, no snapping occurs
  if (Math.abs(delta) < DEFAULT_DRAG_SNAP_THRESHOLD) return state;

  // Detect direction of scroll
  var direction = Math.sign(delta);

  // Check if the offset is at or beyond the start or end of the track and loop around
  var containerWidth = container.offsetWidth;
  var trackWidth = track.scrollWidth;
  if (direction < 0 && offset <= -trackWidth + containerWidth) {
    // If sliding right and at or beyond the last slide, loop back to the first slide
    return slide(state, function () {
      return 0;
    }, container, track, true);
  }
  if (direction > 0 && offset === 0) {
    // If sliding left and at or beyond the first slide, loop back to the last slide
    return slide(state, function () {
      return children.length - 1;
    }, container, track, true);
  }
  var visibleChildren = getVisibleChildren(container, track);
  var nextIndex;
  if (direction > 0) {
    // Right
    // Snap to the first visible child when sliding right
    var firstChildIndex = children.indexOf(visibleChildren[0]);
    nextIndex = Math.min(firstChildIndex, state.slides.length - 1);
  } else {
    // Left
    // Snap to the last visible child when sliding left including the offscreen slide to the right
    var lastChildIndex = children.indexOf(visibleChildren[visibleChildren.length - 1]);
    nextIndex = Math.max(0, lastChildIndex);
  }

  // Slide to the calculated next index
  return slide(state, function () {
    return nextIndex;
  }, container, track, true);
}

/**
 * Reducer function to manage the state of the slider track.
 *
 * @param {SliderState} state - The current state of the slider.
 * @param {Object} action - The action to be performed.
 * @returns {SliderState} The new state of the slider.
 */
function slideTrackReducer(state, action) {
  var container = action.container,
    track = action.track;
  var actionState = {};
  switch (action.type) {
    case 'containerResize':
      actionState = {
        offset: calculateOffset(state.index, container, track)
      };
      break;
    case 'setIndex':
      actionState = {
        index: action.index,
        offset: calculateOffset(action.index, container, track)
      };
      break;
    case 'slideLeft':
      actionState = _objectSpread2({}, slide(state, function (currentState) {
        return calculateLeftIndex(currentState, action.slideMagnitude);
      }, container, track, action.shouldFocus));
      break;
    case 'slideRight':
      actionState = _objectSpread2({}, slide(state, function (currentState) {
        return calculateRightIndex(currentState, action.slideMagnitude);
      }, container, track, action.shouldFocus));
      break;
    case 'slidesUpdated':
      actionState = {
        slides: action.slides
      };
      break;
    case 'snap':
      actionState = _objectSpread2({}, snap(state, action.delta, container, track));
      break;
  }
  return _objectSpread2(_objectSpread2({}, state), actionState);
}function useSlider(slides, _ref) {
  var containerRef = _ref.containerRef,
    trackRef = _ref.trackRef,
    containerWidth = _ref.containerWidth;
  var _useReducer = useReducer(slideTrackReducer, getDefaultState(slides)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isScrollAllowed = _useState2[0],
    setIsScrollAllowed = _useState2[1];

  // Set whether horizontal scrolling is enabled
  useEffect(function () {
    var childrenWidth = sumWidthOfChildren(_toConsumableArray(trackRef.current.children));
    setIsScrollAllowed(childrenWidth > containerWidth);
  }, [containerWidth, trackRef]);

  // Focus the active slide
  useEffect(function () {
    var _trackRef$current;
    var index = state.index,
      shouldFocus = state.shouldFocus;
    var children = (_trackRef$current = trackRef.current) === null || _trackRef$current === void 0 ? void 0 : _trackRef$current.children;
    if (!shouldFocus) return;

    // Prevent immediate focus until the next event cycle
    setTimeout(function () {
      children[index].focus({
        preventScroll: true
      });
    }, 0);
  }, [state, trackRef]);
  useEffect(function () {
    dispatch({
      type: 'slidesUpdated',
      slides: slides
    });
  }, [slides]);

  // Recalculate containerSize
  useEffect(function () {
    dispatch({
      container: containerRef.current,
      track: trackRef.current,
      type: 'containerResize'
    });
  }, [containerRef, trackRef, containerWidth]);
  var handleOnSlideLeft = function handleOnSlideLeft() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$shouldFocus = _ref2.shouldFocus,
      shouldFocus = _ref2$shouldFocus === void 0 ? false : _ref2$shouldFocus,
      _ref2$slideMagnitude = _ref2.slideMagnitude,
      slideMagnitude = _ref2$slideMagnitude === void 0 ? 1 : _ref2$slideMagnitude;
    return dispatch({
      type: 'slideLeft',
      container: containerRef.current,
      slideMagnitude: slideMagnitude,
      shouldFocus: shouldFocus,
      slides: slides,
      track: trackRef.current
    });
  };
  var handleOnSlideRight = function handleOnSlideRight() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$shouldFocus = _ref3.shouldFocus,
      shouldFocus = _ref3$shouldFocus === void 0 ? false : _ref3$shouldFocus,
      _ref3$slideMagnitude = _ref3.slideMagnitude,
      slideMagnitude = _ref3$slideMagnitude === void 0 ? 1 : _ref3$slideMagnitude;
    return dispatch({
      type: 'slideRight',
      container: containerRef.current,
      slideMagnitude: slideMagnitude,
      shouldFocus: shouldFocus,
      slides: slides,
      track: trackRef.current
    });
  };
  var handleOnSlideSelect = function handleOnSlideSelect(index) {
    return dispatch({
      type: 'setIndex',
      container: containerRef.current,
      index: index,
      track: trackRef.current
    });
  };
  var handleOnSlideSnap = function handleOnSlideSnap(delta) {
    return dispatch({
      type: 'snap',
      delta: delta,
      container: containerRef.current,
      track: trackRef.current
    });
  };
  return {
    state: state,
    isScrollAllowed: isScrollAllowed,
    containerWidth: containerWidth,
    containerRef: containerRef,
    trackRef: trackRef,
    handleOnSlideLeft: handleOnSlideLeft,
    handleOnSlideRight: handleOnSlideRight,
    handleOnSlideSelect: handleOnSlideSelect,
    handleOnSlideSnap: handleOnSlideSnap
  };
}/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target;
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function read(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init(converter, defaultAttributes) {
  function set(name, value, attributes) {
    if (typeof document === 'undefined') {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += '; ' + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }
    return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
  }
  function get(name) {
    if (typeof document === 'undefined' || arguments.length && !name) {
      return;
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');
      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);
        if (name === found) {
          break;
        }
      } catch (e) {}
    }
    return name ? jar[name] : jar;
  }
  return Object.create({
    set: set,
    get: get,
    remove: function remove(name, attributes) {
      set(name, '', assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function withAttributes(attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function withConverter(converter) {
      return init(assign({}, this.converter, converter), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(defaultAttributes)
    },
    converter: {
      value: Object.freeze(converter)
    }
  });
}
var api = init(defaultConverter, {
  path: '/'
});var COOKIE_NAME = 'OptanonConsent';
var ENCODED_CONSENT_IDENTIFIERS = Object.freeze({
  STRICTLY_NECESSARY_COOKIES: {
    ENABLED: 'C0001%3A1',
    DISABLED: 'C0001%3A0'
  },
  PERFORMANCE_COOKIES: {
    ENABLED: 'C0002%3A1',
    DISABLED: 'C0002%3A0'
  },
  FUNCTIONAL_COOKIES: {
    ENABLED: 'C0003%3A1',
    DISABLED: 'C0003%3A0'
  },
  // TARGETING_COOKIES is the only one that changes between ENABLED/DISABLED base on user consent
  TARGETING_COOKIES: {
    ENABLED: 'C0004%3A1',
    DISABLED: 'C0004%3A0'
  },
  PERSONAL_INFO_SHARE_COOKIES: {
    ENABLED: 'SSPD_BG%3A1',
    DISABLED: 'SSPD_BG%3A0'
  }
});
var CONSENT_IDENTIFIERS = Object.freeze({
  STRICTLY_NECESSARY_COOKIES: 'C0001',
  PERFORMANCE_COOKIES: 'C0002',
  FUNCTIONAL_COOKIES: 'C0003',
  // TARGETING_COOKIES is the only one that will be present/absent base on user consent
  TARGETING_COOKIES: 'C0004',
  PERSONAL_INFO_SHARE_COOKIES: 'SSPD_BG'
});

/**
 * @name getUserTrackingConsent
 * @description Check for the consent groups and returns a Boolean based on the
 * findings
 *
 * With the CRO implementation, Cookie consent groups are set after checking the
 * user consent profile in Cloud
 *
 * Intermittently there is some latency in fetching the groups, to resolve that
 * we are doing max attempts.
 * @return {Boolean} - Returns a Boolean value
 */
var getUserTrackingConsent = function getUserTrackingConsent() {
  var optCookie = api.get(COOKIE_NAME);
  var consentValues = encodeURIComponent(optCookie);
  return consentValues.includes(ENCODED_CONSENT_IDENTIFIERS.TARGETING_COOKIES.ENABLED);
};

/**
 * @name useUserConsent
 * @description Function that returns the state of user consent as a boolean. It goes through
 * a series of steps to determine this
 *
 * - First, it checks if the One Trust OptAnon cookie is present.
 *    If not present, returns false.
 *    If present, continues to the next/second step.
 *
 * - Second, it checks the One Trust data layer in the browser for Active Groups. The value is
 * set by the One Trust script. We look here before looking into the cookie itself due to a
 * weird race condition.
 *    If not present, continues to the next/third step.
 *    If present, it returns user selection as saved in the functional cookie
 *
 * - Third, it checks the state of consent in the OptAnon cookie set by One Trust.
 *
 * @return {Function<Boolean>} - Returns a Boolean value
 */
function useUserConsent() {
  var getUserConsent = function getUserConsent() {
    var _window;
    var optCookie = api.get(COOKIE_NAME);
    if (!optCookie) return false;
    var consentActiveGroups = (_window = window) === null || _window === void 0 ? void 0 : _window.OptanonActiveGroups;
    var activeGroups = consentActiveGroups === null || consentActiveGroups === void 0 ? void 0 : consentActiveGroups.split(',');
    if (activeGroups !== null && activeGroups !== void 0 && activeGroups.length) {
      return activeGroups === null || activeGroups === void 0 ? void 0 : activeGroups.some(function (value) {
        return value.includes(CONSENT_IDENTIFIERS.TARGETING_COOKIES);
      });
    }
    return getUserTrackingConsent();
  };
  return {
    getUserConsent: getUserConsent
  };
}

/**
 * @name useConsentFromDatabridge
 * @description Hook to subscribe to consent changes in databridge and return the status of
 * the consent. It handles both single and multiple consent identifiers, providing either a boolean
 * or an object of consent statuses to the callback function.
 * @param {string|string[]} consentIdentifiers - Single or array of identifiers (strings) to track
 * @param {function} callback - The callback to call when the consent changes; it receives a boolean
 * or an object of consent statuses.
 * e.g.
 * useConsentFromDatabridge(CONSENT_IDENTIFIERS.TARGETING_COOKIES, callback) -> callback(true)
 *
 * or
 *
 * useConsentFromDatabridge(
 * [CONSENT_IDENTIFIERS.TARGETING_COOKIES,
 * CONSENT_IDENTIFIERS.PERFORMANCE_COOKIES], callback) -> callback({
 *  [CONSENT_IDENTIFIERS.TARGETING_COOKIES]: false,
 *  [CONSENT_IDENTIFIERS.PERFORMANCE_COOKIES]: true
 * })
 */
var useConsentFromDatabridge = function useConsentFromDatabridge(consentIdentifiers, callback) {
  var memoizedIdentifiers = useMemo(function () {
    return Array.isArray(consentIdentifiers) ? consentIdentifiers : [consentIdentifiers];
  }, [consentIdentifiers]);
  var memoizedCallback = useCallback(callback, [callback]);
  var subscriptionHandler = useCallback(function (consent) {
    var newStatus = memoizedIdentifiers.reduce(function (acc, identifier) {
      var _consent$detail;
      acc[identifier] = consent === null || consent === void 0 || (_consent$detail = consent.detail) === null || _consent$detail === void 0 ? void 0 : _consent$detail.includes(identifier);
      return acc;
    }, {});
    if (memoizedCallback) {
      var result = Array.isArray(consentIdentifiers) ? newStatus : newStatus[consentIdentifiers];
      memoizedCallback(result);
    }
  }, [memoizedIdentifiers, consentIdentifiers, memoizedCallback]);
  useEffect(function () {
    var _window2;
    (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.digitalData) === null || _window2 === void 0 || _window2.subscribe('consent', subscriptionHandler);
  }, [subscriptionHandler]);
};var LOUDCROWD_SCRIPT_SRC = 'https://pub.loudcrowd.com/embed.js';
var LC_CONFIG = {
  // Analytics config
  pdpTrackingParams: {
    prodvm: 'affiliate storefront',
    pagefm: 'affiliate storefront',
    pagevm: 'page load'
  }
};

/**
 * This hook loads a 3rd party script from LoudCrowd to the `head` of the document
 * This hook is disabled by default with the intention of enabling the hook via a feature flag
 * The LoudCrowd script populates affiliate storefronts and
 *   adds admin tools for LoudCrowd-authenticated affiliates
 *
 * LoudCrowd documentation:
 *   https://intercom.help/loudcrowd-developer-docs/en/articles/9703471-install-the-loudcrowd-sdk-on-your-ecommerce-site
 */
function useLoudCrowdScript(_ref) {
  var _ref$enable = _ref.enable,
    enable = _ref$enable === void 0 ? false : _ref$enable,
    _ref$shopId = _ref.shopId,
    shopId = _ref$shopId === void 0 ? '' : _ref$shopId;
  useEffect(function () {
    // Hook will be disabled by default
    // `shopId` is required
    if (enable !== true || !shopId) {
      // Need to return an explicit value here (eslint consistent-return)
      return undefined;
    }

    // Initialize LoudCrowd
    var initLoudCrowd = function initLoudCrowd() {
      var _window$loudcrowd;
      (_window$loudcrowd = window.loudcrowd) === null || _window$loudcrowd === void 0 || _window$loudcrowd.init(shopId, LC_CONFIG);
    };

    // Handle waiting for `window.loudcrowd` if not immediately available
    var waitForLoudCrowdAndInit = function waitForLoudCrowdAndInit() {
      if (window.loudcrowd) {
        initLoudCrowd();
      } else {
        document.addEventListener('loudcrowd-global-loaded', initLoudCrowd);
      }
    };

    // Check if the script already exists in the DOM
    // Note: Choosing not to re-initialize the script if it already exists
    var existingScript = document.querySelector("script[src=\"".concat(LOUDCROWD_SCRIPT_SRC, "\"]"));

    // The LoudCrowd script reference to be set up below
    var script;
    if (!existingScript) {
      // Set up script element
      script = document.createElement('script');
      script.src = LOUDCROWD_SCRIPT_SRC;
      script.type = 'module';
      script.async = true;
      script.onload = waitForLoudCrowdAndInit;

      // Append script to DOM `head`
      document.head.appendChild(script);
    }

    // Cleanup function
    return function () {
      if (script) {
        document.head.removeChild(script);
      }
      document.removeEventListener('loudcrowd-global-loaded', initLoudCrowd);
    };
  }, [enable, shopId]);
}/*
  Analytics methods from crs/StaticWeb/WebContent/src/util/algonomy/helpers.es6

  Includes:
    - getPersonalizationTestValues
    - collectOnLoadAnalyticsData
    - collectOnClickAnalyticsData
*/

/**
 * @name getPersonalizationTestValues
 * @public
 * @description Function that does the following
 *    1. If mvtDetailed is empty returns "null"
 *    2. Gets mvtDetailed and formats it into this = testId:control:treatmentId:treatmentName
 *    3. Returns mvtDetailed with the expected format, or "null" if no values
 *
 * @param {Array} mvtDetailed - An array of objects with test cases data.
 *
 * @return {String} - Returns algonomy values in the following format,
 * testId:control:treatmentId:treatmentName or "null" if no values'.
 */
var getPersonalizationTestValues = function getPersonalizationTestValues(mvtDetailed) {
  if (!(mvtDetailed !== null && mvtDetailed !== void 0 && mvtDetailed.length)) return 'null';
  var personalizationTestValues = mvtDetailed.filter(function (item) {
    return item.eligible;
  }).map(function (item) {
    return "".concat(item.testId, ":").concat(item.control, ":").concat(item.treatmentId, ":").concat(item.treatmentName);
  }).join(',');
  return personalizationTestValues || 'null';
};

/**
 * @name collectOnLoadAnalyticsData
 * @public
 * @description Function receives the instrumentation call response object,
 * packages on load analytics data and returns it.
 *
 * @param {Object} data - The data returned from the recommendations query
 * @returns {Object} - returns the onLoad analytics object.
 */
var collectOnLoadAnalyticsData = function collectOnLoadAnalyticsData(data) {
  var mvtDetailed = data.mvtDetailed,
    rcs = data.rcs,
    userId = data.userId;

  // Note: expecting rcs and userId to be null when consent isn't given by the BFF
  return {
    rcs: rcs || '',
    mvtDetailed: mvtDetailed,
    userId: userId || '',
    personalizationTest: getPersonalizationTestValues(mvtDetailed)
  };
};

/**
 * @name collectOnClickAnalyticsData
 * @public
 * @description Function receives the user click event object on product card,
 * packages analytics data and returns it.
 *
 * @param {Object} placement - the focused placement contain the clicked product
 * @param {Object} productIndex - the index of the product within the placements array
 *
 * @return {Object} - Returns the onClick analytics data object
 */
var collectOnClickAnalyticsData = function collectOnClickAnalyticsData(placement, productIndex) {
  var _window;
  var id = placement.id,
    name = placement.name,
    treatments = placement.treatments;
  var onLoadData = ((_window = window) === null || _window === void 0 || (_window = _window.digitalData) === null || _window === void 0 ? void 0 : _window.get('algonomy.onLoad', {})) || {};
  var processedTreatments = treatments.reduce(function (acc, item) {
    acc.push(_objectSpread2(_objectSpread2({}, item), {}, {
      control: item.control === null ? '' : item.control,
      testId: item.testId === null ? '' : item.testId
    }));
    return acc;
  }, []);
  return _objectSpread2(_objectSpread2({}, onLoadData), {}, {
    placement: id,
    position: productIndex,
    strategyName: name,
    mvtTreatments: processedTreatments
  });
};

/**
 * @name runAnalyticsOnLoad
 * @public
 * @description Function to initiate the analytics data bridge events
 *
 * @param {Object} data - The analytics data to pass with the data bridge events
 */
var runAnalyticsOnLoad = function runAnalyticsOnLoad(data) {
  var _window2;
  if (!((_window2 = window) !== null && _window2 !== void 0 && _window2.digitalData)) return;

  // Handle legacy analytics events/data
  window.digitalData.set('algonomy.onLoad', data);
  window.digitalData.trigger('analytics.recs_loaded', data);
};

/**
 * @name runAnalyticsOnClick
 * @public
 * @description Function to initiate the analytics onClick data bridge events
 *
 * @param {Object} data - The analytics data to pass with the data bridge events
 */
var runAnalyticsOnClick = function runAnalyticsOnClick(data) {
  var _window3;
  if (!((_window3 = window) !== null && _window3 !== void 0 && _window3.digitalData)) return;
  window.digitalData.set('algonomy.onClick', data);
};

/**
 * Triggers a universal scroll analytics event using the `digitalData` object if it exists.
 * This event sends scroll-related data to the analytics service.
 *
 * @param {string} placement - A string representing where the user has scrolled to on the page.
 *                             This will be included in the analytics event payload.
 *
 * @returns {void} - This function does not return any value.
 */
var runAnalyticsUniversalScrollEvent = function runAnalyticsUniversalScrollEvent(placement) {
  var _window4;
  if (!((_window4 = window) !== null && _window4 !== void 0 && _window4.digitalData)) return;
  window.digitalData.trigger('universal_scroll', {
    Tealium_event: 'scroll',
    data_text: 'user scrolled to',
    data_action: placement
  });
};

/**
 * @name getProdvmFromDatabridge
 * @public
 * @description  Retrieves the product view model (prodvm) from the Databridge.
 *
 * This function listens for the 'algonomy.onClick' event on the `window.digitalData` object.
 * When the event is triggered, it constructs a prodvm string using the strategy name and test ID
 * from the event data.
 *
 * @returns {string} The constructed prodvm string or an empty string if
 *                    `window.digitalData` is not available.
 */
var getProdvmFromDatabridge = function getProdvmFromDatabridge() {
  var _window5;
  if (!((_window5 = window) !== null && _window5 !== void 0 && _window5.digitalData)) return '';
  var prodvm = '';
  window.digitalData.subscribe('algonomy.onClick', function (data) {
    var strategyName = data.strategyName;
    var testId = data.mvtTreatments[0].testId;
    prodvm = "recommendations-".concat(strategyName, "-").concat(testId);
  });
  return prodvm;
};

/**
 * @name handleQuickViewClickAnalytics
 * @public
 * @description Handles the analytics for Quick View clicks.
 *
 * This function subscribes to the appropriate digital data event based on whether the click
 * is a swatch click or not. It then sets the product view method and triggers an analytics event.
 * @param {boolean} [isSwatchClick] - Indicates if the click is a swatch click
 */
var handleQuickViewClickAnalytics = function handleQuickViewClickAnalytics() {
  var _window6;
  var isSwatchClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (!((_window6 = window) !== null && _window6 !== void 0 && _window6.digitalData)) return;
  var prodvm = getProdvmFromDatabridge();
  if (isSwatchClick) {
    window.digitalData.set('product.dataText', 'recommendations-swatch');
    window.digitalData.set('product.dataAction', 'click');
  }
  window.digitalData.set('product.productViewMethod', prodvm);
  window.digitalData.trigger(new CustomEvent('analytics.quickview'));
};

/**
 * @name handlePDPAnalytics
 * @public
 * @description Handles PDP analytics by appending query parameters to the given URL.
 *
 * @param {string} pdpUrl - The URL of the Product Detail Page.
 * @param {string} dataText - The text data to be appended as a query parameter.
 * @returns {string} - The modified URL with appended query parameters.
 */
var handlePDPAnalytics = function handlePDPAnalytics(pdpUrl) {
  var _window7;
  var isSwatchClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!((_window7 = window) !== null && _window7 !== void 0 && _window7.digitalData)) return pdpUrl;
  var url = new URL(window.location.origin + pdpUrl);
  var queryParams = new URLSearchParams(url.search);
  var prodvm = getProdvmFromDatabridge();
  queryParams.append('prodvm', prodvm);
  if (isSwatchClick) {
    queryParams.append('dataText', 'recommendations-swatch');
    queryParams.append('dataAction', 'click');
  }
  url.search = queryParams.toString();
  return url.toString();
};var recForPlacementsCallback = function recForPlacementsCallback(response) {
  var rrAnnotations = (response === null || response === void 0 ? void 0 : response.rrAnnotations) || (response === null || response === void 0 ? void 0 : response.rr_annotations);
  var script;

  // Check if rr_annotations object was returned in the response
  /* eslint-disable */
  if (rrAnnotations) {
    // If we have rr_annotations_array push rr_annotations object there,
    // otherwise create it with rr_annotations inside
    if (window.rr_annotations_array) {
      window.rr_annotations_array.push(rrAnnotations);
    } else {
      window.rr_annotations_array = [rrAnnotations];
    }

    // Check if Experience Browser was already loaded on the page
    // (it creates rr_experience_browser global variable)
    if (window.rr_experience_browser) {
      rr_experience_browser.start();
    } else {
      // If Experience Browser is missing, load it from RichRelevance cdn,
      // it will start automatically and parse rr_annotations
      script = document.createElement('script');
      script.src = '//cdn.richrelevance.com/dashboard/applications/cfrad/dist/index.min.js';
      script.async = true;
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  } else {
    console.log('recsForPlacementsCallback: rr_annotations is missing');
  }
  /* eslint-enable */
};/**
 * @name getTopLevelBrand
 * @private
 * @description Function that returns the top level brand based on the current page pageInfo.brand.
 *
 * @return {String} - Returns a string.
 */
var getTopLevelBrand = function getTopLevelBrand() {
  var brand = window.digitalData.get('page.brand', '');
  return brand === 'anf' || brand === 'kids' ? 'ANF' : 'HCO';
};

/**
 * @name getCfradKey
 * @private
 * @description Function that returns the CFRAD key from cfradKey config map in this file.
 * @param {String} brand - The current top level brand (ANF || HCO) the user is interacting with.
 *
 * @return {String} - Returns a string.
 */
var getCfradKey = function getCfradKey(brand) {
  var cfradKeyMap = {
    ANF: 'HK2N4DlWcFrHfYhD',
    HCO: 'BoqlsaInquDu3Kna'
  };
  return cfradKeyMap[brand];
};

/**
 * @name shouldCallExperienceBrowser
 * @private
 * @description Function that determines whether the Experience Browser vendor code
 * should be called or not.
 *
 * In order to make the determination, the function looks at two conditions.
 * First, it checks if the LD flag is enabled or not.
 *
 * Second, it compares the cfrad appended to the URL and the cfrad of current brand
 * as defined by Algonomy.
 *
 * The Experience Browser vendor code is called ONLY if the LD flag is enabled AND
 * if the cfrad appended to the URL
 * matches the Algonomy defined cfrad of the current brand the user is interacting with.
 *
 * If any of the above conditions are not met, then the Experience Browser vendor code
 * will not be called.
 *
 * @returns {Boolean} - Returns true/false for whether Experience Browser vendor code
 * should be invoked.
 */
var shouldCallExperienceBrowser = function shouldCallExperienceBrowser() {
  var _window;
  if (!((_window = window) !== null && _window !== void 0 && _window.digitalData)) return false;
  var cfradAppendedToUrl = new URL(window.location.href).searchParams.get('cfrad');
  var currentBrandCfrad = getCfradKey(getTopLevelBrand());
  var isCorrectCfrad = cfradAppendedToUrl === currentBrandCfrad;
  var isExperienceBrowserIntegrationEnabled = window.digitalData.get('flag.has-algonomy-experience-browser-enabled', false);
  return isCorrectCfrad && isExperienceBrowserIntegrationEnabled;
};

/**
 * @name startExperienceBrowser
 * @public
 * @description Function that starts the Algonomy Experience Browser with the rr_annotations.
 *
 * @param {Object} data - Data returned from Algonomy. Expected to contain
 * rr_annotations or rrAnnotations object
 */
var startExperienceBrowser = function startExperienceBrowser(data) {
  var callExperienceBrowser = shouldCallExperienceBrowser();
  if (callExperienceBrowser) recForPlacementsCallback(data);
};var ANALYTICS_ACCOUNT_PATH = 'analytics.global.account';

/**
 * Safely merges data into window.digitalData
 * @param {Object} data - The data to merge
 */
var mergeAnalyticsData = function mergeAnalyticsData(data) {
  var _window;
  /* istanbul ignore next */
  if (!data) return;
  (_window = window) === null || _window === void 0 || (_window = _window.digitalData) === null || _window === void 0 || _window.merge(ANALYTICS_ACCOUNT_PATH, data);
};

/**
 * Checks if algonomy data exists in digitalData
 * @returns {boolean} - Whether algonomy data exists
 */
var hasAlgonomyData = function hasAlgonomyData(path) {
  var _window2, _window2$export;
  var data = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.digitalData) === null || _window2 === void 0 || (_window2$export = _window2["export"]) === null || _window2$export === void 0 ? void 0 : _window2$export.call(_window2);
  return Boolean(path && data && data[path]);
};
var setAlgonomyData = function setAlgonomyData(path, value) {
  if (!hasAlgonomyData(path)) {
    var _window3, _window3$set;
    (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.digitalData) === null || _window3 === void 0 || (_window3$set = _window3.set) === null || _window3$set === void 0 || _window3$set.call(_window3, path, value);
  }
};

/**
 * Sets user authentication data in analytics based on user state
 * Handles both authenticated and guest user scenarios
 */
var analytics = {
  /**
     * Algonomy analytics methods
     * Handles tracking of personalization tests, recommendations, and product interactions
   */
  algonomy: {
    /**
       * Sets personalization test data - strings together algonomy page load variables
       * Format: <testId>:<control>:<treatmentId>:<treatmentName>
     */
    setPersonalizationTest: function setPersonalizationTest(testId, control, treatmentId, treatmentName) {
      var personalizationTest = 'null';
      if (testId && control && treatmentId && treatmentName) {
        personalizationTest = "".concat(testId, ":").concat(control, ":").concat(treatmentId, ":").concat(treatmentName);
      }
      mergeAnalyticsData({
        personalization_test: personalizationTest
      });

      // Fallback to set personalization_test
      setAlgonomyData('algonomy.onLoad.personalizationTest', personalizationTest);
    },
    setRcsId: function setRcsId() {
      var rcsId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var finalRcsId = rcsId || 'null';
      mergeAnalyticsData({
        rcs_id: finalRcsId
      });

      // Fallback to set rcsId
      setAlgonomyData('algonomy.onLoad.rcs', finalRcsId);
    },
    /**
       * Sets recommendations data for clicked recommendations
       * Format: recommendations-<strategyName>-<treatmentID>
       * @param {string} strategyName - The strategy name
       * @param {string} treatmentId - The treatment ID
    */
    setRecommendations: function setRecommendations(strategyName, treatmentId) {
      var recommendations = 'null';
      if (strategyName && treatmentId) {
        recommendations = "recommendations-".concat(strategyName, "-").concat(treatmentId);
      }
      mergeAnalyticsData({
        recommendations: recommendations
      });
    },
    /**
       * Sets product recommendation placement for clicked products
       * @param {string} placement - The placement identifier
     */
    setProductRecommendationPlacement: function setProductRecommendationPlacement(placement) {
      var finalPlacement = placement || 'null';
      mergeAnalyticsData({
        product_recommendation_placement: finalPlacement
      });
      // Fallback to set product_recommendation_placement
      setAlgonomyData('algonomy.onClick.placement', finalPlacement);
    },
    /**
       * Sets product recommendation position for clicked products
       * @param {number|string} position - The position/slot number
     */
    setProductRecommendationPosition: function setProductRecommendationPosition(position) {
      var finalPosition = position !== undefined && position !== null ? String(position) : 'null';
      mergeAnalyticsData({
        product_recommendation_position: finalPosition
      });
      // Fallback to set product_recommendation_position
      setAlgonomyData('algonomy.onClick.position', finalPosition);
    }
  }
};var parseProductResponse = function parseProductResponse(products) {
  return products === null || products === void 0 ? void 0 : products.map(function (product) {
    return _objectSpread2(_objectSpread2({}, JSON.parse(product === null || product === void 0 ? void 0 : product.response)), {}, {
      clickTrackingUrl: product === null || product === void 0 ? void 0 : product.clickTrackingUrl,
      categoryRec: product === null || product === void 0 ? void 0 : product.categoryRec
    });
  });
};
var setAlgonomyDebugData = function setAlgonomyDebugData(algonomyDebug) {
  if (!algonomyDebug) return null;
  var parsedDebugData = null;
  try {
    parsedDebugData = JSON.parse(algonomyDebug);
  } catch (_unused) {/* Do nothing */}
  if (!parsedDebugData) return null;
  var _parsedDebugData = parsedDebugData,
    _parsedDebugData$algo = _parsedDebugData.algonomyQueryParams,
    _parsedDebugData$algo2 = _parsedDebugData$algo === void 0 ? {} : _parsedDebugData$algo,
    _parsedDebugData$algo3 = _parsedDebugData$algo2.placements,
    debugPlacement = _parsedDebugData$algo3 === void 0 ? '' : _parsedDebugData$algo3;
  var debugId = debugPlacement.split('|')[0];
  if (debugId) {
    window.digitalData.set("algonomy.debug.".concat(debugId), parsedDebugData);
  }
  return parsedDebugData;
};
var processPlacement = function processPlacement(placement) {
  var id = placement.id,
    name = placement.name,
    title = placement.title,
    products = placement.products,
    treatments = placement.treatments;
  try {
    var productResponse = parseProductResponse(products);
    window.digitalData.set("algonomy.placements.".concat(id), {
      id: id,
      // placement
      name: name,
      title: title,
      products: productResponse,
      treatments: treatments
    });
  } catch (_unused2) {/* do nothing */}
};
var loadProductDataIntoDataBridge = function loadProductDataIntoDataBridge(data) {
  var _window;
  if (!data || !((_window = window) !== null && _window !== void 0 && _window.digitalData)) {
    return;
  }
  var placements = data.placements,
    algonomyDebug = data.algonomyDebug;
  setAlgonomyDebugData(algonomyDebug);
  placements === null || placements === void 0 || placements.forEach(function (placement) {
    processPlacement(placement);
  });
};

/**
 * @name onRecommendationsCompleted
 * @public
 * @description Handler for the kicking off post algonomy query functionality (analytics)
 *
 * @param {Object} ctx - The recommendation context value
 * @param {Object} data - The data returned from the recommendations query
 */
var onRecommendationsQueryCompleted = function onRecommendationsQueryCompleted(data, ctx) {
  var recommendations = data.recommendations;
  var analyticsOnLoadData = collectOnLoadAnalyticsData(recommendations);
  loadProductDataIntoDataBridge(recommendations);
  runAnalyticsOnLoad(analyticsOnLoadData);
  try {
    var rrAnnotations = recommendations.rrAnnotations;
    startExperienceBrowser({
      rr_annotations: JSON.parse(rrAnnotations)
    });
  } catch (err) {
    /* eslint-disable-next-line no-console */
    console.warn('@xp-utilities/web recommendations helpers', 'onRecommendationsQueryCompleted() - rrAnnotations could not be parsed', err);
  }
};

/**
 * @name onRecommendedProductClick
 * @public
 * @description Handler for the kicking off onClick algonomy events for analytics
 *
 * @param {Object} placement - associated placement with click
 * @param {Object} args - the arguments passed to the onProductClick => (event, product, index)
 */
var onRecommendedProductClick = function onRecommendedProductClick(placement) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var index = args[2];
  var analyticsData = collectOnClickAnalyticsData(placement, index);
  runAnalyticsOnClick(analyticsData);
};
var onRecommendedProductSwatchClick = function onRecommendedProductSwatchClick(placement) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  // Args are event, swatch, and product coming from RecommendedProductSwatch.jsx
  var _args$ = args[2],
    currentProduct = _args$ === void 0 ? {} : _args$;
  var _currentProduct$kic = currentProduct.kic,
    kic = _currentProduct$kic === void 0 ? '' : _currentProduct$kic;
  var _placement$products = placement.products,
    products = _placement$products === void 0 ? [] : _placement$products;
  var swatchProductIndex = products.findIndex(function (product) {
    return product.kic === kic;
  });
  var analyticsData = collectOnClickAnalyticsData(placement, swatchProductIndex);
  runAnalyticsOnClick(analyticsData);
};

// RecommendationsSliders passes args in the following order - event, swatchDetails, productDetails
var onSwatchClickHandler = function onSwatchClickHandler(_, swatchDetails) {
  var productUrl = swatchDetails.productUrl;
  var productUrlWithAnalytics = handlePDPAnalytics(productUrl, true);
  window.location.href = productUrlWithAnalytics;
};

/**
 * @name handlePDPAnalyticsGlobal
 * @public
 * @description Handles global analytics data
 * collection for PDP (Product Detail Page) recommendations.
 * Extracts analytics data from recommendations response and sets various analytics properties
 * including RCS ID, placement, position,
 * recommendations data, and personalization test information.
 *
 * @param {Object} recommendationsData - The complete recommendations data object
 * @param {Object} placement - The placement object containing placement details and treatments
 * @param {Array} args - Additional arguments passed from the click handler (event, product, index)
 */
var handlePDPAnalyticsGlobal = function handlePDPAnalyticsGlobal(recommendationsData, placement) {
  var _recommendationsData$;
  for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    args[_key3 - 2] = arguments[_key3];
  }
  var index = args[2];
  var treatment = placement === null || placement === void 0 ? void 0 : placement.treatments[index];
  analytics.algonomy.setRcsId(recommendationsData === null || recommendationsData === void 0 || (_recommendationsData$ = recommendationsData.recommendations) === null || _recommendationsData$ === void 0 ? void 0 : _recommendationsData$.rcs);
  analytics.algonomy.setProductRecommendationPlacement(placement === null || placement === void 0 ? void 0 : placement.id);
  analytics.algonomy.setProductRecommendationPosition(index);
  analytics.algonomy.setRecommendations(placement === null || placement === void 0 ? void 0 : placement.name, treatment === null || treatment === void 0 ? void 0 : treatment.testId);
  analytics.algonomy.setPersonalizationTest(treatment === null || treatment === void 0 ? void 0 : treatment.testId, treatment === null || treatment === void 0 ? void 0 : treatment.control, treatment === null || treatment === void 0 ? void 0 : treatment.treatmentId, treatment === null || treatment === void 0 ? void 0 : treatment.treatmentName);
};var generateRecommendationsCallEventName = function generateRecommendationsCallEventName(id) {
  return "recommendations-".concat(id);
};
function useRecommendationsCall(_ref) {
  var query = _ref.query,
    _ref$queryOptions = _ref.queryOptions,
    queryOptions = _ref$queryOptions === void 0 ? {} : _ref$queryOptions,
    _ref$placements = _ref.placements,
    placements = _ref$placements === void 0 ? [] : _ref$placements,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled;
  var recommendationsContext = useContext(RecommendationsContext);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    hasUserConsent = _useState2[0],
    setHasUserConsent = _useState2[1];
  var _recommendationsConte = recommendationsContext.id,
    id = _recommendationsConte === void 0 ? placements.join('|') : _recommendationsConte,
    _recommendationsConte2 = recommendationsContext.isEventDriven,
    isEventDriven = _recommendationsConte2 === void 0 ? false : _recommendationsConte2,
    _recommendationsConte3 = recommendationsContext.variables,
    recommendationVariables = _recommendationsConte3 === void 0 ? {} : _recommendationsConte3;
  var onCompleted = queryOptions.onCompleted,
    _queryOptions$variabl = queryOptions.variables,
    variables = _queryOptions$variabl === void 0 ? {} : _queryOptions$variabl;
  var memoizedOnCompleted = useCallback(function (data) {
    onRecommendationsQueryCompleted(data);
    if (onCompleted) onCompleted(data);
  }, [onCompleted]);
  var queryParameters = useMemo(function () {
    return _objectSpread2(_objectSpread2({
      context: {
        batch: true
      },
      fetchPolicy: 'network-only'
    }, queryOptions), {}, {
      variables: _objectSpread2(_objectSpread2(_objectSpread2({
        placements: placements
      }, recommendationVariables), variables), {}, {
        hasUserConsent: hasUserConsent
      }),
      onCompleted: memoizedOnCompleted
    });
  }, [queryOptions, placements, recommendationVariables, variables, hasUserConsent, memoizedOnCompleted]);
  var _useLazyQuery = useLazyQuery(query, queryParameters),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    fetch = _useLazyQuery2[0],
    result = _useLazyQuery2[1];
  var recsEventCallback = useCallback(function (args) {
    var _args$data;
    fetch({
      variables: (_args$data = args === null || args === void 0 ? void 0 : args.data) !== null && _args$data !== void 0 ? _args$data : {}
    });
  }, [fetch]);
  useConsentFromDatabridge(CONSENT_IDENTIFIERS.TARGETING_COOKIES, function (consent) {
    setHasUserConsent(consent);
  });
  useEffect(function () {
    var _window;
    if (!enabled) return;
    if (typeof hasUserConsent !== 'boolean') return;
    // This is for split testing using the x seg cookie values.
    // It is controlled by the LD flag recommendation-swatches-x-seg-value
    // The XSeg key is pageKind specific
    // The LD flag can be updated to dynamically add new tests without requiring a code push
    var xSegKey = (_window = window) === null || _window === void 0 || (_window = _window.digitalData) === null || _window === void 0 ? void 0 : _window.get('flag.recommendation-swatches-x-seg-value');
    var opts = {
      variables: {
        xSegKey: xSegKey
      }
    };
    if (!isEventDriven) fetch(opts);else {
      var _window2;
      (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.digitalData) === null || _window2 === void 0 || _window2.subscribe("event:".concat(generateRecommendationsCallEventName(id)), recsEventCallback);
    }
  }, [fetch, id, isEventDriven, hasUserConsent, enabled, recsEventCallback]);
  return [fetch, result];
}var propTypes$8 = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired
};
var ADDTOBAG_EVENT_NAME = 'addToBag:perso-instrumentation';
function AddToBagRecommendationsContextProvider(_ref) {
  var id = _ref.id,
    children = _ref.children;
  var _useUserConsent = useUserConsent(),
    getUserConsent = _useUserConsent.getUserConsent;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    products = _useState2[0],
    setProducts = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    cartItems = _useState4[0],
    setCartItems = _useState4[1];
  var ctx = useMemo(function () {
    return {
      id: id,
      isEventDriven: true,
      variables: {
        hasUserConsent: getUserConsent(),
        products: products || [],
        cartItems: cartItems || []
      }
    };
  }, [id, products, cartItems, getUserConsent]);
  useEffect(function () {
    var _window;
    var handleAddToBag = function handleAddToBag(e) {
      var kicId = e.detail.kicId;
      var productAdded = {
        kic: kicId
      };
      setProducts(productAdded);
      setCartItems(kicId);
    };
    (_window = window) === null || _window === void 0 || _window.addEventListener(ADDTOBAG_EVENT_NAME, handleAddToBag);
    return function () {
      window.removeEventListener(ADDTOBAG_EVENT_NAME, handleAddToBag);
    };
  }, []);
  useEffect(function () {
    var _window2;
    if (!products && !cartItems) return;
    (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.digitalData) === null || _window2 === void 0 || _window2.trigger(generateRecommendationsCallEventName(id));
  }, [cartItems, id, products]);
  return /*#__PURE__*/React.createElement(RecommendationsContext.Provider, {
    value: ctx
  }, children);
}
AddToBagRecommendationsContextProvider.propTypes = propTypes$8;var propTypes$7 = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired
};
function CategoryRecommendationsContextProvider(_ref) {
  var id = _ref.id,
    children = _ref.children;
  var _useUserConsent = useUserConsent(),
    getUserConsent = _useUserConsent.getUserConsent;
  var categoryData = useDatabridgeSubscribe('category');
  var ctx = useMemo(function () {
    var _categoryData$product;
    return {
      id: id,
      isEventDriven: true,
      variables: {
        categoryId: (categoryData === null || categoryData === void 0 ? void 0 : categoryData.categoryId) || null,
        hasUserConsent: getUserConsent(),
        products: (categoryData === null || categoryData === void 0 || (_categoryData$product = categoryData.products) === null || _categoryData$product === void 0 ? void 0 : _categoryData$product.map(function (product) {
          return {
            kic: product.kic
          };
        })) || []
      }
    };
  }, [id, getUserConsent, categoryData]);
  useEffect(function () {
    var _window;
    if (!(categoryData !== null && categoryData !== void 0 && categoryData.categoryId) || !(categoryData !== null && categoryData !== void 0 && categoryData.products)) return;
    (_window = window) === null || _window === void 0 || (_window = _window.digitalData) === null || _window === void 0 || _window.trigger(generateRecommendationsCallEventName(id));
  }, [categoryData, id]);
  return /*#__PURE__*/React.createElement(RecommendationsContext.Provider, {
    value: ctx
  }, children);
}
CategoryRecommendationsContextProvider.propTypes = propTypes$7;var propTypes$6 = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  hideSwatches: PropTypes.bool
};
var defaultProps$2 = {
  id: '',
  hideSwatches: false
};
function GenericRecommendationsContextProvider(_ref) {
  var id = _ref.id,
    hideSwatches = _ref.hideSwatches,
    children = _ref.children;
  var ctx = useMemo(function () {
    return {
      id: id,
      variables: {
        hideSwatches: hideSwatches
      }
    };
  }, [id, hideSwatches]);
  useEffect(function () {
    var _window;
    (_window = window) === null || _window === void 0 || (_window = _window.digitalData) === null || _window === void 0 || _window.trigger(generateRecommendationsCallEventName(id));
  }, [id]);
  return /*#__PURE__*/React.createElement(RecommendationsContext.Provider, {
    value: ctx
  }, children);
}
GenericRecommendationsContextProvider.propTypes = propTypes$6;
GenericRecommendationsContextProvider.defaultProps = defaultProps$2;var propTypes$5 = {
  children: PropTypes.node.isRequired,
  hideSwatches: PropTypes.bool
};
var defaultProps$1 = {
  hideSwatches: false
};
function MyListRecommendationsContextProvider(_ref) {
  var hideSwatches = _ref.hideSwatches,
    children = _ref.children;
  var _useMyListItems = useMyListItems(),
    getMyListKICArray = _useMyListItems.getMyListKICArray;
  var ctx = useMemo(function () {
    return {
      variables: {
        products: getMyListKICArray(),
        hideSwatches: hideSwatches
      }
    };
  }, [getMyListKICArray, hideSwatches]);
  return /*#__PURE__*/React.createElement(RecommendationsContext.Provider, {
    value: ctx
  }, children);
}
MyListRecommendationsContextProvider.propTypes = propTypes$5;
MyListRecommendationsContextProvider.defaultProps = defaultProps$1;var propTypes$4 = {
  children: PropTypes.node.isRequired
};
function NullSearchRecommendationsContextProvider(_ref) {
  var children = _ref.children;
  var _useSearchTerm = useSearchTerm(),
    getSearchTerm = _useSearchTerm.getSearchTerm;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var ctx = useMemo(function () {
    return {
      variables: {
        searchTerm: searchTerm
      }
    };
  }, [searchTerm]);
  useEffect(function () {
    setSearchTerm(getSearchTerm());
  }, [getSearchTerm]);
  return /*#__PURE__*/React.createElement(RecommendationsContext.Provider, {
    value: ctx
  }, children);
}
NullSearchRecommendationsContextProvider.propTypes = propTypes$4;var propTypes$3 = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  hideSwatches: PropTypes.bool
};
var defaultProps = {
  hideSwatches: false
};
function PDPRecommendationsContextProvider(_ref) {
  var id = _ref.id,
    hideSwatches = _ref.hideSwatches,
    children = _ref.children;
  var _ref2 = useDatabridgeSubscribe('pdp.collectionData') || {},
    activeProduct = _ref2.activeProduct,
    breadcrumbsUrls = _ref2.breadcrumbsUrls;
  var ctx = useMemo(function () {
    return {
      id: id,
      isEventDriven: true,
      variables: {
        hideSwatches: hideSwatches,
        products: !activeProduct ? [] : [{
          kic: activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.kicId
        }],
        categories: (breadcrumbsUrls === null || breadcrumbsUrls === void 0 ? void 0 : breadcrumbsUrls.map(function (_ref3) {
          var categoryId = _ref3.categoryId;
          return categoryId;
        })) || []
      }
    };
  }, [id, activeProduct, breadcrumbsUrls, hideSwatches]);
  useEffect(function () {
    var _window;
    if (!activeProduct && !breadcrumbsUrls) return;
    (_window = window) === null || _window === void 0 || (_window = _window.digitalData) === null || _window === void 0 || _window.trigger(generateRecommendationsCallEventName(id));
  }, [id, activeProduct, breadcrumbsUrls]);
  return /*#__PURE__*/React.createElement(RecommendationsContext.Provider, {
    value: ctx
  }, children);
}
PDPRecommendationsContextProvider.propTypes = propTypes$3;
PDPRecommendationsContextProvider.defaultProps = defaultProps;var propTypes$2 = {
  children: PropTypes.node.isRequired
};
function PickedForYouRecommendationsContextProvider(_ref) {
  var children = _ref.children;
  var _useCategoryId = useCategoryId(),
    getCategoryId = _useCategoryId.getCategoryId;
  var ctx = useMemo(function () {
    return {
      variables: {
        categories: getCategoryId()
      }
    };
  }, [getCategoryId]);
  return /*#__PURE__*/React.createElement(RecommendationsContext.Provider, {
    value: ctx
  }, children);
}
PickedForYouRecommendationsContextProvider.propTypes = propTypes$2;var propTypes$1 = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired
};
var QUICKVIEW_EVENT_NAME = 'quickview:recs:openModal';
function QuickviewRecommendationsContextProvider(_ref) {
  var id = _ref.id,
    children = _ref.children;
  var ctx = useMemo(function () {
    return {
      id: id,
      isEventDriven: true
    };
  }, [id]);
  useEffect(function () {
    var handleEvent = function handleEvent() {
      var _window;
      (_window = window) === null || _window === void 0 || (_window = _window.digitalData) === null || _window === void 0 || _window.trigger(generateRecommendationsCallEventName(id));
    };
    document.addEventListener(QUICKVIEW_EVENT_NAME, handleEvent);
    return function () {
      document.removeEventListener(QUICKVIEW_EVENT_NAME, handleEvent);
    };
  }, [id]);
  return /*#__PURE__*/React.createElement(RecommendationsContext.Provider, {
    value: ctx
  }, children);
}
QuickviewRecommendationsContextProvider.propTypes = propTypes$1;var propTypes = {
  children: PropTypes.node.isRequired
};
function SearchRecommendationsContextProvider(_ref) {
  var children = _ref.children;
  var _useSearchTerm = useSearchTerm(),
    getSearchTerm = _useSearchTerm.getSearchTerm;
  var ctx = useMemo(function () {
    return {
      variables: {
        searchTerm: getSearchTerm()
      }
    };
  }, [getSearchTerm]);
  return /*#__PURE__*/React.createElement(RecommendationsContext.Provider, {
    value: ctx
  }, children);
}
SearchRecommendationsContextProvider.propTypes = propTypes;var errorFragmentStr = "\n  fragment error on Error {\n    message {\n      key\n      value\n    }\n    status\n  }\n";var globalFragments=/*#__PURE__*/Object.freeze({__proto__:null,errorFragmentStr:errorFragmentStr});var mvtDetailsFragmentStr = "\n  fragment mvtDetails on MVTDetails {\n    control\n    eligible\n    testId\n    treatmentId\n    treatmentName\n  }\n";
var mvtTreatmentFragmentStr = "\n  fragment mvtTreatment on MVTTreatment {\n    control\n    testId\n    testType\n    treatmentId\n    treatmentName\n  }\n";
var recommendedProductSwatchFragmentStr = "\n  fragment recommendedProductSwatch on RecommendedProductSwatch {\n    id\n    imageUrl\n    name\n    productId\n    productImageUrl\n    productUrl\n    sequence\n  }\n";
var categoryRecFragmentStr = "\n  fragment categoryRec on CategoryRec {\n    id\n    name\n    linkUrl\n    imageUrl\n  }\n";
var recommendedProductFragmentStr = "\n  fragment recommendedProduct on RecommendedProduct {\n    brand\n    clickTrackingUrl\n    categoryRec { ...categoryRec }\n    collection # collectionId\n    discountPrice\n    faceout\n    id # productID\n    imageId\n    imageUrl\n    kic\n    memberPrice # member pricing\n    name\n    price\n    productUrl # Product URL\n    response # The product \"/list\" API response JSON string\n    swatches { ...recommendedProductSwatch }\n  }\n\n  ".concat(categoryRecFragmentStr, "\n  ").concat(recommendedProductSwatchFragmentStr, "\n");
var placementFragmentStr = "\n  fragment placement on Placement {\n    id # placement id\n    title\n    name\n    products { ...recommendedProduct }\n    treatments { ...mvtTreatment }\n  }\n\n  ".concat(mvtTreatmentFragmentStr, "\n  ").concat(recommendedProductFragmentStr, "\n");var recommendationFragments=/*#__PURE__*/Object.freeze({__proto__:null,categoryRecFragmentStr:categoryRecFragmentStr,mvtDetailsFragmentStr:mvtDetailsFragmentStr,mvtTreatmentFragmentStr:mvtTreatmentFragmentStr,placementFragmentStr:placementFragmentStr,recommendedProductFragmentStr:recommendedProductFragmentStr,recommendedProductSwatchFragmentStr:recommendedProductSwatchFragmentStr});var _templateObject$2;
var GET_MICROFRONTEND_CLIENT = gql(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  query GET_MICROFRONTEND_CLIENT(\n    $client: String!,\n    $mfe: MFE!,\n    $includeScript: Boolean,\n    $dataSourceKey: String,\n    $queryString: String\n  ) {\n    microfrontend(\n      client: $client,\n      mfe: $mfe,\n      dataSourceKey: $dataSourceKey,\n      includeScript: $includeScript,\n      queryString: $queryString\n    ) {\n      markup\n    }\n  }\n"])));var _templateObject$1, _templateObject2$1;

/*
  RECOMMENDATIONS_QUERY

  Will be used for the slider and is catered towards
  displaying UI that follows the agreed upon schema.

  Tech Design schema proposal: https://anfcorp.atlassian.net/wiki/spaces/eComm/pages/403538044/Customer+MFE+BFF+Algonomy+Migration#Schema
*/
var RECOMMENDATIONS_QUERY = gql(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  query RECOMMENDATIONS_QUERY(\n    $cartItems: [String],\n    $categories: [String],\n    $categoryData: Boolean,\n    $categoryId: String,\n    $excludeItemAttributes: Boolean,\n    $hasUserConsent: Boolean!,\n    $hideSwatches: Boolean,\n    $orderId: String,\n    $placements: [String]!,\n    $products: [RecommendationProductDetails],\n    $searchTerm: String,\n    $xSegKey: String,\n  ) {\n    recommendations(\n      cartItems: $cartItems,\n      categories: $categories,\n      categoryData: $categoryData,\n      categoryId: $categoryId,\n      excludeItemAttributes: $excludeItemAttributes\n      hasUserConsent: $hasUserConsent,\n      hideSwatches: $hideSwatches,\n      orderId: $orderId,\n      placements: $placements,\n      products: $products,\n      searchTerm: $searchTerm\n      xSegKey: $xSegKey\n    ) {\n      userId\n      errors { ...error }\n      mvtDetailed { ...mvtDetails }\n      placements { ...placement }\n      rcs\n      rrAnnotations\n      success\n      algonomyDebug\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"])), errorFragmentStr, mvtDetailsFragmentStr, placementFragmentStr);

/*
  RECOMMENDATIONS_DATA_QUERY

  Will be used to supply the digital data object. The "response" value
  will be a JSON string that can be parsed and then stored within
  the dataBridge using the placement name and product data.
*/
var RECOMMENDATIONS_DATA_QUERY = gql(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  query RECOMMENDATIONS_DATA_QUERY(\n    $cartItems: [String],\n    $categories: [String],\n    $categoryData: Boolean,\n    $categoryId: String,\n    $excludeItemAttributes: Boolean,\n    $hasUserConsent: Boolean!,\n    $hideSwatches: Boolean,\n    $orderId: String,\n    $placements: [String]!,\n    $products: [RecommendationProductDetails],\n    $searchTerm: String\n    $xSegKey: String\n  ) {\n    recommendations(\n      cartItems: $cartItems,\n      categories: $categories,\n      categoryData: $categoryData,\n      categoryId: $categoryId,\n      excludeItemAttributes: $excludeItemAttributes,\n      hasUserConsent: $hasUserConsent,\n      hideSwatches: $hideSwatches,\n      orderId: $orderId,\n      placements: $placements,\n      products: $products,\n      searchTerm: $searchTerm\n      xSegKey: $xSegKey\n    ) {\n      userId\n      errors { ...error }\n      mvtDetailed { ...mvtDetails }\n      placements {\n        id\n        title\n        name\n        products { \n          clickTrackingUrl\n          categoryRec { ...categoryRec }\n          response\n          swatches { ...recommendedProductSwatch }\n        }\n        treatments { ...mvtTreatment }\n      }\n      rcs\n      rrAnnotations\n      success\n      algonomyDebug\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), categoryRecFragmentStr, errorFragmentStr, mvtDetailsFragmentStr, mvtTreatmentFragmentStr, recommendedProductSwatchFragmentStr);var fragments = {
  global: _objectSpread2({}, globalFragments),
  recommendations: _objectSpread2({}, recommendationFragments)
};function getFrontendId(packageName, frontend, id) {
  if (!id) return "".concat(packageName, "-").concat(frontend);
  return "".concat(packageName, "-").concat(frontend, "-").concat(id);
}function getCacheId(name, frontend, id) {
  return "".concat(getFrontendId(name, frontend, id), "-config");
}function getXSegCookieKeyValue(key) {
  // If a key is not provided, return an empty string
  if (!key) return '';
  var xSegCookie = api.get('xSeg');
  if (xSegCookie) {
    var params = new URLSearchParams(xSegCookie);
    // If the key doesn't have a value, return an empty string
    return params.get(key) || '';
  }

  // If the xSeg cookie doesn't exist, return an empty string
  return '';
}var contentConfigProp = {
  clientId: PropTypes.string
};
var contentPropTypes = {
  config: PropTypes.shape(contentConfigProp).isRequired,
  content: PropTypes.string.isRequired,
  frontend: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};/**
 * Content component that renders a content section and a corresponding script.
 * The content is injected directly into the DOM using `dangerouslySetInnerHTML`,
 * and a script is added with the Apollo cache state.
 *
 * @param {Object} props - The props object containing required properties.
 * @param {Object} props.config - Configuration object, usually contains apollo cache contents.
 * @param {Object} props.config.clientId - clientId meant to differentiate instances from
 * one another
 * @param {string} props.content - HTML content to be inserted into the DOM.
 * @param {string} props.frontend - Frontend identifier to associate with the content.
 * @param {string} props.name - Name of the component (usually PACKAGE.name).
 *
 * @returns {JSX.Element} The rendered content and script elements.
 */
function Content(_ref) {
  var config = _ref.config,
    content = _ref.content,
    frontend = _ref.frontend,
    name = _ref.name;
  /*
    Extract clientId from the config object
    - `clientId` is used by the customer team to employ instancing (multiple clients per page)
      in their widely used clients (recommendations)
  */
  var clientId = config.clientId;

  // Generate a unique cache ID based on component attributes
  var cacheId = getCacheId(name, frontend, clientId);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: getFrontendId(name, frontend, clientId),
    className: name
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: content
    }
  }), /*#__PURE__*/React.createElement("script", {
    type: "text/javascript"
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: "window['APOLLO_STATE__".concat(cacheId, "'] = ").concat(JSON.stringify(config).replace(/</g, "\\u003c"))
    }
  }));
}

// Define the propTypes for the Content component using the contentPropTypes object
Content.propTypes = contentPropTypes;/**
 * Formats and filters recommendation data by processing nested objects containing product
 * recommendations. The data for this comes from digitalData.export().algonomy.placements.
 * The function filters out invalid placements and transforms product data by
 * removing __typename fields.
 *
 * @param {Object} data - The raw recommendation data object containing nested page types and
 * placements
 *
 * @returns {Array<Object>} Array of formatted placement objects containing filtered products
 *
 * @example
 * // Input data
 * const data = {
 *   generic_page: {
 *     account_flyout1: {
 *       name: 'Top Products',
 *       products: [
 *         {
 *           ...
 *           categoryRec: {
 *             id: '123',
 *             name: 'Product 1',
 *             price: 19.99,
 *             __typename: 'Product'
 *           }
 *          ...
 *         }
 *       ]
 *     }
 *   }
 * };
 *
 * // Output
 * [
 *   {
 *     name: 'Top Products',
 *     products: [
 *        // products are an array of objects containing product categoryRec
 *       {
 *         id: '123',
 *         name: 'Product 1',
 *         price: 19.99
 *       }
 *     ]
 *    ...
 *   }
 * ]
 */
function formatData(data) {
  return Object.values(data).filter(function (pageType) {
    return pageType && _typeof(pageType) === 'object';
  }).flatMap(function (pageType) {
    return Object.values(pageType).filter(function (placement) {
      var _placement$products;
      return (placement === null || placement === void 0 || (_placement$products = placement.products) === null || _placement$products === void 0 ? void 0 : _placement$products.length) > 0 && placement.products.every(function (product) {
        return product.categoryRec;
      });
    }).map(function (placement) {
      return _objectSpread2(_objectSpread2({}, placement), {}, {
        products: placement.products.map(function (_ref) {
          var categoryRec = _ref.categoryRec;
          return Object.entries(categoryRec || {}).filter(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 1),
              key = _ref3[0];
            return key !== '__typename';
          }).reduce(function (acc, _ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
              key = _ref5[0],
              value = _ref5[1];
            acc[key] = value;
            return acc;
          }, {});
        })
      });
    });
  });
}

/**
 * Custom hook for fetching and managing category recommendations.
 * The hook will fetch the data from the databridge.
 *
 * If a page does not have recommendations call then recommendations can be fetched
 * When the fetchRecommendations is true, a recommendations call is made using
 * useRecommendationsCall hook. This hook will load the relevant data in databridge and
 * the hook will fetch the data from the databridge.
 *
 *
 * @param {Boolean} fetchRecommendations - Fetch recs if algononmy call is not present on page
 * @param {Array<string>} [placements=[]] - Array of placements to fetch recommendations;
 * required when fetchRecommendations is true
 * @param {Object} [query=RECOMMENDATIONS_QUERY] - Query to use when fetchRecommendations is true;
 * @param {Object} [queryOptions={}] - Additional options to pass to the useRecommendationsCall hook
 * only used when fetchRecommendations is true
 *
 * @returns {Object} Object containing recommendation data and loading state
 *
 * @example
 * If a page does not have algonomy call, we can make a call
 * by passing true for fetchRecommendations
 *
 * const { data, loading } = useCategoryRecommendationsCall(
 *   true,
 *   ['home_page.app_rr1', 'home_page.app_category_rr1'],
 *   RECOMMENDATIONS_QUERY,
 *   { fetchPolicy: 'network-only' }
 * );
 *
 * @example
 * If algonomy call is already present on the page; grab the data from databridge
 *
 * const { data, loading } = useCategoryRecommendationsCall();
 */
function useCategoryRecommendationsCall() {
  var fetchRecommendations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var placements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var query = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : RECOMMENDATIONS_QUERY;
  var queryOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    windowData = _useState2[0],
    setWindowData = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    windowLoading = _useState4[0],
    setWindowLoading = _useState4[1];
  var timeoutRef = useRef();
  var dataReceivedRef = useRef(false);

  // Fetch recommendations if fetchRecommendations is true
  useRecommendationsCall({
    placements: placements,
    query: query,
    queryOptions: queryOptions,
    enabled: fetchRecommendations
  });
  var handleRecLoaded = useCallback(function (data) {
    if (!data) return;
    // dataReceivedRef is intialized here to handle race condition with window resize
    dataReceivedRef.current = true;
    setWindowData(formatData(data));
    setWindowLoading(false);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);
  useEffect(function () {
    var _window;
    var digitalData = (_window = window) === null || _window === void 0 ? void 0 : _window.digitalData;
    if (!digitalData) {
      setWindowLoading(false);
      return function () {};
    }
    digitalData.subscribe('algonomy.placements', handleRecLoaded);

    // Only set timeout if we haven't received data yet
    if (!dataReceivedRef.current) {
      timeoutRef.current = setTimeout(function () {
        setWindowData(null);
        setWindowLoading(false);
      }, 4000);
    }
    return function () {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      dataReceivedRef.current = false;
    };
  }, [handleRecLoaded]);
  return useMemo(function () {
    return {
      data: windowData,
      loading: windowLoading
    };
  }, [windowData, windowLoading]);
}var u = (function (e) {
  var a = useRef(e);
  return useEffect(function () {
    a.current = e;
  }), a;
});var o$1 = function o(n, _o, c) {
    function i() {
      l.current && clearTimeout(l.current), l.current = void 0;
    }
    function a() {
      l.current = void 0;
    }
    void 0 === _o && (_o = 100), void 0 === c && (c = 0);
    var v = u(n),
      l = useRef(),
      m = [_o, c, v];
    return useEffect(function () {
      return i;
    }, m), useCallback(function () {
      var r = arguments,
        t = l.current;
      if (void 0 === t && c) return l.current = setTimeout(a, _o), v.current.apply(null, r);
      t && clearTimeout(t), l.current = setTimeout(function () {
        l.current = void 0, v.current.apply(null, r);
      }, _o);
    }, m);
  },
  c = function c(r, t, e) {
    var u = useState(r);
    return [u[0], o$1(u[1], t, e)];
  };function i (t, n, a, u) {
  var c = useRef(a),
    i = useRef(u);
  useEffect(function () {
    c.current = a, i.current = u;
  }), useEffect(function () {
    function r() {
      if (!a) {
        for (var r = arguments.length, e = new Array(r), t = 0; r > t; t++) e[t] = arguments[t];
        c.current.apply(this, e);
      }
    }
    var e = t && "current" in t ? t.current : t;
    if (e) {
      var a = 0;
      e.addEventListener(n, r);
      var u = i.current;
      return function () {
        a = 1, e.removeEventListener(n, r), u && u();
      };
    }
  }, [t, n]);
}var t = {},
  n = "undefined" == typeof window ? null : window,
  o = n && void 0 !== n.visualViewport ? n.visualViewport : null,
  d = function d() {
    return [document.documentElement.clientWidth, document.documentElement.clientHeight];
  },
  r = function r(_r2) {
    void 0 === _r2 && (_r2 = t);
    var _r = _r2,
      u = _r.wait,
      l = _r.leading,
      _r$initialWidth = _r.initialWidth,
      a = _r$initialWidth === void 0 ? 0 : _r$initialWidth,
      _r$initialHeight = _r.initialHeight,
      c$1 = _r$initialHeight === void 0 ? 0 : _r$initialHeight,
      _e = c("undefined" == typeof document ? [a, c$1] : d, u, l),
      _e2 = _slicedToArray(_e, 2),
      m = _e2[0],
      f = _e2[1],
      h = function h() {
        return f(d);
      };
    return i(n, "resize", h), i(o, "resize", h), i(n, "orientationchange", h), m;
  },
  l = function l(e) {
    return r(e)[0];
  };function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}var classnames = {exports: {}};(function (module) {
  /* global define */

  (function () {

    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = '';
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === 'string' || typeof arg === 'number') {
        return arg;
      }
      if (_typeof(arg) !== 'object') {
        return '';
      }
      if (Array.isArray(arg)) {
        return classNames.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
        return arg.toString();
      }
      var classes = '';
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + ' ' + newClass;
      }
      return value + newClass;
    }
    if (module.exports) {
      classNames["default"] = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var classnamesExports = classnames.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);var productItemShape = {
  id: PropTypes.string,
  name: PropTypes.string,
  linkUrl: PropTypes.string,
  imageUrl: PropTypes.string
};
var BubbleRecItemPropTypes = {
  product: PropTypes.shape(productItemShape).isRequired
};
var BubbleRecContainerPropTypes = {
  analyticsQueryParams: PropTypes.object,
  className: PropTypes.string,
  name: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.shape(productItemShape)),
  title: PropTypes.string,
  titleWrapper: PropTypes.element,
  treatments: PropTypes.arrayOf(PropTypes.object)
};
var BubbleRecommendationsPropTypes = {
  analyticsQueryParams: PropTypes.object,
  brand: PropTypes.oneOf(['anf', 'kids', 'hol']),
  className: PropTypes.string,
  fetchRecommendations: PropTypes.bool,
  placementKey: PropTypes.string.isRequired,
  placements: PropTypes.arrayOf(PropTypes.string),
  query: PropTypes.object,
  queryOptions: PropTypes.object,
  source: PropTypes.string,
  titleWrapper: PropTypes.element
};
var LoadingBubbleRecommendationsPropTypes = {
  isLoading: PropTypes.bool.isRequired
};function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}var css_248z$7 = "/* stylelint-disable-line scss/dollar-variable-pattern */\n/** This clear-unit function helps removing the Unit of Any Element.\n* Cases To Use: For Example:\n* Constant Declaration: const $element-height: 40px;\n* Usage 1 Get Untiless Output:\n  line-height: clear-unit($element-height) / body('font-size');\n* Usage 2 Same Constant Get Unit Output:\n  height: $element-height;\n* Saves declaring 2 variables or Constants & makes multi usage\n* This is used inside rem function\n* Please don't alter without consulting project team members\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Progress Steps Funtion\n* Note for Development Team:\n* Progress Steps Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n.bubble-recommendations-module__cbr-container--rT3xA {\n  position: relative;\n}\n.bubble-recommendations-module__cbr-container--rT3xA[data-is-mobile=true] {\n  margin-bottom: 0px;\n  margin-left: 20px;\n  margin-top: 20px;\n}\n.bubble-recommendations-module__cbr-container__title--tlPhh {\n  margin-bottom: 20px;\n  text-align: center;\n}\n@media screen and (min-width: 825px) {\n  .bubble-recommendations-module__cbr-container__title--tlPhh {\n    text-align: left;\n  }\n}\n.bubble-recommendations-module__cbr-container__scroll--JGhgI {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 20px;\n  overflow-x: auto;\n  scrollbar-width: none; /* Hide horizontal scrollbar in Firefox */\n  scroll-snap-type: x mandatory;\n  -ms-overflow-style: none; /* Hide horizontal scrollbar in IE and Edge */\n  -webkit-overflow-scrolling: touch;\n  cursor: grab;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n.bubble-recommendations-module__cbr-container__scroll--JGhgI::-webkit-scrollbar {\n  display: none; /* Hide horizontal scrollbar in Webkit browsers (Chrome, Safari, Opera, etc.) */\n}\n.bubble-recommendations-module__cbr-container--rT3xA .bubble-recommendations-module__dragging--Wb2Ff {\n  cursor: grabbing;\n}\n.bubble-recommendations-module__cbr-container--rT3xA .bubble-recommendations-module__dragging--Wb2Ff > * {\n  pointer-events: none;\n}\n\n.bubble-recommendations-module__cbr-item--su9oz {\n  flex: 0 1 100px;\n}\n.bubble-recommendations-module__cbr-item__link-wrapper--ftVYA {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n}\n.bubble-recommendations-module__cbr-item__image--RY-c6 {\n  border-radius: 50%;\n  height: 100px;\n  overflow: hidden;\n  width: 100px;\n}\n.bubble-recommendations-module__cbr-item__image--RY-c6 img {\n  display: block;\n  height: 100%;\n  object-fit: contain;\n  width: 100%;\n}\n.bubble-recommendations-module__anf--XEG1N .bubble-recommendations-module__cbr-item__image--RY-c6 img {\n  background-color: #EBE9EC;\n}\n.bubble-recommendations-module__kids--k-J0d .bubble-recommendations-module__cbr-item__image--RY-c6 img {\n  background-color: #EBE9EC;\n}\n.bubble-recommendations-module__hol--NWPIB .bubble-recommendations-module__cbr-item__image--RY-c6 img {\n  background-color: #EFEFED;\n}\n.bubble-recommendations-module__cbr-item__name--Ui-D3 {\n  margin-top: 10px;\n  text-align: center;\n  text-decoration: none;\n}\n.bubble-recommendations-module__cbr-item--su9oz a {\n  text-decoration: none;\n}\n\n.bubble-recommendations-module__cbr-loading__title-section--q5Exg {\n  height: 30px;\n  margin-bottom: 20px;\n  width: 100%;\n}\n@media screen and (min-width: 825px) {\n  .bubble-recommendations-module__cbr-loading__title-section--q5Exg {\n    width: 40%;\n  }\n}\n.bubble-recommendations-module__cbr-loading__bubble-section--1qQgv {\n  height: 130px;\n  width: 100%;\n}\n.bubble-recommendations-module__cbr-loading--pScOy[data-loading=true] .bubble-recommendations-module__cbr-loading__title-section--q5Exg,\n.bubble-recommendations-module__cbr-loading--pScOy[data-loading=true] .bubble-recommendations-module__cbr-loading__bubble-section--1qQgv {\n  animation: bubble-recommendations-module__pulse-loading--1UC1A 1s infinite ease-out;\n  transition: background-color 200ms ease-in-out;\n}\n@keyframes bubble-recommendations-module__pulse-loading--1UC1A {\n  0% {\n    background-color: #fefefe;\n  }\n  50% {\n    background-color: #f6f6f6;\n  }\n  100% {\n    background-color: #fefefe;\n  }\n}";
var styles$4 = {"cbr-container":"bubble-recommendations-module__cbr-container--rT3xA","cbr-container__title":"bubble-recommendations-module__cbr-container__title--tlPhh","cbr-container__scroll":"bubble-recommendations-module__cbr-container__scroll--JGhgI","dragging":"bubble-recommendations-module__dragging--Wb2Ff","cbr-item":"bubble-recommendations-module__cbr-item--su9oz","cbr-item__link-wrapper":"bubble-recommendations-module__cbr-item__link-wrapper--ftVYA","cbr-item__image":"bubble-recommendations-module__cbr-item__image--RY-c6","anf":"bubble-recommendations-module__anf--XEG1N","kids":"bubble-recommendations-module__kids--k-J0d","hol":"bubble-recommendations-module__hol--NWPIB","cbr-item__name":"bubble-recommendations-module__cbr-item__name--Ui-D3","cbr-loading__title-section":"bubble-recommendations-module__cbr-loading__title-section--q5Exg","cbr-loading__bubble-section":"bubble-recommendations-module__cbr-loading__bubble-section--1qQgv","cbr-loading":"bubble-recommendations-module__cbr-loading--pScOy","pulse-loading":"bubble-recommendations-module__pulse-loading--1UC1A"};
styleInject(css_248z$7);/**
 * BubbleRecItem Component
 *
 * Renders a clickable product bubble with an image and name.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} [props.brand='anf'] - The brand identifier for styling and analytics.
 * @param {string} props.productUrl - The URL for the product detail page.
 * @param {Object} props.product - The product recommendation data object.
 * @param {string} props.product.imageUrl - The URL of the product image.
 * @param {string} props.product.name - The name of the product.
 * @param {string|number} props.product.id - The unique identifier for the product.
 * @returns {JSX.Element} The rendered BubbleRecItem component.
 *
 * @example
 * const product = {
 *   imageUrl: 'http://example.com/image.jpg',
 *   name: 'Test Product',
 *   id: '1',
 * };
 * const productUrl = 'http://example.com/product/1';
 *
 * <BubbleRecItem
 *   brand="anf"
 *   productUrl={productUrl}
 *   product={product}
 * />
 */

function BubbleRecItem(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'anf' : _ref$brand,
    productUrl = _ref.productUrl,
    product = _ref.product;
  var imageUrl = product.imageUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles$4['cbr-item'], styles$4[brand]),
    "data-testid": "cbr-item-".concat(product === null || product === void 0 ? void 0 : product.id)
  }, /*#__PURE__*/React.createElement(Link, {
    href: productUrl,
    classList: styles$4['cbr-item__link-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4['cbr-item__image']
  }, /*#__PURE__*/React.createElement("img", {
    src: imageUrl,
    alt: product === null || product === void 0 ? void 0 : product.name,
    draggable: false
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles$4['cbr-item__name'], styles$4[brand])
  }, product === null || product === void 0 ? void 0 : product.name)));
}
BubbleRecItem.propTypes = BubbleRecItemPropTypes;/**
 * @name useHorizontalScroll
 *
 * @description Custom hook that enables horizontal scrolling on an element using the mouse wheel.
 * Attaches a wheel event listener to the referenced element, converting vertical
 * mouse wheel movements to horizontal scrolling. Detects and ignores trackpad horizontal
 * scroll gestures to avoid conflicting behaviors.
 *
 * @public
 *
 * @returns {React.RefObject} A React ref object to be attached to the scrollable container element
 */

function useHorizontalScroll() {
  var elRef = useRef();
  useEffect(function () {
    var el = elRef.current;
    if (!el) return function () {};
    var onWheel = function onWheel(event) {
      var isTrackpad = Math.abs(event.deltaX) > 0;
      if (isTrackpad) return;
      event.preventDefault();
      el.scrollBy({
        left: event.deltaY,
        behavior: 'smooth'
      });
    };
    el.addEventListener('wheel', onWheel, {
      passive: false
    });

    // Clean up on unmount
    return function () {
      return el.removeEventListener('wheel', onWheel);
    };
  }, []);
  return elRef;
}/**
 * @name useGrabScroll
 *
 * @description Custom hook that enables grab-and-drag scrolling behavior on an element.
 * Attaches mouse/touch event listeners to allow users to click/touch and drag
 * to scroll the content, similar to how mobile interfaces work.
 *
 * @public
 *
 * @returns {React.RefObject} A React ref object to be attached to the scrollable container element
 */
function useGrabScroll() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  var grabScrollRef = useRef();
  useEffect(function () {
    var el = grabScrollRef.current;
    if (!el) return function () {};
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var dragged = false;
    var onMouseDown = function onMouseDown(event) {
      event.preventDefault();
      isDown = true;
      dragged = false;
      startX = event.clientX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    };
    var onMouseLeave = function onMouseLeave() {
      isDown = false;
      setIsDragging(false);
    };
    var onMouseUp = function onMouseUp() {
      isDown = false;
      setIsDragging(false);
    };
    var onMouseMove = function onMouseMove(event) {
      if (!isDown) return;
      var x = event.clientX - el.offsetLeft;
      var walk = x - startX;
      if (Math.abs(walk) > 5) {
        if (!dragged) {
          dragged = true;
          setIsDragging(true);
        }
      }
      var deltaX = scrollLeft - walk - el.scrollLeft;
      el.scrollBy({
        left: deltaX
      });
    };
    el.addEventListener('mousedown', onMouseDown);
    el.addEventListener('mouseleave', onMouseLeave);
    el.addEventListener('mouseup', onMouseUp);
    el.addEventListener('mousemove', onMouseMove);
    return function () {
      el.removeEventListener('mousedown', onMouseDown);
      el.removeEventListener('mouseleave', onMouseLeave);
      el.removeEventListener('mouseup', onMouseUp);
      el.removeEventListener('mousemove', onMouseMove);
    };
  }, []);
  return {
    grabScrollRef: grabScrollRef,
    isDragging: isDragging
  };
}/**
 * BubbleRecContainer is a React component that displays a list of category
 * recommendations in a horizontally scrollable container. It adapts its layout
 * based on the screen size (mobile or desktop).
 *
 * @component
 * @param {Object} props - The props object.
 * @param {Object} [props.analyticsQueryParams] - Additional analytics data to be merged
 *   with default analytics.
 * @param {string} [props.brand='anf'] - The brand identifier for styling and analytics.
 * @param {string} [props.className] - Optional additional class name(s) for the
 *   container.
 * @param {string} [props.name] - The name of the recommendation strategy.
 * @param {string} [props.placement] - The placement of the recommendation strategy.
 * @param {Array<{
 *   id: string,
 *   name: string,
 *   imageUrl: string,
 *   linkUrl: string
 * }>} [props.products] - Array of recommendation product objects to display.
 * @param {string} [props.title] - The title to display above the recommendations.
 * @param {React.ComponentType<{children: React.ReactNode}>} [props.titleWrapper]
 *   - Optional custom wrapper component for the title. If not provided, a default
 *   `<h2>` element is used.
 * @param {Array<{ testId: string }>} [props.treatments] - Optional array of
 *   treatment objects for analytics.
 *
 * @returns {JSX.Element|null} The rendered BubbleRecContainer component, or `null`
 *   if no recommendations are provided.
 *
 * @example
 * const products = [
 *   {
 *     id: '1',
 *     name: 'Category 1',
 *     imageUrl: 'https://example.com/image1.jpg',
 *     linkUrl: 'https://example.com/cat1'
 *   },
 *   {
 *     id: '2',
 *     name: 'Category 2',
 *     imageUrl: 'https://example.com/image2.jpg',
 *     linkUrl: 'https://example.com/cat2'
 *   },
 * ];
 *
 * const treatments = [{ testId: 'treatment1' }];
 *
 * const CustomTitleWrapper = ({ children }) => (
 *   <h2 className="custom-title">{children}</h2>
 * );
 *
 * <BubbleRecContainer
 *   analyticsQueryParams={{ custom: 'value' }}
 *   brand="anf"
 *   className="my-bubble-container"
 *   name="strategy1"
 *   placement="item_page.rr5"
 *   products={products}
 *   title="Recommended Categories"
 *   titleWrapper={CustomTitleWrapper}
 *   treatments={treatments}
 * />
 */

function BubbleRecContainer(_ref) {
  var _ref$analyticsQueryPa = _ref.analyticsQueryParams,
    analyticsQueryParams = _ref$analyticsQueryPa === void 0 ? {} : _ref$analyticsQueryPa,
    _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'anf' : _ref$brand,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$name = _ref.name,
    strategyName = _ref$name === void 0 ? '' : _ref$name,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? '' : _ref$placement,
    _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$titleWrapper = _ref.titleWrapper,
    TitleWrapper = _ref$titleWrapper === void 0 ? function (_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/React.createElement("h2", {
        className: "h1"
      }, children);
    } : _ref$titleWrapper,
    _ref$treatments = _ref.treatments,
    treatments = _ref$treatments === void 0 ? [] : _ref$treatments;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var windowWidth = l();
  var scrollRef = useHorizontalScroll();
  var _useGrabScroll = useGrabScroll(),
    grabScrollRef = _useGrabScroll.grabScrollRef,
    isDragging = _useGrabScroll.isDragging;
  var setRefs = useCallback(function (element) {
    scrollRef.current = element;
    grabScrollRef.current = element;
  }, [scrollRef, grabScrollRef]);
  useEffect(function () {
    setIsMobile(windowWidth < 700);
  }, [windowWidth]);

  // Filter valid products once for reuse
  var validProducts = useMemo(function () {
    return products.filter(function (product) {
      var _product$imageUrl, _product$linkUrl;
      return (product === null || product === void 0 || (_product$imageUrl = product.imageUrl) === null || _product$imageUrl === void 0 ? void 0 : _product$imageUrl.length) > 0 && (product === null || product === void 0 || (_product$linkUrl = product.linkUrl) === null || _product$linkUrl === void 0 ? void 0 : _product$linkUrl.length) > 0;
    });
  }, [products]);
  if (validProducts.length < 2) return null;

  // Create a title rendering function
  var renderTitle = function renderTitle() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$4['cbr-container__title'],
      "data-testid": "cbr-container__title"
    }, /*#__PURE__*/React.createElement(TitleWrapper, null, title));
  };

  // Generate analytics-enhanced product URLs
  var enhanceProductUrl = function enhanceProductUrl(product, index) {
    var _treatments$;
    var url = new URL(product.linkUrl);
    var params = new URLSearchParams(url.search);
    var placementAnalytics = placement ? {
      precPla: placement
    } : {};
    var treatmentTestId = treatments && Array.isArray(treatments) && treatments.length > 0 ? ((_treatments$ = treatments[0]) === null || _treatments$ === void 0 ? void 0 : _treatments$.testId) || '' : '';
    var analyticsData = new URLSearchParams(_objectSpread2(_objectSpread2({
      pagefm: "recommendations-".concat(strategyName || '', "-").concat(treatmentTestId),
      dataText: 'category recs',
      dataAction: 'click',
      precPos: index
    }, placementAnalytics), analyticsQueryParams)).toString();

    // Append analytics data
    params.set('ct', "".concat(params.get('ct'), "?").concat(analyticsData));
    url.search = params.toString();
    return url.toString();
  };

  // Render the collection of products, limiting to 6
  var renderProductCollection = function renderProductCollection() {
    return validProducts.slice(0, 6).map(function (product, index) {
      return /*#__PURE__*/React.createElement(BubbleRecItem, {
        brand: brand,
        key: product.id,
        productUrl: enhanceProductUrl(product, index),
        product: product
      });
    });
  };
  var customClass = className ? className.split(' ').map(function (c) {
    return "".concat(c, "-scroll");
  }).join(' ') : '';
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " ").concat(styles$4['cbr-container']),
    "data-testid": "cbr-container",
    "data-is-mobile": isMobile
  }, renderTitle(), /*#__PURE__*/React.createElement("div", {
    ref: setRefs,
    className: "".concat(customClass, " ").concat(styles$4['cbr-container__scroll'], " ").concat(isDragging ? styles$4.dragging : ''),
    "data-testid": "cbr-container__scroll"
  }, renderProductCollection()));
}
BubbleRecContainer.propTypes = BubbleRecContainerPropTypes;function LoadingBubbleRecommendations(_ref) {
  var isLoading = _ref.isLoading;
  return /*#__PURE__*/React.createElement("div", {
    className: styles$4['cbr-loading'],
    "data-loading": isLoading,
    "data-testid": "cbr-loading"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4['cbr-loading__title-section']
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$4['cbr-loading__bubble-section']
  }));
}
LoadingBubbleRecommendations.propTypes = LoadingBubbleRecommendationsPropTypes;/**
 * BubbleRecommendations component fetches and displays product recommendations as bubbles.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {Object} [props.analyticsQueryParams={}] - Optional analytics data for the container.
 * @param {string} [props.brand='anf'] - The brand identifier for styling and analytics.
 * @param {string} [props.className=''] - Optional CSS class for the container.
 * @param {Boolean} [props.fetchRecommendations=false] - fetch recommendations if algononmy call
 *   is not present on page
 * @param {string} [props.placementKey=''] - isRequired The placement key used for category
 *   recommendations, when multiple category recommendations are availble on the page.
 *   if not provided, the first category rec placement data will be used
 *   e.g. placementKey='generic_page.category_returns_rr1'
 * @param {Array<string>} [props.placements=[]] - Placement identifiers for recommendations. Only
 *   required when fetchRecommendations is true
 * @param {string|undefined} [props.query=undefined] - Optional query string for recommendations.
 * @param {Object} [props.queryOptions={}] - Additional options for the recommendations query.
 * @param {React.ElementType|undefined} [props.titleWrapper=undefined] - Optional wrapper for the
 *   title element.
 *
 * @returns {JSX.Element|null} The rendered bubble recommendations, loading indicator, or null if
 *   no data.
 *
 * @example
 * import BubbleRecommendations from './BubbleRecommendations';
 *
 * const CustomTitleWrapper = ({ children }) => (
 *   <h2 className="custom-title">{children}</h2>
 * );
 *
 * <BubbleRecommendations
 *   analyticsQueryParams={{ pagefm: 'test-page-finding-method' }}
 *   brand="anf"
 *   className="my-bubble-recs"
 *   placements={['placement1', 'placement2']}
 *   titleWrapper={CustomTitleWrapper}
 * />
 */

function BubbleRecommendations(_ref) {
  var _ref$analyticsQueryPa = _ref.analyticsQueryParams,
    analyticsQueryParams = _ref$analyticsQueryPa === void 0 ? {} : _ref$analyticsQueryPa,
    _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'anf' : _ref$brand,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$fetchRecommendat = _ref.fetchRecommendations,
    fetchRecommendations = _ref$fetchRecommendat === void 0 ? false : _ref$fetchRecommendat,
    _ref$placementKey = _ref.placementKey,
    placementKey = _ref$placementKey === void 0 ? '' : _ref$placementKey,
    _ref$placements = _ref.placements,
    placements = _ref$placements === void 0 ? [] : _ref$placements,
    _ref$query = _ref.query,
    query = _ref$query === void 0 ? undefined : _ref$query,
    _ref$queryOptions = _ref.queryOptions,
    queryOptions = _ref$queryOptions === void 0 ? {} : _ref$queryOptions,
    _ref$titleWrapper = _ref.titleWrapper,
    titleWrapper = _ref$titleWrapper === void 0 ? undefined : _ref$titleWrapper;
  var _useCategoryRecommend = useCategoryRecommendationsCall(fetchRecommendations, placements, query, queryOptions),
    data = _useCategoryRecommend.data,
    loading = _useCategoryRecommend.loading;
  if (loading) return /*#__PURE__*/React.createElement(LoadingBubbleRecommendations, {
    isLoading: loading
  });
  if (!data || data.length === 0) return null;

  // Default to the first placement if no specific placementKey is provided
  // or if the provided placementKey does not match any data
  var _ref2 = data.find(function (item) {
      return item.id === placementKey;
    }) || {},
    _ref2$id = _ref2.id,
    placement = _ref2$id === void 0 ? '' : _ref2$id,
    _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? '' : _ref2$title,
    _ref2$products = _ref2.products,
    products = _ref2$products === void 0 ? [] : _ref2$products,
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? '' : _ref2$name,
    _ref2$treatments = _ref2.treatments,
    treatments = _ref2$treatments === void 0 ? [] : _ref2$treatments;
  return /*#__PURE__*/React.createElement(BubbleRecContainer, {
    analyticsQueryParams: analyticsQueryParams,
    brand: brand,
    className: className,
    name: name,
    placement: placement,
    products: products,
    title: title,
    titleWrapper: titleWrapper,
    treatments: treatments
  });
}
BubbleRecommendations.propTypes = BubbleRecommendationsPropTypes;function Layout(_ref) {
  var children = _ref.children,
    padding = _ref.padding,
    margin = _ref.margin,
    variant = _ref.variant,
    width = _ref.width;
  var style = {
    padding: padding,
    margin: margin,
    width: width
  };

  // The purpose of this variant is to allow a visual display configured
  // from JSON that uses flex display with a space between justification
  // placing equal space between child elements
  if (variant === 'space-between') {
    style.display = 'flex';
    style.justifyContent = 'space-between';
  }
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, children);
}
Layout.propTypes = {
  children: PropTypes.node.isRequired,
  padding: PropTypes.string,
  margin: PropTypes.string,
  variant: PropTypes.string,
  width: PropTypes.string
};
Layout.defaultProps = {
  padding: null,
  margin: null,
  variant: null,
  width: null
};// This component support allowing `children` which are a string to include replacement tokens
// which can inject other components into the string.  For example, consider the string
// "Click {0} to view additional information" where {0} refers to a link component
// from the design system.  This regex finds a pattern of curly braces with a number
// inside, and captures the number as a group.
var replacementPattern = /\{(\d+)\}/;

// This pattern determines if a string is only digits
var digitPattern = /^\d+$/;
function DesignSystemRenderer(_ref) {
  var config = _ref.config;
  var handleTextReplacement = null;
  var renderContent = useCallback(function (content) {
    var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!content) return null;
    if (typeof content === 'string') {
      return handleTextReplacement(content, replacements);
    }
    return content.map(function (item) {
      var Component = item.component === 'Layout' ? Layout : DSComponents[item.component] || item.component;
      var _item$props = item.props,
        props = _item$props === void 0 ? {} : _item$props,
        _item$smartProps = item.smartProps,
        smartProps = _item$smartProps === void 0 ? [] : _item$smartProps;
      var resolvedProps = _objectSpread2({}, props);

      // Process smartProps
      if (Array.isArray(smartProps)) {
        smartProps.forEach(function (key) {
          if (props[key]) {
            var rendered = renderContent(Array.isArray(props[key]) ? props[key] : [props[key]]);
            resolvedProps[key] = Array.isArray(rendered) && rendered.length === 1 ? rendered[0] : rendered;
          }
        });
      }
      return /*#__PURE__*/React.createElement(Component, _objectSpread2({
        key: item.key
      }, resolvedProps), renderContent(item.children, item.replacements));
    });
  }, [handleTextReplacement]);
  handleTextReplacement = useCallback(function (content, replacements) {
    if (!replacements) return content;
    var parts = content.split(replacementPattern);
    return parts.filter(function (part) {
      return part.trim().length > 0;
    }).map(function (part) {
      // Determine if this `part` is entirely digits
      if (digitPattern.test(part)) {
        var idx = parseInt(part, 10);
        var replacement = replacements[idx];
        if (typeof replacement === 'string') {
          return /*#__PURE__*/React.createElement("span", {
            style: {
              marginRight: '.2rem'
            }
          }, replacement);
        }
        return renderContent([replacement]);
      }
      return /*#__PURE__*/React.createElement("span", {
        style: {
          marginRight: '.2rem'
        }
      }, part);
    });
  }, [renderContent]);
  var output = useMemo(function () {
    return renderContent(config.children);
  }, [config, renderContent]);
  return output;
}
DesignSystemRenderer.propTypes = {
  config: PropTypes.shape({}).isRequired
};var microFrontendPropTypes = {
  client: PropTypes.string.isRequired,
  mfe: PropTypes.string.isRequired,
  dataSourceKey: PropTypes.string,
  includeScript: PropTypes.bool,
  queryString: PropTypes.string
};
var microFrontendDefaultProps = {
  dataSourceKey: undefined,
  includeScript: false,
  queryString: undefined
};/**
 * MicroFrontend component fetches and renders content from another MFE client
 * It retrieves the markup from the `GET_MICROFRONTEND_CLIENT` query and
 * renders it with `dangerouslySetInnerHTML`.
 *
 * @component
 * @param {Object} props - Props object for the MicroFrontend component.
 * @param {string} props.client - The client identifier.
 * @param {string} props.mfe - The micro-frontend name.
 * @param {string} props.queryString - Query parameters to send with the mfeContent request.
 * @param {Boolean} props.includeScript - Flag to pull the scripts from mfeContent.
 * @param {Boolean} props.dataSourceKey - Key override for context if you need to target
 * a non-default mfe dataSource.
 * @returns {JSX.Element|null} A div with the markup or null if no markup is available.
 *
 * @example
 * <MicroFrontend client="client-id" mfe="micro-frontend-name" />
 */
function MicroFrontend(props) {
  var _data$microfrontend;
  var _useQuery = useQuery(GET_MICROFRONTEND_CLIENT, {
      variables: props
    }),
    data = _useQuery.data;

  // If no markup is available, return null to render nothing.
  if (!(data !== null && data !== void 0 && (_data$microfrontend = data.microfrontend) !== null && _data$microfrontend !== void 0 && _data$microfrontend.markup)) return null;
  var client = props.client,
    mfe = props.mfe;
  var markup = data.microfrontend.markup;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "".concat(mfe, "-").concat(client)
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: markup
    }
  });
}
MicroFrontend.propTypes = microFrontendPropTypes;
MicroFrontend.defaultProps = microFrontendDefaultProps;var RecommendedProductSwatchPropTypes = {
  onSwatchClick: PropTypes.func,
  onSwatchMouseOver: PropTypes.func,
  onSwatchMouseLeave: PropTypes.func,
  swatch: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    productId: PropTypes.string,
    imageUrl: PropTypes.string
  }),
  product: PropTypes.object
};
var RecommendedProductSwatchGroupPropTypes = {
  legend: PropTypes.node.isRequired,
  onSwatchClick: PropTypes.func,
  onSwatchMouseLeave: PropTypes.func,
  onSwatchMouseOver: PropTypes.func,
  swatches: PropTypes.array,
  productUrl: PropTypes.string,
  product: PropTypes.object
};
var RecommendationSlidePropTypes = {
  product: PropTypes.shape({
    imageUrl: PropTypes.string,
    price: PropTypes.string,
    memberPrice: PropTypes.string,
    name: PropTypes.string
  }),
  onSwatchClick: PropTypes.func,
  onSwatchHover: PropTypes.func
};
var RecommendationSliderPropTypes = {
  title: PropTypes.string.isRequired,
  mobileBreakpoint: PropTypes.number,
  onIsVisible: PropTypes.func,
  onProductClick: PropTypes.func,
  onSwatchClick: PropTypes.func,
  products: PropTypes.arrayOf(PropTypes.object),
  slideRenderer: PropTypes.func,
  slidesToShow: PropTypes.number,
  useGrid: PropTypes.bool
};
var RecommendationSlidersPropTypes = {
  placements: PropTypes.arrayOf(PropTypes.string).isRequired,
  onIsVisible: PropTypes.func,
  onProductClick: PropTypes.func,
  onSwatchClick: PropTypes.func,
  query: PropTypes.object,
  queryOptions: PropTypes.object,
  slideRenderer: PropTypes.func,
  slidesToShow: PropTypes.number,
  useGrid: PropTypes.bool
};
var RecommendationsPropTypes = {
  placements: PropTypes.arrayOf(PropTypes.string).isRequired,
  query: PropTypes.object,
  queryOptions: PropTypes.object
};
({
  product: PropTypes.shape({
    imageUrl: PropTypes.string,
    name: PropTypes.string
  })
});function Recommendations(_ref) {
  var _ref$placements = _ref.placements,
    placements = _ref$placements === void 0 ? [] : _ref$placements,
    _ref$query = _ref.query,
    query = _ref$query === void 0 ? RECOMMENDATIONS_DATA_QUERY : _ref$query,
    _ref$queryOptions = _ref.queryOptions,
    queryOptions = _ref$queryOptions === void 0 ? {} : _ref$queryOptions;
  useRecommendationsCall({
    placements: placements,
    query: query,
    queryOptions: queryOptions
  });
  return null;
}
Recommendations.propTypes = RecommendationsPropTypes;function RecommendedProductSwatch(_ref) {
  var _ref$onSwatchClick = _ref.onSwatchClick,
    onSwatchClick = _ref$onSwatchClick === void 0 ? undefined : _ref$onSwatchClick,
    _ref$onSwatchMouseOve = _ref.onSwatchMouseOver,
    onSwatchMouseOver = _ref$onSwatchMouseOve === void 0 ? undefined : _ref$onSwatchMouseOve,
    _ref$onSwatchMouseLea = _ref.onSwatchMouseLeave,
    onSwatchMouseLeave = _ref$onSwatchMouseLea === void 0 ? undefined : _ref$onSwatchMouseLea,
    _ref$swatch = _ref.swatch,
    swatch = _ref$swatch === void 0 ? {} : _ref$swatch,
    _ref$product = _ref.product,
    product = _ref$product === void 0 ? {} : _ref$product;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  var id = swatch.id,
    name = swatch.name,
    productId = swatch.productId,
    imageUrl = swatch.imageUrl;
  var handleOnSwatchClick = function handleOnSwatchClick(event) {
    event.stopPropagation();
    setIsChecked(!isChecked);
    if (!onSwatchClick) return;
    onSwatchClick(event, swatch, product);
  };
  var handleOnSwatchMouseOver = function handleOnSwatchMouseOver(event) {
    if (!onSwatchMouseOver) return;
    onSwatchMouseOver(event, swatch);
  };
  var handleOnSwatchMouseLeave = function handleOnSwatchMouseLeave(event) {
    if (!onSwatchMouseLeave) return;
    onSwatchMouseLeave(event);
  };
  var handleOnFocus = function handleOnFocus(event) {
    event.stopPropagation();
    var target = event.target;
    target.focus({
      preventScroll: true
    });
  };
  var emptyHandler = function emptyHandler(event) {
    return event.stopPropagation();
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "recommended-product-swatch",
    key: id,
    onClick: handleOnSwatchClick,
    onFocus: handleOnFocus,
    onKeyDown: emptyHandler,
    onMouseLeave: handleOnSwatchMouseLeave,
    onMouseOver: handleOnSwatchMouseOver,
    role: "button",
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(SwatchTile$1, {
    id: id,
    label: name,
    name: name,
    onChange: emptyHandler,
    src: imageUrl,
    type: "checkbox",
    value: productId,
    isChecked: isChecked
  }));
}
RecommendedProductSwatch.propTypes = RecommendedProductSwatchPropTypes;var css_248z$6 = ".recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 {\n  margin-bottom: 10px;\n}\n.recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 .recommended-product-swatch-group-module__full-swatch-list-toggle--skhtw {\n  align-self: center;\n}\n.recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 a.recommended-product-swatch-group-module__full-swatch-list-toggle--skhtw {\n  display: none;\n}\n@media screen and (max-width: 540px) {\n  .recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 span.recommended-product-swatch-group-module__full-swatch-list-toggle--skhtw {\n    display: none;\n  }\n  .recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 a.recommended-product-swatch-group-module__full-swatch-list-toggle--skhtw {\n    display: initial;\n  }\n}\n.recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 .swatch-tile-group[data-size=small] {\n  padding-top: 0;\n}\n.recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 .swatch-tile-group[data-size=small] legend {\n  display: none;\n}\n.recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 .swatch-tile-group[data-size=small] .swtg-input-outer-wrapper {\n  display: grid;\n  grid-auto-flow: row;\n  grid-gap: 0;\n  grid-template-columns: repeat(auto-fill, 31px);\n  margin: -3px;\n}\n.recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 .swatch-tile-group[data-size=small] .swtg-input-inner-wrapper {\n  height: 31px;\n  width: 31px;\n}\n.recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 .swatch-tile-group[data-size=small] .swtg-input-tile-wrapper {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 .swatch-tile-group[data-size=small] .swtg-label {\n  display: none;\n}\n@media screen and (max-width: 360px) {\n  .recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 .swatch-tile-group[data-size=small] .swtg-input-outer-wrapper {\n    grid-template-columns: repeat(auto-fill, 26px);\n    margin: 0px;\n  }\n  .recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9 .swatch-tile-group[data-size=small] .swtg-input-inner-wrapper {\n    height: 26px;\n    width: 26px;\n  }\n}";
var styles$3 = {"recommended-product-swatch-group":"recommended-product-swatch-group-module__recommended-product-swatch-group--jzsa9","full-swatch-list-toggle":"recommended-product-swatch-group-module__full-swatch-list-toggle--skhtw"};
styleInject(css_248z$6);function RecommendedProductSwatchGroup(_ref) {
  var legend = _ref.legend,
    _ref$onSwatchClick = _ref.onSwatchClick,
    onSwatchClick = _ref$onSwatchClick === void 0 ? undefined : _ref$onSwatchClick,
    _ref$onSwatchMouseLea = _ref.onSwatchMouseLeave,
    onSwatchMouseLeave = _ref$onSwatchMouseLea === void 0 ? undefined : _ref$onSwatchMouseLea,
    _ref$onSwatchMouseOve = _ref.onSwatchMouseOver,
    onSwatchMouseOver = _ref$onSwatchMouseOve === void 0 ? undefined : _ref$onSwatchMouseOve,
    _ref$swatches = _ref.swatches,
    swatches = _ref$swatches === void 0 ? [] : _ref$swatches,
    _ref$productUrl = _ref.productUrl,
    productUrl = _ref$productUrl === void 0 ? undefined : _ref$productUrl,
    _ref$product = _ref.product,
    product = _ref$product === void 0 ? {} : _ref$product;
  var windowWidth = l();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShowingFullSwatchList = _useState2[0],
    setIsShowingFullSwatchList = _useState2[1];
  var handleOnMouseEnter = function handleOnMouseEnter() {
    if (windowWidth < 540) return;
    setIsShowingFullSwatchList(true);
  };
  var handleOnMouseLeave = function handleOnMouseLeave() {
    if (windowWidth < 540) return;
    setIsShowingFullSwatchList(false);
  };
  if (!(swatches !== null && swatches !== void 0 && swatches.length)) return null;
  var renderSwatch = function renderSwatch(swatch) {
    return /*#__PURE__*/React.createElement(RecommendedProductSwatch, {
      onSwatchClick: onSwatchClick,
      onSwatchMouseOver: onSwatchMouseOver,
      onSwatchMouseLeave: onSwatchMouseLeave,
      swatch: swatch,
      key: swatch.id,
      product: product
    });
  };
  var renderedSwatchList = !isShowingFullSwatchList ? _toConsumableArray(swatches.slice(0, DEFAULT_SWATCHES_TO_SHOW)) : swatches;
  var moreString = "+".concat(swatches.length - DEFAULT_SWATCHES_TO_SHOW);
  return /*#__PURE__*/React.createElement("div", {
    className: styles$3['recommended-product-swatch-group'],
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave
  }, /*#__PURE__*/React.createElement(SwatchTileGroup$1, {
    size: "small",
    legend: legend
  }, renderedSwatchList.map(renderSwatch), !isShowingFullSwatchList && swatches.length > DEFAULT_SWATCHES_TO_SHOW ? /*#__PURE__*/React.createElement("span", {
    className: styles$3['full-swatch-list-toggle']
  }, moreString) : null, swatches.length > DEFAULT_SWATCHES_TO_SHOW ? /*#__PURE__*/React.createElement("a", {
    className: styles$3['full-swatch-list-toggle'],
    href: productUrl
  }, moreString) : null));
}
RecommendedProductSwatchGroup.propTypes = RecommendedProductSwatchGroupPropTypes;var css_248z$5 = "/* stylelint-disable-line scss/dollar-variable-pattern */\n/** This clear-unit function helps removing the Unit of Any Element.\n* Cases To Use: For Example:\n* Constant Declaration: const $element-height: 40px;\n* Usage 1 Get Untiless Output:\n  line-height: clear-unit($element-height) / body('font-size');\n* Usage 2 Same Constant Get Unit Output:\n  height: $element-height;\n* Saves declaring 2 variables or Constants & makes multi usage\n* This is used inside rem function\n* Please don't alter without consulting project team members\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Progress Steps Funtion\n* Note for Development Team:\n* Progress Steps Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n.recommendation-slide-module__recommendation-slide--RaMnJ .recommendation-slide-module__loading--dT5Xv {\n  animation: recommendation-slide-module__pulse-loading--ZxVsl 1s infinite ease-out;\n  transition: background-color 200ms ease-in-out;\n}\n@keyframes recommendation-slide-module__pulse-loading--ZxVsl {\n  0% {\n    background-color: #fefefe;\n  }\n  50% {\n    background-color: #f6f6f6;\n  }\n  100% {\n    background-color: #fefefe;\n  }\n}\n.recommendation-slide-module__recommendation-slide--RaMnJ .recommendation-slide-module__loading--dT5Xv > img {\n  display: none;\n}\n.recommendation-slide-module__recommendation-slide--RaMnJ .recommendation-slide-module__product-content--G7rLk {\n  padding: 0 5px;\n  margin-top: 10px;\n}\n.recommendation-slide-module__recommendation-slide--RaMnJ .product-image {\n  /*\n    Note: added because product images were getting zero height on window resize\n    Original display mode set to \"display: grid\"\n  */\n  display: block;\n}\n.recommendation-slide-module__recommendation-slide--RaMnJ .product-image img {\n  width: 100%;\n}";
var styles$2 = {"recommendation-slide":"recommendation-slide-module__recommendation-slide--RaMnJ","loading":"recommendation-slide-module__loading--dT5Xv","pulse-loading":"recommendation-slide-module__pulse-loading--ZxVsl","product-content":"recommendation-slide-module__product-content--G7rLk"};
styleInject(css_248z$5);function RecommendationSlide(_ref) {
  var _ref$onSwatchClick = _ref.onSwatchClick,
    onSwatchClick = _ref$onSwatchClick === void 0 ? undefined : _ref$onSwatchClick,
    _ref$product = _ref.product,
    product = _ref$product === void 0 ? {} : _ref$product;
  var discountPrice = product.discountPrice,
    imageUrl = product.imageUrl,
    memberPrice = product.memberPrice,
    name = product.name,
    price = product.price,
    swatches = product.swatches,
    productUrl = product.productUrl;

  /**
   * Base product image candidates parsed from pipe-separated imageUrl.
   * Recomputed when the product imageUrl changes.
   */
  var fallbackUrls = useMemo(function () {
    return imageUrl ? imageUrl.split('|').filter(function (url) {
      return url.trim();
    }) : [];
  }, [imageUrl]);

  /**
   * Preferred base image to display and revert to.
   * Uses the first URL in fallbackUrls, which comes from the BFF faceout
   * priority order (e.g., life1 -> model1 -> prod1).
   */
  var preferredFallbackUrl = useMemo(function () {
    return fallbackUrls[0];
  }, [fallbackUrls]);
  var initialFallbackIndex = Math.max(0, fallbackUrls.indexOf(preferredFallbackUrl));
  var _useState = useState(preferredFallbackUrl),
    _useState2 = _slicedToArray(_useState, 2),
    currentImageUrl = _useState2[0],
    setCurrentImageUrl = _useState2[1];
  var _useState3 = useState(preferredFallbackUrl),
    _useState4 = _slicedToArray(_useState3, 2),
    validImageUrl = _useState4[0],
    setValidImageUrl = _useState4[1];
  var _useState5 = useState(DEFAULT_SLIDES_TO_SHOW),
    _useState6 = _slicedToArray(_useState5, 2),
    slidesToShow = _useState6[0],
    setSlidesToShow = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isImageLoading = _useState8[0],
    setIsImageLoading = _useState8[1];
  var _useState9 = useState(initialFallbackIndex),
    _useState10 = _slicedToArray(_useState9, 2),
    fallbackIndex = _useState10[0],
    setFallbackIndex = _useState10[1];
  var slideRef = useRef(null);
  var windowWidth = l();

  /**
   * Marks image as loaded.
   * Do not update validImageUrl here to avoid capturing hover images as
   * the revert target.
   */
  var handleOnLoad = function handleOnLoad() {
    setIsImageLoading(false);
  };

  /**
   * Advances through base fallbackUrls on real image load error.
   * If current revert target failed, update validImageUrl to next base.
   */
  var handleImageError = function handleImageError() {
    var nextIndex = fallbackIndex + 1;
    if (nextIndex < fallbackUrls.length) {
      var nextUrl = fallbackUrls[nextIndex];
      setFallbackIndex(nextIndex);
      setCurrentImageUrl(nextUrl);
      // If preferred revert image failed, update to next available base image
      if (currentImageUrl === validImageUrl) {
        setValidImageUrl(nextUrl);
      }
    }
  };

  /**
   * Shows hovered swatch image without changing validImageUrl.
   */
  var handleOnSwatchMouseOver = function handleOnSwatchMouseOver(_, swatch) {
    var newImageUrl = swatch.productImageUrl;
    setCurrentImageUrl(newImageUrl);
  };

  /**
   * Reverts to last known base image when pointer leaves a swatch.
   */
  var handleOnSwatchMouseLeave = function handleOnSwatchMouseLeave() {
    setCurrentImageUrl(validImageUrl);
  };

  /**
   * Computes placeholder height to avoid layout shift while images load.
   */
  var calculateMinimumSlideWidth = function calculateMinimumSlideWidth() {
    var maximumSlideWidth = DEFAULT_MINIMUM_SLIDE_WIDTH * slidesToShow;
    return Math.max(windowWidth, maximumSlideWidth) / slidesToShow * DEFAULT_ASPECT_RATIO;
  };

  /**
   * Workaround: disable native drag on images until DS exposes a prop.
   */
  useEffect(function () {
    var images = _toConsumableArray(slideRef.current.querySelectorAll('img'));
    images.forEach(function (image) {
      return image.setAttribute('draggable', 'false');
    });
  }, []);

  /**
   * Resets image state when product imageUrl changes.
   * Sets current/valid image to preferred base and resets fallback index/loading.
   */
  useEffect(function () {
    var idx = Math.max(0, fallbackUrls.indexOf(preferredFallbackUrl));
    setCurrentImageUrl(preferredFallbackUrl);
    setValidImageUrl(preferredFallbackUrl);
    setFallbackIndex(idx);
    setIsImageLoading(true);
  }, [preferredFallbackUrl, fallbackUrls]);
  useEffect(function () {
    if (windowWidth < DEFAULT_BREAKPOINTS.desktop) setSlidesToShow(DEFAULT_SLIDES_TO_SHOW_TABLET);else setSlidesToShow(DEFAULT_SLIDES_TO_SHOW);
  }, [windowWidth]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles$2['recommendation-slide'],
    "data-testid": "recommendation-slide",
    ref: slideRef
  }, /*#__PURE__*/React.createElement(ProductImage, {
    alt: name,
    classList: !isImageLoading ? '' : styles$2.loading,
    src: currentImageUrl,
    onLoad: handleOnLoad,
    onError: handleImageError
  }, !isImageLoading ? null : /*#__PURE__*/React.createElement("div", {
    className: "placeholder",
    style: {
      minHeight: calculateMinimumSlideWidth()
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$2['product-content']
  }, /*#__PURE__*/React.createElement(RecommendedProductSwatchGroup, {
    legend: name,
    onSwatchClick: onSwatchClick,
    onSwatchMouseOver: handleOnSwatchMouseOver,
    onSwatchMouseLeave: handleOnSwatchMouseLeave,
    productUrl: productUrl,
    swatches: swatches,
    product: product
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: '5px'
    }
  }, /*#__PURE__*/React.createElement(ProductName, null, name)), /*#__PURE__*/React.createElement(ProductPrice, {
    description: discountPrice || price,
    originalPrice: price,
    discountPrice: discountPrice,
    variant: !discountPrice ? 'original' : 'discount'
  }), memberPrice && /*#__PURE__*/React.createElement(ProductPrice, {
    description: memberPrice,
    originalPrice: memberPrice,
    variant: "member"
  })));
}
RecommendationSlide.propTypes = RecommendationSlidePropTypes;var slidePropTypes = {
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
  isHidden: PropTypes.bool,
  isScrollAllowed: PropTypes.bool,
  minWidth: PropTypes.number,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onTouchStart: PropTypes.func,
  onTouchEnd: PropTypes.func,
  width: PropTypes.number
};
var sliderPropTypes = {
  label: PropTypes.node.isRequired,
  slides: PropTypes.arrayOf(PropTypes.node).isRequired,
  minimumSlideWidth: PropTypes.number,
  nextLabel: PropTypes.string,
  onSlideClick: PropTypes.func,
  onSlideActivate: PropTypes.func,
  previousLabel: PropTypes.string,
  slideMagnitude: PropTypes.number,
  slidesToShow: PropTypes.number
};var css_248z$4 = "/* stylelint-disable-line scss/dollar-variable-pattern */\n/** This clear-unit function helps removing the Unit of Any Element.\n* Cases To Use: For Example:\n* Constant Declaration: const $element-height: 40px;\n* Usage 1 Get Untiless Output:\n  line-height: clear-unit($element-height) / body('font-size');\n* Usage 2 Same Constant Get Unit Output:\n  height: $element-height;\n* Saves declaring 2 variables or Constants & makes multi usage\n* This is used inside rem function\n* Please don't alter without consulting project team members\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Progress Steps Funtion\n* Note for Development Team:\n* Progress Steps Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n.slider-module__slider--T1uSe {\n  align-items: center;\n  display: flex;\n  position: relative;\n}\n.slider-module__slider--T1uSe .slider-module__control-container--kU-Nz {\n  align-items: center;\n  display: flex;\n  position: absolute;\n  z-index: 1;\n}\n.slider-module__slider--T1uSe .slider-module__control-container--kU-Nz [data-theme=inverse] {\n  background: rgba(255, 255, 255, 0.6);\n  height: 40px;\n  width: 40px;\n}\n.slider-module__slider--T1uSe .slider-module__control-container--kU-Nz [data-theme=inverse] > [data-icon] {\n  line-height: 40px;\n}\n.slider-module__slider--T1uSe .slider-module__control-container--kU-Nz [data-theme=inverse]:hover:not(:disabled), .slider-module__slider--T1uSe .slider-module__control-container--kU-Nz [data-theme=inverse]:active:not(:disabled) {\n  background: white;\n}\n.slider-module__slider--T1uSe .slider-module__control-container--kU-Nz [data-theme=inverse]:focus {\n  outline: 1px dashed #000000;\n  outline-offset: 5px;\n}\n.slider-module__slider--T1uSe .slider-module__control-container--kU-Nz:first-of-type {\n  left: 0;\n}\n.slider-module__slider--T1uSe .slider-module__control-container--kU-Nz:nth-of-type(2) {\n  right: 0;\n}\n.slider-module__slider--T1uSe .slider-module__container--PYEpX {\n  overflow-x: hidden;\n  width: 100%;\n}\n.slider-module__slider--T1uSe .slider-module__container--PYEpX.slider-module__centered--adJFj {\n  display: flex;\n  justify-content: center;\n}\n.slider-module__slider--T1uSe .slider-module__track--y9VUq {\n  align-items: center;\n  display: flex;\n  width: max-content;\n}\n.slider-module__slider--T1uSe .slider-module__track--y9VUq:not(.slider-module__draggable--7WTHE) {\n  transition: transform 200ms ease-in-out;\n}\n.slider-module__slider--T1uSe .slider-module__slide--ONbL4 {\n  align-self: stretch;\n  box-sizing: border-box;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.slider-module__slider--T1uSe .slider-module__slide--ONbL4:focus, .slider-module__slider--T1uSe .slider-module__slide--ONbL4.slider-module__active--2nIKA {\n  outline: 1px dashed #000000;\n  outline-offset: -2px;\n  z-index: 1;\n}\n.slider-module__slider--T1uSe .slider-module__slide--ONbL4 > * {\n  margin: 5px;\n}";
var styles$1 = {"slider":"slider-module__slider--T1uSe","control-container":"slider-module__control-container--kU-Nz","container":"slider-module__container--PYEpX","centered":"slider-module__centered--adJFj","track":"slider-module__track--y9VUq","draggable":"slider-module__draggable--7WTHE","slide":"slider-module__slide--ONbL4","active":"slider-module__active--2nIKA"};
styleInject(css_248z$4);function Slide(_ref) {
  var _children$props;
  var children = _ref.children,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    _ref$isHidden = _ref.isHidden,
    isHidden = _ref$isHidden === void 0 ? false : _ref$isHidden,
    _ref$isScrollAllowed = _ref.isScrollAllowed,
    isScrollAllowed = _ref$isScrollAllowed === void 0 ? false : _ref$isScrollAllowed,
    _ref$minWidth = _ref.minWidth,
    minWidth = _ref$minWidth === void 0 ? undefined : _ref$minWidth,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? undefined : _ref$onClick,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? undefined : _ref$onFocus,
    _ref$onMouseDown = _ref.onMouseDown,
    onMouseDown = _ref$onMouseDown === void 0 ? undefined : _ref$onMouseDown,
    _ref$onMouseUp = _ref.onMouseUp,
    onMouseUp = _ref$onMouseUp === void 0 ? undefined : _ref$onMouseUp,
    _ref$onTouchEnd = _ref.onTouchEnd,
    onTouchEnd = _ref$onTouchEnd === void 0 ? undefined : _ref$onTouchEnd,
    _ref$onTouchStart = _ref.onTouchStart,
    onTouchStart = _ref$onTouchStart === void 0 ? undefined : _ref$onTouchStart,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? undefined : _ref$width;
  var getTabIndex = function getTabIndex() {
    if (!isScrollAllowed) return undefined;
    return isHidden ? -1 : 0;
  };
  var getActiveClass = function getActiveClass() {
    if (!isScrollAllowed) return '';
    return !isActive ? '' : styles$1.active;
  };

  // Set style object
  var style = {};
  if (minWidth) style.minWidth = "".concat(minWidth, "px");
  if (width) style.width = "".concat(width, "px");
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("div", {
      "aria-labelledby": (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props.id // Use the id of the slide if possible
      ,
      "aria-roledescription": "slide",
      "aria-hidden": isHidden,
      className: "".concat(styles$1.slide, " ").concat(getActiveClass()),
      onClick: onClick,
      onFocus: onFocus,
      onMouseDown: onMouseDown,
      onMouseUp: onMouseUp,
      onTouchStart: onTouchStart,
      onTouchEnd: onTouchEnd,
      style: style,
      tabIndex: getTabIndex(),
      role: "button"
    }, children)
  );
}
Slide.propTypes = slidePropTypes;/*
  TODO:
  - Figure out button aria-hidden issue
*/

function Slider(_ref) {
  var _containerRef$current2, _trackRef$current;
  var label = _ref.label,
    previousLabel = _ref.previousLabel,
    _ref$minimumSlideWidt = _ref.minimumSlideWidth,
    minimumSlideWidth = _ref$minimumSlideWidt === void 0 ? undefined : _ref$minimumSlideWidt,
    _ref$nextLabel = _ref.nextLabel,
    nextLabel = _ref$nextLabel === void 0 ? undefined : _ref$nextLabel,
    _ref$onSlideClick = _ref.onSlideClick,
    onSlideClick = _ref$onSlideClick === void 0 ? undefined : _ref$onSlideClick,
    _ref$onSlideActivate = _ref.onSlideActivate,
    onSlideActivate = _ref$onSlideActivate === void 0 ? undefined : _ref$onSlideActivate,
    _ref$slideMagnitude = _ref.slideMagnitude,
    slideMagnitude = _ref$slideMagnitude === void 0 ? 1 : _ref$slideMagnitude,
    slides = _ref.slides,
    _ref$slidesToShow = _ref.slidesToShow,
    slidesToShow = _ref$slidesToShow === void 0 ? undefined : _ref$slidesToShow,
    sliderControlOffset = _ref.sliderControlOffset;
  var focusSource = useFocusSource();
  var windowWidth = l();
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    containerWidth = _useState2[0],
    setContainerWidth = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDragging = _useState4[0],
    setIsDragging = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    dragDelta = _useState6[0],
    setDragDelta = _useState6[1];
  var dragOrigin = useRef(0);
  var isClickBlocked = useRef(false);
  var timeoutRef = useRef(null);
  var containerRef = useRef(null);
  var trackRef = useRef(null);
  var _useSlider = useSlider(slides, {
      containerRef: containerRef,
      trackRef: trackRef,
      containerWidth: containerWidth
    }),
    state = _useSlider.state,
    isScrollAllowed = _useSlider.isScrollAllowed,
    handleOnSlideLeft = _useSlider.handleOnSlideLeft,
    handleOnSlideRight = _useSlider.handleOnSlideRight,
    handleOnSlideSelect = _useSlider.handleOnSlideSelect,
    handleOnSlideSnap = _useSlider.handleOnSlideSnap;

  /*
    Handler Helpers
  */
  var throttleEvent = function throttleEvent(fn, event) {
    if (!timeoutRef.current) {
      fn(event);
      timeoutRef.current = setTimeout(function () {
        timeoutRef.current = null;
      }, DEFAULT_SLIDE_TIMEOUT);
    }
  };
  var handleKeyboardClick = function handleKeyboardClick(event) {
    var children = _toConsumableArray(trackRef.current.children);
    var targetIndex = children.indexOf(event.target);
    if (targetIndex < 0) return;
    event.target.click();
  };
  var onKeyDown = function onKeyDown(event) {
    var code = event.code;
    switch (code === null || code === void 0 ? void 0 : code.toLowerCase()) {
      case 'arrowleft':
        handleOnSlideLeft({
          shouldFocus: true
        });
        break;
      case 'arrowright':
        handleOnSlideRight({
          shouldFocus: true
        });
        break;
      case 'space':
        handleKeyboardClick(event);
        break;
    }
  };
  var onDragStart = function onDragStart(x) {
    dragOrigin.current = x;
    setIsDragging(true);
  };
  var onDragMove = function onDragMove(x) {
    if (!isDragging) return;
    var delta = x - dragOrigin.current;
    if (Math.abs(delta) < DEFAULT_DRAG_THRESHOLD) return;
    setDragDelta(delta);
  };
  var onDragReset = function onDragReset() {
    dragOrigin.current = 0;
    setDragDelta(0);
  };

  /*
    Handlers
  */
  var handleOnKeyDown = function handleOnKeyDown(event) {
    return throttleEvent(onKeyDown, event);
  };
  var handleOnSlideClick = function handleOnSlideClick(event, index) {
    event.preventDefault();
    if (isClickBlocked.current) return;
    handleOnSlideSelect(index);
    if (onSlideClick) onSlideClick(event, index);
  };
  var handleOnMouseDown = function handleOnMouseDown(event) {
    if (event.button > 0) return;
    onDragStart(event.clientX);
  };
  var handleOnMouseMove = function handleOnMouseMove(event) {
    onDragMove(event.clientX);
  };
  var handleOnMouseUp = function handleOnMouseUp() {
    setIsDragging(false);
    if (dragDelta === 0) return;
    handleOnSlideSnap(dragDelta);

    /*
      Note: Set then reset on the next tick to ensure that slide click through isn't
      interupted after a drag action
    */
    isClickBlocked.current = true;
    setTimeout(function () {
      isClickBlocked.current = false;
    }, 0);
    onDragReset();
  };
  var handleOnMouseLeave = function handleOnMouseLeave() {
    setIsDragging(false);
    handleOnSlideSnap(dragDelta);
    onDragReset();
  };
  var handleOnFocus = function handleOnFocus(event) {
    var focusIndex = _toConsumableArray(trackRef.current.children).indexOf(event.target);
    if (focusSource !== 'keyboard') return;
    handleOnSlideSelect(focusIndex);
  };

  /*
    Touch Handlers
  */
  var handleOnTouchStart = function handleOnTouchStart(event) {
    var clientX = event.touches[0].clientX;
    onDragStart(clientX);
  };
  var handleOnTouchMove = function handleOnTouchMove(event) {
    var clientX = event.touches[0].clientX;
    onDragMove(clientX);
  };
  var handleOnTouchEnd = handleOnMouseUp;

  /*
    Effects
  */
  useEffect(function () {
    var _containerRef$current;
    setContainerWidth((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth);
  }, [windowWidth, containerRef]);
  useEffect(function () {
    var index = state.index;
    if (!onSlideActivate) return;
    onSlideActivate(index);
  }, [state, state.index, onSlideActivate]);

  /*
    Rendering
  */
  var getIsActive = function getIsActive(index) {
    return isScrollAllowed && index === state.index;
  };
  var getIsHidden = function getIsHidden(index) {
    if (!isScrollAllowed) return false; // All slides are visible
    if (slideMagnitude < 2) return !getIsActive(index);
    var chunkedIndexes = getChunkedIndexes(state.slides, slideMagnitude);
    var nextChunkIndex = chunkedIndexes.find(function (chunkIndex) {
      return chunkIndex > state.index;
    });
    var currentChunkIndex = chunkedIndexes.find(function (chunkIndex) {
      return chunkIndex <= state.index && state.index < chunkIndex + slideMagnitude;
    });
    var isBeforeCurrentChunk = index < currentChunkIndex;
    var isAfterNextChunk = nextChunkIndex ? index >= nextChunkIndex : false;
    return isBeforeCurrentChunk || isAfterNextChunk;
  };
  var renderSlides = function renderSlides(slide, index) {
    var i = index;
    var isActive = getIsActive(index);
    var isHidden = getIsHidden(index);
    return /*#__PURE__*/React.createElement(Slide, {
      isActive: isActive,
      isHidden: isHidden,
      isScrollAllowed: isScrollAllowed,
      key: "slide-".concat(i),
      minWidth: minimumSlideWidth,
      onClick: function onClick(event) {
        return handleOnSlideClick(event, index);
      },
      onFocus: handleOnFocus,
      onMouseDown: handleOnMouseDown,
      onMouseUp: handleOnMouseUp,
      onTouchEnd: handleOnTouchEnd,
      onTouchStart: handleOnTouchStart,
      width: slidesToShow && slidesToShow > 0 ? Math.floor(containerWidth / slidesToShow) : undefined
    }, slide);
  };
  var renderSliderControls = function renderSliderControls() {
    if (!isScrollAllowed) return null;
    var setSliderControlPosition = sliderControlOffset ? {
      top: "".concat(sliderControlOffset, "px")
    } : {};
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$1['control-container']),
      style: setSliderControlPosition
    }, /*#__PURE__*/React.createElement(IconButton, {
      icon: "left-thin",
      labelText: previousLabel,
      onClick: function onClick() {
        return handleOnSlideLeft({
          slideMagnitude: slideMagnitude
        });
      },
      theme: "inverse",
      variant: "square"
    })), /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$1['control-container']),
      style: setSliderControlPosition
    }, /*#__PURE__*/React.createElement(IconButton, {
      icon: "right-thin",
      labelText: nextLabel,
      onClick: function onClick() {
        return handleOnSlideRight({
          slideMagnitude: slideMagnitude
        });
      },
      theme: "inverse",
      variant: "square"
    })));
  };
  var translation = !isDragging ? state.offset : setLimitsOnOffset(state.offset + dragDelta, (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.offsetWidth, (_trackRef$current = trackRef.current) === null || _trackRef$current === void 0 ? void 0 : _trackRef$current.offsetWidth);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    React.createElement("section", {
      "aria-label": label,
      "aria-roledescription": "carousel",
      onKeyDown: handleOnKeyDown,
      onMouseLeave: handleOnMouseLeave,
      className: styles$1.slider
    }, renderSliderControls(), /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles$1.container, " ").concat(!isScrollAllowed ? styles$1.centered : ''),
      ref: containerRef
    }, /*#__PURE__*/React.createElement("div", {
      "aria-live": "off",
      className: "".concat(styles$1.track, " ").concat(!isDragging ? '' : styles$1.draggable),
      "data-testid": "slider-track",
      onMouseMove: handleOnMouseMove,
      onTouchMove: handleOnTouchMove,
      ref: trackRef,
      style: {
        transform: "translateX(".concat(translation, "px)"),
        touchAction: 'pan-y' // prevents horizontal scroll
      }
    }, slides === null || slides === void 0 ? void 0 : slides.map(renderSlides))))
  );
}
Slider.propTypes = sliderPropTypes;var GridPropTypes = {
  children: PropTypes$1.node.isRequired
};
var RowPropTypes = {
  children: PropTypes$1.node.isRequired
};function Grid(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "scope-xp grid"
  }, children);
}
Grid.propTypes = GridPropTypes;function Row(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "scope-xp row"
  }, children);
}
Row.propTypes = RowPropTypes;var css_248z$3 = "/* stylelint-disable-line scss/dollar-variable-pattern */\n/** This clear-unit function helps removing the Unit of Any Element.\n* Cases To Use: For Example:\n* Constant Declaration: const $element-height: 40px;\n* Usage 1 Get Untiless Output:\n  line-height: clear-unit($element-height) / body('font-size');\n* Usage 2 Same Constant Get Unit Output:\n  height: $element-height;\n* Saves declaring 2 variables or Constants & makes multi usage\n* This is used inside rem function\n* Please don't alter without consulting project team members\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Progress Steps Funtion\n* Note for Development Team:\n* Progress Steps Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n.recommendation-slider-module__recommendation-slider--9fbEi {\n  -webkit-tap-highlight-color: transparent;\n}\n.recommendation-slider-module__recommendation-slider--9fbEi [class^=slider-module__track] {\n  align-items: flex-start;\n}\n.recommendation-slider-module__recommendation-slider--9fbEi [class^=slider-module__slider] {\n  margin-bottom: 50px;\n}\n.recommendation-slider-module__recommendation-slider--9fbEi [class^=slider-module__slider] [class^=slider-module__slide][class*=slider-module__active] {\n  outline: none;\n}\n.recommendation-slider-module__recommendation-slider--9fbEi [class^=slider-module__slider] [class^=slider-module__slide] > * {\n  margin: 10px;\n}\n.recommendation-slider-module__recommendation-slider--9fbEi .grid {\n  display: flex;\n  flex-direction: column;\n}\n.recommendation-slider-module__recommendation-slider--9fbEi .grid .row {\n  align-items: flex-start;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n.recommendation-slider-module__recommendation-slider--9fbEi .grid .row:first-of-type {\n  margin-bottom: 10px;\n}\n.recommendation-slider-module__recommendation-slider--9fbEi .grid .row > button {\n  all: unset;\n  cursor: pointer;\n}\n.recommendation-slider-module__recommendation-slider--9fbEi .grid .row > button:focus, .recommendation-slider-module__recommendation-slider--9fbEi .grid .row > button.active {\n  outline: 1px dashed #000000;\n  outline-offset: 0px;\n  z-index: 1;\n}\n.recommendation-slider-module__recommendation-slider--9fbEi.recommendation-slider-module__mobile--tGlYn [class*=slider-module__active] {\n  outline: unset;\n}\n.recommendation-slider-module__recommendation-slider--9fbEi.recommendation-slider-module__mobile--tGlYn [class*=slider-module__active]:focus {\n  outline: 1px dashed #000000;\n  outline-offset: -2px;\n  z-index: 1;\n}";
var styles = {"recommendation-slider":"recommendation-slider-module__recommendation-slider--9fbEi","mobile":"recommendation-slider-module__mobile--tGlYn"};
styleInject(css_248z$3);function RecommendationSlider(_ref) {
  var _ref$mobileBreakpoint = _ref.mobileBreakpoint,
    mobileBreakpoint = _ref$mobileBreakpoint === void 0 ? DEFAULT_BREAKPOINTS.tablet : _ref$mobileBreakpoint,
    _ref$onIsVisible = _ref.onIsVisible,
    onIsVisible = _ref$onIsVisible === void 0 ? undefined : _ref$onIsVisible,
    _ref$onProductClick = _ref.onProductClick,
    onProductClick = _ref$onProductClick === void 0 ? undefined : _ref$onProductClick,
    _ref$onSwatchClick = _ref.onSwatchClick,
    onSwatchClick = _ref$onSwatchClick === void 0 ? undefined : _ref$onSwatchClick,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? '' : _ref$placement,
    _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    _ref$slideRenderer = _ref.slideRenderer,
    slideRenderer = _ref$slideRenderer === void 0 ? undefined : _ref$slideRenderer,
    _ref$slidesToShow = _ref.slidesToShow,
    slidesToShow = _ref$slidesToShow === void 0 ? DEFAULT_SLIDES_TO_SHOW : _ref$slidesToShow,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$useGrid = _ref.useGrid,
    useGrid = _ref$useGrid === void 0 ? false : _ref$useGrid;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    activeSlide = _useState4[0],
    setActiveSlide = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    containerWidth = _useState6[0],
    setContainerWidth = _useState6[1];
  var _useElementOnScreen = useElementOnScreen({
      threshold: 0.5
    }),
    _useElementOnScreen2 = _slicedToArray(_useElementOnScreen, 2),
    containerRef = _useElementOnScreen2[0],
    isVisible = _useElementOnScreen2[1];
  var windowWidth = l();
  var handleProductClick = function handleProductClick(event, index) {
    var _window;
    var product = products[index];
    if (onProductClick) onProductClick(event, product, index);
    var clickTrackingUrl = product.clickTrackingUrl;
    var fetchFn = ((_window = window) === null || _window === void 0 ? void 0 : _window.fetch) || /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", Promise.resolve());
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    fetchFn(clickTrackingUrl)["catch"](function () {/* do nothing */});
  };
  var handleOnSlideActivate = function handleOnSlideActivate(index) {
    return setActiveSlide(index);
  };
  var handleOnIsVisible = useCallback(function () {
    if (!onIsVisible) return;
    onIsVisible(containerRef.current, placement, products);
  }, [onIsVisible, containerRef, placement, products]);
  useEffect(function () {
    return setIsMobile(windowWidth < mobileBreakpoint);
  }, [windowWidth, mobileBreakpoint]);
  useEffect(function () {
    var _containerRef$current;
    setContainerWidth((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth);
  }, [windowWidth, containerRef]);
  useEffect(function () {
    if (!isVisible) return;
    handleOnIsVisible();
    runAnalyticsUniversalScrollEvent(placement);
  }, [isVisible, placement, handleOnIsVisible]);
  var renderSlide = function renderSlide(product) {
    if (!slideRenderer) {
      return /*#__PURE__*/React.createElement(RecommendationSlide, {
        onSwatchClick: onSwatchClick,
        product: product
      });
    }
    return slideRenderer(product);
  };
  var renderGridSlide = function renderGridSlide(grids, product, i) {
    var id = product.id;
    var key = "recommendation-grid-".concat(id);
    var handleOnClick = function handleOnClick(event, index) {
      event.stopPropagation();
      handleProductClick(event, index);
    };
    var handleOnFocus = function handleOnFocus(event) {
      event.preventDefault();
      event.stopPropagation();
      var target = event.target;
      target.focus({
        preventScroll: true
      });
    };
    var renderButton = function renderButton(item, index) {
      var tabIndex = Math.floor(i / 4) === activeSlide ? 0 : -1;
      return /*#__PURE__*/React.createElement("button", {
        onClick: function onClick(event) {
          return handleOnClick(event, i + index);
        },
        onFocus: handleOnFocus,
        key: "recommendation-item-".concat(i + index),
        tabIndex: tabIndex,
        type: "button",
        style: {
          flex: 1
        }
      }, renderSlide(item));
    };
    if (i % 4 === 0) {
      var gridItems = products.slice(i, i + 4);
      grids.push( /*#__PURE__*/React.createElement(Grid, {
        key: key
      }, /*#__PURE__*/React.createElement(Row, null, gridItems.slice(0, 2).map(renderButton)), gridItems.length > 2 && /*#__PURE__*/React.createElement(Row, null, gridItems.slice(2, 4).map(function (item, index) {
        return renderButton(item, index + 2);
      }))));
    }
    return grids;
  };
  var showDesktop = !isMobile || products.length < 3;
  var slides = !showDesktop || useGrid ? products.reduce(renderGridSlide, []) : products.map(renderSlide);

  // This sets the slider control arrows position in such a way that they do not
  // shift downward when swatches are expanded.
  // subtract 20px from slide width to account for margins around product images
  var widthOfProductImage = Math.floor(containerWidth / slidesToShow - 20);

  // multiply by 1.25 to account for aspect ratio of product images
  // divide by 2 to get the center of the product image
  // subtract 10px from product image height to account for top margin
  var sliderControlOffset = Math.floor(widthOfProductImage * 1.25 / 2 - 10);
  return /*#__PURE__*/React.createElement("div", {
    className: "scope-xp scope-1892 ".concat(styles['recommendation-slider'], " ").concat(isMobile ? styles.mobile : ''),
    "data-testid": "recommendation-slider",
    "data-slider-id": placement,
    ref: containerRef
  }, /*#__PURE__*/React.createElement("h2", {
    className: "h1"
  }, /*#__PURE__*/React.createElement(Headline, {
    align: "center",
    size: "s",
    marginBottom: "l",
    marginTop: "l"
  }, title)), !showDesktop || useGrid ? /*#__PURE__*/React.createElement(Slider, {
    id: "recommendation-slider-".concat(title),
    label: title,
    minimumSlideWidth: DEFAULT_MINIMUM_SLIDE_WIDTH,
    onSlideActivate: handleOnSlideActivate,
    slideMagnitude: 1,
    slides: slides,
    slidesToShow: 1
  }) : /*#__PURE__*/React.createElement(Slider, {
    id: "recommendation-slider-".concat(title),
    label: title,
    slides: slides,
    minimumSlideWidth: DEFAULT_MINIMUM_SLIDE_WIDTH,
    onSlideClick: handleProductClick,
    slidesToShow: windowWidth < DEFAULT_BREAKPOINTS.desktop ? 3 : slidesToShow,
    slideMagnitude: windowWidth < DEFAULT_BREAKPOINTS.desktop ? 3 : slidesToShow,
    sliderControlOffset: sliderControlOffset
  }));
}
RecommendationSlider.propTypes = RecommendationSliderPropTypes;var css_248z$2 = "/* stylelint-disable-line scss/dollar-variable-pattern */\n/** This clear-unit function helps removing the Unit of Any Element.\n* Cases To Use: For Example:\n* Constant Declaration: const $element-height: 40px;\n* Usage 1 Get Untiless Output:\n  line-height: clear-unit($element-height) / body('font-size');\n* Usage 2 Same Constant Get Unit Output:\n  height: $element-height;\n* Saves declaring 2 variables or Constants & makes multi usage\n* This is used inside rem function\n* Please don't alter without consulting project team members\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Progress Steps Funtion\n* Note for Development Team:\n* Progress Steps Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n.scope-xp.recommendation-slider.loading {\n  animation: pulse-loading 1s infinite ease-out;\n  transition: background-color 200ms ease-in-out;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 10px;\n  min-height: 250px;\n}\n@keyframes pulse-loading {\n  0% {\n    background-color: #fefefe;\n  }\n  50% {\n    background-color: #f6f6f6;\n  }\n  100% {\n    background-color: #fefefe;\n  }\n}\n.scope-xp.recommendation-slider.loading:last-of-type {\n  margin-bottom: 0px;\n}";
styleInject(css_248z$2);function LoadingRecommendationSliders(_ref) {
  var placements = _ref.placements;
  return placements.map(function (placement) {
    return /*#__PURE__*/React.createElement("div", {
      className: "scope-xp recommendation-slider loading",
      key: placement
    }, /*#__PURE__*/React.createElement(Button, {
      classList: "recommendation-loading-spinner",
      variant: "borderless",
      isProcessing: true,
      isDisabled: true
    }));
  });
}function RecommendationSliders(_ref) {
  var _ref$onIsVisible = _ref.onIsVisible,
    onIsVisible = _ref$onIsVisible === void 0 ? undefined : _ref$onIsVisible,
    _ref$onProductClick = _ref.onProductClick,
    onProductClick = _ref$onProductClick === void 0 ? undefined : _ref$onProductClick,
    _ref$onSwatchClick = _ref.onSwatchClick,
    onSwatchClick = _ref$onSwatchClick === void 0 ? undefined : _ref$onSwatchClick,
    _ref$placements = _ref.placements,
    placements = _ref$placements === void 0 ? [] : _ref$placements,
    _ref$query = _ref.query,
    query = _ref$query === void 0 ? RECOMMENDATIONS_QUERY : _ref$query,
    _ref$queryOptions = _ref.queryOptions,
    queryOptions = _ref$queryOptions === void 0 ? {} : _ref$queryOptions,
    slideRenderer = _ref.slideRenderer,
    _ref$slidesToShow = _ref.slidesToShow,
    slidesToShow = _ref$slidesToShow === void 0 ? DEFAULT_SLIDES_TO_SHOW : _ref$slidesToShow,
    _ref$useGrid = _ref.useGrid,
    useGrid = _ref$useGrid === void 0 ? false : _ref$useGrid;
  var _useRecommendationsCa = useRecommendationsCall({
      placements: placements,
      query: query,
      queryOptions: queryOptions
    }),
    _useRecommendationsCa2 = _slicedToArray(_useRecommendationsCa, 2),
    _useRecommendationsCa3 = _useRecommendationsCa2[1],
    called = _useRecommendationsCa3.called,
    data = _useRecommendationsCa3.data,
    error = _useRecommendationsCa3.error,
    loading = _useRecommendationsCa3.loading;
  if (!called) return null;
  if (loading) return /*#__PURE__*/React.createElement(LoadingRecommendationSliders, {
    placements: placements
  });
  if (error) return null;
  var _data$recommendations = data.recommendations,
    recommendations = _data$recommendations === void 0 ? {} : _data$recommendations;
  var _recommendations$plac = recommendations.placements,
    productPlacements = _recommendations$plac === void 0 ? [] : _recommendations$plac;
  var renderPlacement = function renderPlacement(placement) {
    var id = placement.id,
      title = placement.title,
      products = placement.products;
    var handleOnProductClick = function handleOnProductClick() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      onRecommendedProductClick.apply(void 0, [placement].concat(args));
      handlePDPAnalyticsGlobal.apply(void 0, [data, placement].concat(args));
      if (onProductClick) onProductClick.apply(void 0, args);
    };
    var handleOnSwatchClick = function handleOnSwatchClick() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      onRecommendedProductSwatchClick.apply(void 0, [placement].concat(args));

      // allow for custom implementation, otherwise use default
      if (onSwatchClick) onSwatchClick.apply(void 0, args);else onSwatchClickHandler.apply(void 0, args);
    };
    if (!(products !== null && products !== void 0 && products.length)) return null;
    return /*#__PURE__*/React.createElement(RecommendationSlider, {
      key: id,
      onIsVisible: onIsVisible,
      onProductClick: handleOnProductClick,
      onSwatchClick: handleOnSwatchClick,
      products: products,
      slideRenderer: slideRenderer,
      title: title,
      slidesToShow: slidesToShow,
      placement: id,
      useGrid: useGrid
    });
  };
  return productPlacements === null || productPlacements === void 0 ? void 0 : productPlacements.map(renderPlacement);
}
RecommendationSliders.propTypes = RecommendationSlidersPropTypes;var EMPTY_TMNT = '??????';
var PRODUCT_CARD_URL_ANALYTICS_PARAMETERS = {
  pagefm: 'navigation-grid',
  prodvm: 'navigation-grid'
};
var PRODUCT_CARD_SWATCH_URL_ANALYTICS_PARAMETERS = {
  pagefm: 'navigation-swatch',
  prodvm: 'navigation-swatch'
};
var SMALLEST_POSSIBLE_BLANK_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw';
var IMAGE_SIZE_POLICY = {
  XSMALL: 'xsmall',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge'
};
var API_TIMEOUT = 5000;
var SCROLL_THRESHOLD = '800px';/**
 * Returns provided URL string with provided query parameters appended
 *
 * @param {string} url - URL string to append query parameters to
 * @param {Object} [parameters={}] - Object of query parameters to append to url
 * @returns {string} URL string with appended query parameters, or original URL string if URL is
 * falsy or if parameters is empty
 * @example
 * // Returns '/shop/us/mens?pagefm=navigation-breadcrumbs'
 * addUrlParameters('/shop/us/mens', { pagefm: 'navigation-breadcrumbs' });
 * @example
* // Returns 'https://www.abercrombie.com/shop/us/p/90s-jeans?categoryId=12203&faceout=model&seq=99&pagefm=navigation-grid&prodvm=navigationgrid'
 * addUrlParameters('https://www.abercrombie.com/shop/us/p/90s-jeans?categoryId=12203&faceout=model&seq=99', { pagefm: 'navigation-grid', prodvm: 'navigation-grid' });
 */
var addUrlParameters = function addUrlParameters(url) {
  var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!url) {
    return url;
  }
  var parametersString = Object.entries(parameters).reduce(function (string, _ref, i) {
    var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];
    return "".concat(string).concat(i > 0 ? '&' : '').concat(k, "=").concat(v);
  }, '');
  if (!parametersString) {
    return url;
  }
  return "".concat(url).concat(url.includes('?') ? '&' : '?').concat(parametersString);
};var css_248z$1 = "/* stylelint-disable-line scss/dollar-variable-pattern */\n/** This clear-unit function helps removing the Unit of Any Element.\n* Cases To Use: For Example:\n* Constant Declaration: const $element-height: 40px;\n* Usage 1 Get Untiless Output:\n  line-height: clear-unit($element-height) / body('font-size');\n* Usage 2 Same Constant Get Unit Output:\n  height: $element-height;\n* Saves declaring 2 variables or Constants & makes multi usage\n* This is used inside rem function\n* Please don't alter without consulting project team members\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Progress Steps Funtion\n* Note for Development Team:\n* Progress Steps Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/* stylelint-disable-line scss/dollar-variable-pattern */\n/** This clear-unit function helps removing the Unit of Any Element.\n* Cases To Use: For Example:\n* Constant Declaration: const $element-height: 40px;\n* Usage 1 Get Untiless Output:\n  line-height: clear-unit($element-height) / body('font-size');\n* Usage 2 Same Constant Get Unit Output:\n  height: $element-height;\n* Saves declaring 2 variables or Constants & makes multi usage\n* This is used inside rem function\n* Please don't alter without consulting project team members\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Progress Steps Funtion\n* Note for Development Team:\n* Progress Steps Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/*\n * Variables used for ProductCard\n */\n@media screen and (min-width: 825px) {\n  .miniGrid-module__miniGrid--b61sk {\n    padding-left: 16px;\n  }\n}\n\nli.miniGrid-module__spotlightCard--Uf4x4 {\n  display: flex;\n  grid-column: span 2;\n  justify-content: center;\n}\n@media screen and (min-width: 1025px) {\n  li.miniGrid-module__spotlightCard--Uf4x4 {\n    justify-content: flex-end;\n  }\n  li.miniGrid-module__spotlightCard--Uf4x4 + li.miniGrid-module__spotlightCard--Uf4x4 {\n    justify-content: flex-start;\n  }\n}\nli.miniGrid-module__spotlightCard--Uf4x4 > div {\n  max-width: 75%;\n}";
var miniGridStyle = {"miniGrid":"miniGrid-module__miniGrid--b61sk","spotlightCard":"miniGrid-module__spotlightCard--Uf4x4"};
styleInject(css_248z$1);var CLICK_BEHAVIORS = {
  productPage: 'productPage',
  quickview: 'quickview'
};
var productCardClickBehaviorType = oneOf([].concat(_toConsumableArray(Object.values(CLICK_BEHAVIORS)), ['', undefined]));var css_248z = "/* stylelint-disable-line scss/dollar-variable-pattern */\n/** This clear-unit function helps removing the Unit of Any Element.\n* Cases To Use: For Example:\n* Constant Declaration: const $element-height: 40px;\n* Usage 1 Get Untiless Output:\n  line-height: clear-unit($element-height) / body('font-size');\n* Usage 2 Same Constant Get Unit Output:\n  height: $element-height;\n* Saves declaring 2 variables or Constants & makes multi usage\n* This is used inside rem function\n* Please don't alter without consulting project team members\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Progress Steps Funtion\n* Note for Development Team:\n* Progress Steps Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/* stylelint-disable-line scss/dollar-variable-pattern */\n/** This clear-unit function helps removing the Unit of Any Element.\n* Cases To Use: For Example:\n* Constant Declaration: const $element-height: 40px;\n* Usage 1 Get Untiless Output:\n  line-height: clear-unit($element-height) / body('font-size');\n* Usage 2 Same Constant Get Unit Output:\n  height: $element-height;\n* Saves declaring 2 variables or Constants & makes multi usage\n* This is used inside rem function\n* Please don't alter without consulting project team members\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Progress Steps Funtion\n* Note for Development Team:\n* Progress Steps Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/** Omni Card component\n* Note for Development Team:\n* Omni Card Component does not support cross branding as of now.\n* As each brand have their own styles intact.\n*/\n/*\n * Variables used for ProductCard\n */\n.productCard-module__productCard--hiGkO {\n  display: block;\n  overflow: hidden;\n  /**\n  * Prevent the elevated effect of cards on the right side of right-aligned\n  * product grid from causing a horizontal scrollbar to appear at narrower\n  * viewport widths.\n  * See https://jira.homeoffice.anfcorp.com/browse/BROWSE-61\n  */\n}\n.productCard-module__productCard--hiGkO h2 {\n  text-transform: none;\n}\n@media screen and (min-width: 825px) {\n  .productCard-module__productCard--hiGkO[data-large-column-spread=\"1\"] {\n    grid-column: span 1;\n  }\n}\n@media screen and (min-width: 825px) {\n  .productCard-module__productCard--hiGkO[data-large-column-spread=\"2\"] {\n    grid-column: span 2;\n  }\n}\n@media screen and (min-width: 825px) {\n  .productCard-module__productCard--hiGkO[data-large-column-spread=\"3\"] {\n    grid-column: span 3;\n  }\n}\n@media screen and (max-width: 824px) {\n  .productCard-module__productCard--hiGkO[data-small-column-spread=\"1\"] {\n    grid-column: span 1;\n  }\n}\n@media screen and (max-width: 824px) {\n  .productCard-module__productCard--hiGkO[data-small-column-spread=\"2\"] {\n    grid-column: span 2;\n  }\n}\n.productCard-module__productCard--hiGkO .productCard-module__template--UsV8l {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  flex-wrap: nowrap;\n  padding-top: 16px;\n}\n.productCard-module__productCard--hiGkO .productCard-module__content--gm314 {\n  padding-right: 10px;\n  margin-top: 10px;\n}\n@media screen and (max-width: 1024px) {\n  .productCard-module__productCard--hiGkO .productCard-module__content--gm314 {\n    padding-left: 10px;\n  }\n}\n.productCard-module__productCard--hiGkO .productCard-module__content--gm314 .productCard-module__product-details-wrapper--Ogb8e {\n  display: flex;\n  flex-direction: column;\n  text-decoration: none;\n}\n.productCard-module__productCard--hiGkO .productCard-module__content--gm314 .productCard-module__product-content-link--rJH1s {\n  display: flex;\n  flex-direction: column;\n  text-decoration: none;\n}\n.productCard-module__productCard--hiGkO .productCard-module__content--gm314 .productCard-module__product-detail--je7H5 a {\n  text-decoration: none;\n}\n.productCard-module__productCard--hiGkO .productCard-module__save--kQ9Vg {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n.productCard-module__productCard--hiGkO .productCard-module__badges--dvSHM {\n  align-items: center;\n  display: flex;\n  padding-right: 10px;\n  margin-bottom: 10px;\n}\n.productCard-module__productCard--hiGkO .productCard-module__buttons--q4Pat {\n  animation: productCard-module__cardFade--H1WFJ 0.2s ease-in-out 1;\n  bottom: 10px;\n  display: flex;\n  gap: 10px;\n  justify-content: space-between;\n  padding: 0 10px;\n  position: absolute;\n  width: 100%;\n}\n.productCard-module__productCard--hiGkO .productCard-module__swatches--R6sC- {\n  margin-bottom: 10px;\n}\n.productCard-module__productCard--hiGkO .productCard-module__swatchLength--J2Cap {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.productCard-module__productCard--hiGkO .productCard-module__quickview--pYUfs {\n  flex-basis: 50%;\n}\n.productCard-module__productCard--hiGkO .productCard-module__quickview--pYUfs:only-child {\n  flex-grow: 1;\n}\n.productCard-module__productCard--hiGkO .productCard-module__socialProofingBadgeContainer--FVsJ9 {\n  display: inline-flex;\n  flex-direction: row-reverse;\n}\n.productCard-module__productCard--hiGkO.productCard-module__topBadge--tozfu {\n  margin-top: -10px;\n}\n@media screen and (max-width: 824px) {\n  ul.product-grid__products {\n    padding-top: 10px;\n  }\n}\n\n@media screen and (min-width: 1025px) {\n  .productCard-module__productCard--hiGkO.productCard-module__hover--NcwMS {\n    overflow: visible;\n  }\n  .productCard-module__productCard--hiGkO.productCard-module__hover--NcwMS .productCard-module__template--UsV8l {\n    z-index: 2;\n  }\n  .productCard-module__productCard--hiGkO.productCard-module__hover--NcwMS .productCard-module__template--UsV8l .productCard-module__hasHoverImage--xpGBA {\n    animation: productCard-module__cardFade--H1WFJ 0.2s ease-in-out 1;\n  }\n  .productCard-module__productCard--hiGkO.productCard-module__hover--NcwMS .productCard-module__template--UsV8l .productCard-module__hasHoverImage--xpGBA .productCard-module__productCardImage_1--qxbCl {\n    opacity: 0;\n  }\n  .productCard-module__productCard--hiGkO.productCard-module__hover--NcwMS .productCard-module__template--UsV8l .productCard-module__hasHoverImage--xpGBA .productCard-module__productCardImage_2--ZPFak {\n    opacity: 1;\n  }\n  .productCard-module__productCard--hiGkO.productCard-module__hover--NcwMS .productCard-module__template--UsV8l::after {\n    background: #fff;\n    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.12);\n    content: \"\";\n    height: calc(100% + 20px);\n    left: 0;\n    position: absolute;\n    top: 0;\n    transform: translateX(-20px);\n    width: calc(100% + 20px * 2);\n    z-index: -1;\n  }\n}\n@media screen and (min-width: 1025px) and (max-width: 1595px) {\n  .productCard-module__productCard--hiGkO.productCard-module__hover--NcwMS .productCard-module__template--UsV8l::after {\n    transform: translateX(-16px);\n    width: calc(100% + 32px);\n  }\n}\n\n.productCard-module__badgeSeparator--eMv-h {\n  font-weight: bold;\n  margin: 0 3px;\n}\n.productCard-module__anf--Foo23 .productCard-module__badgeSeparator--eMv-h {\n  color: #253746;\n}\n.productCard-module__kids--WPyAw .productCard-module__badgeSeparator--eMv-h {\n  color: #20222b;\n}\n.productCard-module__hol--avqc- .productCard-module__badgeSeparator--eMv-h {\n  color: #5c5a54;\n}\n\n.productCard-module__defaultBadge--hm-ww {\n  text-transform: uppercase;\n  font-weight: bold;\n}\n.productCard-module__anf--Foo23 .productCard-module__defaultBadge--hm-ww {\n  color: #253746;\n  font-size: 11px;\n}\n.productCard-module__kids--WPyAw .productCard-module__defaultBadge--hm-ww {\n  color: #20222b;\n  font-size: 11px;\n}\n.productCard-module__hol--avqc- .productCard-module__defaultBadge--hm-ww {\n  color: #5c5a54;\n  font-size: 13px;\n  font-family: \"DS PF DIN Max\", \"PF DIN Max\", sans-serif;\n  font-stretch: 60%;\n  letter-spacing: 0.02px;\n}\n\n.productCard-module__earlyAccessBadge--ftKRB {\n  font-weight: bold;\n}\n.productCard-module__anf--Foo23 .productCard-module__earlyAccessBadge--ftKRB {\n  color: #835e1b;\n  font-size: 11px;\n}\n.productCard-module__kids--WPyAw .productCard-module__earlyAccessBadge--ftKRB {\n  color: #835e1b;\n  font-size: 11px;\n}\n.productCard-module__hol--avqc- .productCard-module__earlyAccessBadge--ftKRB {\n  color: #075bb1;\n  font-size: 13px;\n  font-family: \"DS PF DIN Max\", \"PF DIN Max\", sans-serif;\n  text-transform: uppercase;\n  font-stretch: 60%;\n  letter-spacing: 0.02px;\n}\n\n.productCard-module__product-image-section--rvCr2 {\n  position: relative;\n}\n.productCard-module__product-image-section--rvCr2 a {\n  display: flex;\n}\n.productCard-module__product-image-section--rvCr2 img {\n  aspect-ratio: 0.8;\n  width: 100%;\n}\n.productCard-module__anf--Foo23 .productCard-module__product-image-section--rvCr2 img {\n  background-color: #f6f6f6;\n}\n.productCard-module__kids--WPyAw .productCard-module__product-image-section--rvCr2 img {\n  background-color: #f6f6f6;\n}\n.productCard-module__hol--avqc- .productCard-module__product-image-section--rvCr2 img {\n  background-color: #f5f4f2;\n}\n.productCard-module__product-image-section--rvCr2 .productCard-module__hasHoverImage--xpGBA .productCard-module__productCardImage_1--qxbCl {\n  position: absolute;\n}\n.productCard-module__product-image-section--rvCr2 .productCard-module__hasHoverImage--xpGBA .productCard-module__productCardImage_2--ZPFak {\n  opacity: 0;\n}\n\n.scope-1892 .productCard-module__productCard--hiGkO .icon-button[data-theme=inverse]:focus,\n.scope-1892 .productCard-module__productCard--hiGkO .button[data-variant=overlay][data-theme=inverse]:focus {\n  outline-color: currentColor;\n}\n.scope-1892 .productCard-module__productCard--hiGkO .product-name {\n  margin-bottom: 10px;\n}\n.scope-1892 .productCard-module__productCard--hiGkO .product-price:last-of-type {\n  margin-bottom: 10px;\n}\n.scope-1892 .productCard-module__productCard--hiGkO .swatch-tile-group {\n  /**\n   * Allow room for at least 5 grid items down to 320px before wrapping, implemented\n   * specifically to prevent \"+#\" text from wrapping when showing 4 tiles on mobile.\n   */\n}\n.scope-1892 .productCard-module__productCard--hiGkO .swatch-tile-group .swtg-input-outer-wrapper {\n  grid-auto-flow: row;\n  /**\n   * Use grid item content dimensions to create gap to prevent interaction gaps when\n   * hovering between tiles\n   */\n  grid-gap: 0;\n}\n.scope-1892 .productCard-module__productCard--hiGkO .swatch-tile-group .swtg-input-outer-wrapper {\n  grid-template-columns: repeat(auto-fill, 35px);\n  /**\n   * Use negative margin so that grid item content dimensions can be used for spacing\n   * between tiles but without superfluous whitespace around the set of tiles\n   */\n  margin: -5px;\n}\n.scope-1892 .productCard-module__productCard--hiGkO .swatch-tile-group .swtg-input-inner-wrapper {\n  height: 35px;\n  width: 35px;\n}\n@media screen and (max-width: 539px) {\n  .scope-1892 .productCard-module__productCard--hiGkO .swatch-tile-group .swtg-input-outer-wrapper {\n    grid-template-columns: repeat(auto-fill, 31px);\n    /**\n     * Use negative margin so that grid item content dimensions can be used for spacing\n     * between tiles but without superfluous whitespace around the set of tiles\n     */\n    margin: -3px;\n  }\n  .scope-1892 .productCard-module__productCard--hiGkO .swatch-tile-group .swtg-input-inner-wrapper {\n    height: 31px;\n    width: 31px;\n  }\n}\n@media screen and (max-width: 359px) {\n  .scope-1892 .productCard-module__productCard--hiGkO .swatch-tile-group .swtg-input-outer-wrapper {\n    grid-template-columns: repeat(auto-fill, 26px);\n    /**\n     * Use negative margin so that grid item content dimensions can be used for spacing\n     * between tiles but without superfluous whitespace around the set of tiles\n     */\n    margin: 0px;\n  }\n  .scope-1892 .productCard-module__productCard--hiGkO .swatch-tile-group .swtg-input-inner-wrapper {\n    height: 26px;\n    width: 26px;\n  }\n}\n.scope-1892 .productCard-module__productCard--hiGkO .swatch-tile-group .swtg-input-tile-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.scope-1892 .productCard-module__productCard--hiGkO .swatch-tile-group .swtg-image-inner-wrapper {\n  border-width: 1px;\n  height: 25px;\n  width: 25px;\n}\n.scope-1892 .productCard-module__productCard--hiGkO .swatch-tile-group .swtg-image-inner-wrapper img {\n  aspect-ratio: 1/1;\n  height: 19px;\n  width: 19px;\n}\n.scope-1892 .productCard-module__productCard--hiGkO .productCard-module__socialProofingBadgeContainer--FVsJ9 .badge {\n  font-weight: normal;\n  line-height: 18px;\n  margin-top: -16px;\n  padding: 5px 9px 5px 9px;\n}\n.scope-1892 .productCard-module__productCard--hiGkO .productCard-module__socialProofingBadgeContainer--FVsJ9 .badge .icon {\n  padding-right: 5px;\n  width: auto;\n}\n\n@keyframes productCard-module__cardFade--H1WFJ {\n  from {\n    opacity: 0.5;\n  }\n  to {\n    opacity: 1;\n  }\n}";
var style = {"productCard":"productCard-module__productCard--hiGkO","template":"productCard-module__template--UsV8l","content":"productCard-module__content--gm314","product-details-wrapper":"productCard-module__product-details-wrapper--Ogb8e","product-content-link":"productCard-module__product-content-link--rJH1s","product-detail":"productCard-module__product-detail--je7H5","save":"productCard-module__save--kQ9Vg","badges":"productCard-module__badges--dvSHM","buttons":"productCard-module__buttons--q4Pat","cardFade":"productCard-module__cardFade--H1WFJ","swatches":"productCard-module__swatches--R6sC-","swatchLength":"productCard-module__swatchLength--J2Cap","quickview":"productCard-module__quickview--pYUfs","socialProofingBadgeContainer":"productCard-module__socialProofingBadgeContainer--FVsJ9","topBadge":"productCard-module__topBadge--tozfu","hover":"productCard-module__hover--NcwMS","hasHoverImage":"productCard-module__hasHoverImage--xpGBA","productCardImage_1":"productCard-module__productCardImage_1--qxbCl","productCardImage_2":"productCard-module__productCardImage_2--ZPFak","badgeSeparator":"productCard-module__badgeSeparator--eMv-h","anf":"productCard-module__anf--Foo23","kids":"productCard-module__kids--WPyAw","hol":"productCard-module__hol--avqc-","defaultBadge":"productCard-module__defaultBadge--hm-ww","earlyAccessBadge":"productCard-module__earlyAccessBadge--ftKRB","product-image-section":"productCard-module__product-image-section--rvCr2"};
styleInject(css_248z);function useBreakpointSizes() {
  var _useState = useState({
      xxsmall: false,
      xsmall: false,
      small: false,
      medium: false,
      large: false,
      xlarge: false,
      xxlarge: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    breakpoints = _useState2[0],
    setBreakpoints = _useState2[1];
  useEffect(function () {
    var updateSize = function updateSize() {
      var width = window.innerWidth;
      setBreakpoints({
        xxsmall: width > 360,
        xsmall: width > 540,
        small: width > 700,
        medium: width > 825,
        large: width > 1025,
        xlarge: width > 1200,
        xxlarge: width > 1500
      });
    };
    updateSize();
    window.addEventListener('resize', updateSize);
    return function () {
      return window.removeEventListener('resize', updateSize);
    };
  }, []);
  return breakpoints;
}var imageSetType = shape({
  primaryFaceOutImage: string.isRequired,
  primaryHoverImage: string,
  prodImage: string,
  modelImage: string,
  lifestyleImage: string
});var mySavesItemType = PropTypes.shape({
  id: PropTypes.shape({
    productId: PropTypes.string,
    kic: PropTypes.string,
    sku: PropTypes.string
  })
});var priceType = shape({
  description: string.isRequired,
  discountPrice: string,
  discountText: string,
  originalPrice: string.isRequired,
  variant: string.isRequired
});var promoMessageType = shape({
  type: string,
  message: string
});var swatchType = shape({
  id: string,
  name: string,
  product: shape({
    id: string,
    imageSet: imageSetType
  }),
  swatchImage: string
});var productType = shape({
  id: string.isRequired,
  imageSet: imageSetType.isRequired,
  name: string.isRequired,
  price: priceType.isRequired,
  promoMessaging: promoMessageType,
  badges: arrayOf(shape({
    text: string,
    theme: string
  })),
  collection: string,
  defaultSwatchSequence: string,
  departmentName: string,
  kic: string,
  memberPrice: priceType,
  partNumber: string,
  similarKeyword: string,
  productPageUrl: string,
  shortDescriptors: arrayOf(string),
  socialProofMessage: string,
  swatchList: arrayOf(swatchType)
});var productCardSharedProps = {
  algonomyOnClickAnalytics: PropTypes.shape({
    placementObj: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      treatments: PropTypes.arrayOf(PropTypes.shape({
        control: PropTypes.bool,
        testId: PropTypes.number,
        testType: PropTypes.string,
        treatmentId: PropTypes.string,
        treatmentName: PropTypes.string
      })).isRequired
    }),
    productIndex: PropTypes.number
  }),
  brand: PropTypes.string.isRequired,
  className: PropTypes.string,
  clickBehavior: productCardClickBehaviorType,
  deferImageLoad: PropTypes.bool,
  hadSwatchInteraction: PropTypes.bool,
  imageHostName: PropTypes.string.isRequired,
  isDesktop: PropTypes.bool,
  isMfeQuickview: PropTypes.bool,
  isMiniGrid: PropTypes.bool,
  isMiniGridSpotlightCard: PropTypes.bool,
  noImageFoundImgUrl: PropTypes.string.isRequired,
  onSwatchInteraction: PropTypes.func,
  product: productType.isRequired,
  shouldSetVisitedProduct: PropTypes.bool
};
var productCardDataWrapperProps = _objectSpread2(_objectSpread2({}, productCardSharedProps), {}, {
  mySavesItems: mySavesItemType,
  refetch: PropTypes.func,
  store: PropTypes.string.isRequired,
  storeId: PropTypes.string.isRequired
});
var productCardProps = _objectSpread2(_objectSpread2({}, productCardSharedProps), {}, {
  categoryId: PropTypes.string,
  handleSavesClick: PropTypes.func.isRequired,
  text: PropTypes.shape({
    elementChangeWarning: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    }),
    quickViewLabel: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    }),
    saveButtonSave: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    }),
    saveButtonSaved: PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    })
  }).isRequired
});
var productCardButtons = {
  isSaved: PropTypes.bool,
  onQuickViewClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  showQuickView: PropTypes.bool,
  isDesktop: PropTypes.bool
};
var productCardImages = {
  forceLifestyleImage: PropTypes.bool,
  imageSet: imageSetType.isRequired,
  hoveredSwatch: swatchType,
  imageHostName: PropTypes.string,
  noImageFoundImgUrl: PropTypes.string,
  onClick: PropTypes.func,
  productName: PropTypes.string,
  productPageUrl: PropTypes.string,
  selectedSwatchName: PropTypes.string,
  showPlaceholder: PropTypes.bool
};
var productDetailsSection = {
  badges: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    theme: PropTypes.string
  })),
  memberPrice: priceType,
  price: priceType,
  productName: PropTypes.string,
  promoMessaging: promoMessageType,
  shortDescriptors: PropTypes.arrayOf(PropTypes.string),
  brand: PropTypes.string,
  departmentName: PropTypes.string,
  handleProductCardClick: PropTypes.func,
  productPageUrl: PropTypes.string
};
var productSwatches = {
  handleSwatchHover: PropTypes.func,
  imageHostName: PropTypes.string,
  isDesktop: PropTypes.bool,
  limitSwatches: PropTypes.bool,
  productId: PropTypes.string,
  productName: PropTypes.string,
  productPageUrl: PropTypes.string,
  showPlaceholder: PropTypes.bool,
  swatchList: PropTypes.arrayOf(swatchType)
};
var socialProofBadge = {
  socialProofMessage: PropTypes.string,
  brand: PropTypes.string,
  isDesktop: PropTypes.bool
};
var swatchTileGroup = {
  children: PropTypes.node.isRequired,
  legend: PropTypes.node.isRequired,
  hasVisibleLegend: PropTypes.bool,
  horizontalAlignment: PropTypes.oneOf(['left', 'center', 'right']),
  layout: PropTypes.oneOf(['', '2-up', '3-up', '4-up', '5-up', '6-up']),
  size: PropTypes.oneOf(['default', 'small']),
  verticalAlignment: PropTypes.oneOf(['top', 'middle', 'bottom'])
};
var swatchTile = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  image: PropTypes.string,
  isChecked: PropTypes.bool,
  /** Makes label into screen-reader text. To be replaced with aria-label on <input>.
     */
  isLabelVisible: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  showPlaceholder: PropTypes.bool,
  state: PropTypes.string,
  handleSwatchHover: PropTypes.func,
  swatch: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    product: PropTypes.shape({
      id: PropTypes.string,
      imageSet: PropTypes.shape({
        primaryFaceOutImage: PropTypes.string
      })
    })
  })
};
var productCardShortDescriptor = {
  brand: PropTypes.string,
  departmentName: PropTypes.string,
  shortDescriptors: PropTypes.arrayOf(PropTypes.string).isRequired
};
var productCardBadge = {
  text: PropTypes.string.isRequired,
  theme: PropTypes.string
};
var productCardDetails = {
  price: priceType,
  productName: PropTypes.string,
  promoMessaging: promoMessageType,
  memberPrice: priceType,
  productNameSize: PropTypes.string
};
var productCardLink = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func
};
var productCardQuickviewButton = {
  onClick: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool
};function ProductCardQuickviewButton(_ref) {
  var onClick = _ref.onClick,
    isDesktop = _ref.isDesktop,
    label = _ref.label;
  var icon = 'zoom';
  var _useBreakpointSizes = useBreakpointSizes(),
    small = _useBreakpointSizes.small,
    medium = _useBreakpointSizes.medium;
  if (medium) {
    return /*#__PURE__*/React.createElement(Button, {
      classList: "product-card__button--qv-aui ".concat(style.quickview),
      onClick: onClick,
      theme: "inverse",
      variant: "overlay"
    }, isDesktop ? /*#__PURE__*/React.createElement("span", {
      "data-icon": icon
    }) : null, /*#__PURE__*/React.createElement("span", {
      "data-aui": "product-card-qv-button-text"
    }, label));
  }
  if (small) {
    return /*#__PURE__*/React.createElement(IconButton, {
      classList: "product-card__button--qv-aui",
      icon: icon,
      labelText: label,
      onClick: onClick,
      theme: "inverse"
    });
  }
  return null;
}
ProductCardQuickviewButton.propTypes = productCardQuickviewButton;function ProductCardSaveButton(_ref) {
  var saved = _ref.saved,
    onClick = _ref.onClick,
    saveLabel = _ref.saveLabel,
    savedLabel = _ref.savedLabel;
  var className = classNames('product-my-saves', style.save);
  var dataState = saved ? 'saved' : 'unsaved';
  var label = saved ? savedLabel : saveLabel;
  var icon = saved ? 'heart-filled' : 'heart';
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-state": dataState,
    "data-testid": "catalog-product-card-save-button"
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: icon,
    labelText: label,
    onClick: onClick,
    theme: "inverse"
  }));
}
ProductCardSaveButton.propTypes = {
  saved: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  saveLabel: PropTypes.string.isRequired,
  savedLabel: PropTypes.string.isRequired
};function ProductCardButtons(_ref) {
  var _ref$isSaved = _ref.isSaved,
    isSaved = _ref$isSaved === void 0 ? false : _ref$isSaved,
    _ref$onQuickViewClick = _ref.onQuickViewClick,
    onQuickViewClick = _ref$onQuickViewClick === void 0 ? function () {} : _ref$onQuickViewClick,
    _ref$onSaveClick = _ref.onSaveClick,
    onSaveClick = _ref$onSaveClick === void 0 ? function () {} : _ref$onSaveClick,
    _ref$showQuickView = _ref.showQuickView,
    showQuickView = _ref$showQuickView === void 0 ? true : _ref$showQuickView,
    _ref$isDesktop = _ref.isDesktop,
    isDesktop = _ref$isDesktop === void 0 ? false : _ref$isDesktop,
    quickViewLabel = _ref.quickViewLabel,
    saveLabel = _ref.saveLabel,
    savedLabel = _ref.savedLabel;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProductCardSaveButton, {
    onClick: onSaveClick,
    saved: isSaved,
    saveLabel: saveLabel.value,
    savedLabel: savedLabel.value
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames(style.buttons, {
      'screen-reader-text': !showQuickView
    }),
    "data-aui": "product-card-buttons",
    "data-testid": "catalog-product-card-quickview-button"
  }, /*#__PURE__*/React.createElement(ProductCardQuickviewButton, {
    onClick: onQuickViewClick,
    isDesktop: isDesktop,
    label: quickViewLabel.value
  })));
}
ProductCardButtons.propTypes = productCardButtons;/**
 * Constructs an image URL with optional image size parameter.
 *
 * @param {string} imageHostName - The image hostname prefix to the URL
 * @param {string} imageId - The image identifier such as KIC_XXX_XXX_XXX.
 * @param {string} [imageSize] - The desired image size such as 'medium' or 'small'.
 * @returns {string} The generated image URL.
 */
var getImageUrl = function getImageUrl(imageHostName, imageId, imageSize) {
  var imageUrl = "".concat(imageHostName, "/is/image/anf/").concat(imageId, "?");
  var params = new URLSearchParams();
  params.append('policy', "product-".concat(imageSize !== null && imageSize !== void 0 ? imageSize : IMAGE_SIZE_POLICY.MEDIUM));
  return imageUrl + params.toString();
};// https://stackoverflow.com/questions/9815762/detect-when-an-image-fails-to-load-in-javascript
var tryImageLoad = function tryImageLoad(url) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.addEventListener('load', function () {
      return resolve();
    });
    img.addEventListener('error', function () {
      return reject();
    });
    img.src = url;
  });
};function ProductCardImages(_ref) {
  var _ref$forceLifestyleIm = _ref.forceLifestyleImage,
    forceLifestyleImage = _ref$forceLifestyleIm === void 0 ? false : _ref$forceLifestyleIm,
    _ref$hoveredSwatch = _ref.hoveredSwatch,
    hoveredSwatch = _ref$hoveredSwatch === void 0 ? null : _ref$hoveredSwatch,
    _ref$imageSet = _ref.imageSet,
    primaryFaceOutImage = _ref$imageSet.primaryFaceOutImage,
    primaryHoverImage = _ref$imageSet.primaryHoverImage,
    prodImage = _ref$imageSet.prodImage,
    lifestyleImage = _ref$imageSet.lifestyleImage,
    _ref$imageHostName = _ref.imageHostName,
    imageHostName = _ref$imageHostName === void 0 ? '' : _ref$imageHostName,
    _ref$noImageFoundImgU = _ref.noImageFoundImgUrl,
    noImageFoundImgUrl = _ref$noImageFoundImgU === void 0 ? '' : _ref$noImageFoundImgU,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$productName = _ref.productName,
    productName = _ref$productName === void 0 ? '' : _ref$productName,
    _ref$productPageUrl = _ref.productPageUrl,
    productPageUrl = _ref$productPageUrl === void 0 ? null : _ref$productPageUrl,
    _ref$selectedSwatchNa = _ref.selectedSwatchName,
    selectedSwatchName = _ref$selectedSwatchNa === void 0 ? null : _ref$selectedSwatchNa,
    _ref$showPlaceholder = _ref.showPlaceholder,
    showPlaceholder = _ref$showPlaceholder === void 0 ? false : _ref$showPlaceholder;
  var productCardLink = useRef(null);
  var primaryImageRef = useRef();
  var secondaryImageRef = useRef();
  var hasHoverImage = primaryHoverImage !== primaryFaceOutImage;

  // if we have no hope of displaying these images let's not even try
  if (!noImageFoundImgUrl || !imageHostName) return null;
  var computedPrimaryFaceOutImage = function computedPrimaryFaceOutImage() {
    if (forceLifestyleImage) {
      return lifestyleImage || primaryFaceOutImage;
    }
    return primaryFaceOutImage;
  };
  // Try prodImage, otherwise use the No Image Found image
  // Choosing not to tryImageLoad elsewhere because
  // most of the time images should load successfully
  var handleOnError = function handleOnError(imageRef) {
    var currentImageRef = imageRef.current;
    if (!currentImageRef) return;
    currentImageRef.onerror = null; // prevents looping
    var prodImageUrl = getImageUrl(imageHostName, prodImage, IMAGE_SIZE_POLICY.MEDIUM);
    tryImageLoad(prodImageUrl).then(function () {
      currentImageRef.src = prodImageUrl;
    })["catch"](function () {
      tryImageLoad(noImageFoundImgUrl).then(function () {
        currentImageRef.src = noImageFoundImgUrl;
      })
      // eslint-disable-next-line no-console
      ["catch"](function () {
        return console.log('No image could be loaded');
      });
    });
  };
  var computeImageUrl = function computeImageUrl(isPrimary) {
    var imageId;
    if (hoveredSwatch) {
      imageId = hoveredSwatch.product.imageSet.primaryFaceOutImage;
    } else {
      imageId = !isPrimary && primaryHoverImage ? primaryHoverImage : computedPrimaryFaceOutImage();
    }
    return showPlaceholder ? SMALLEST_POSSIBLE_BLANK_IMAGE : getImageUrl(imageHostName, imageId, IMAGE_SIZE_POLICY.MEDIUM);
  };
  var computeAltText = function computeAltText(isPrimary) {
    var altText = productName;
    if (hoveredSwatch) {
      altText = "".concat(productName, ", ").concat(hoveredSwatch.name);
    } else if (selectedSwatchName) {
      altText = "".concat(productName, ", ").concat(selectedSwatchName);
    }
    return "".concat(altText, " view ").concat(isPrimary ? '1' : '2');
  };
  var computeDataAuiText = function computeDataAuiText(isPrimary) {
    var dataAuiText = '';
    if (isPrimary) {
      dataAuiText = 'product-card-image';
    } else {
      dataAuiText = hoveredSwatch ? 'product-card-hovered-swatch-image' : 'product-card-hover-image';
    }
    return dataAuiText;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(hasHoverImage ? style.hasHoverImage : '')
  }, /*#__PURE__*/React.createElement("a", {
    ref: productCardLink,
    href: addUrlParameters(productPageUrl, PRODUCT_CARD_URL_ANALYTICS_PARAMETERS),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("img", {
    ref: primaryImageRef,
    alt: computeAltText(true),
    className: style.productCardImage_1,
    "data-aui": computeDataAuiText(true),
    "data-testid": "catalog-product-card-image",
    onError: function onError() {
      return handleOnError(primaryImageRef);
    },
    src: computeImageUrl(true),
    width: "400"
  }), hasHoverImage && /*#__PURE__*/React.createElement("img", {
    ref: secondaryImageRef,
    alt: computeAltText(false),
    className: style.productCardImage_2,
    "data-aui": computeDataAuiText(false),
    onError: function onError() {
      return handleOnError(secondaryImageRef);
    },
    src: computeImageUrl(false),
    width: "400"
  })));
}
ProductCardImages.propTypes = productCardImages;function ProductCardBadge(_ref) {
  var text = _ref.text,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? undefined : _ref$theme;
  return /*#__PURE__*/React.createElement("div", {
    className: theme === 'earlyAccess' ? style.earlyAccessBadge : style.defaultBadge
  }, text);
}
ProductCardBadge.propTypes = productCardBadge;function ProductCardBadges(_ref) {
  var badges = _ref.badges;
  var badgeElements = [];
  badges.forEach(function (_ref2) {
    var text = _ref2.text,
      theme = _ref2.theme;
    // Omit badges with insufficient data
    if (text && theme) {
      badgeElements.push( /*#__PURE__*/React.createElement(React.Fragment, {
        key: text
      }, badgeElements.length > 0 && /*#__PURE__*/React.createElement("span", {
        className: style.badgeSeparator
      }, ' | '), /*#__PURE__*/React.createElement(ProductCardBadge, {
        text: text,
        theme: theme
      })));
    }
  });
  if (badgeElements.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.badges)
  }, badgeElements);
}
ProductCardBadges.propTypes = {
  badges: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    theme: PropTypes.string
  })).isRequired
};function ProductCardDetails(_ref) {
  var _ref$memberPrice = _ref.memberPrice,
    memberPrice = _ref$memberPrice === void 0 ? undefined : _ref$memberPrice,
    price = _ref.price,
    _ref$productName = _ref.productName,
    productName = _ref$productName === void 0 ? '' : _ref$productName,
    _ref$promoMessaging = _ref.promoMessaging,
    promoMessaging = _ref$promoMessaging === void 0 ? undefined : _ref$promoMessaging,
    _ref$productNameSize = _ref.productNameSize,
    productNameSize = _ref$productNameSize === void 0 ? undefined : _ref$productNameSize;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProductName, {
    size: productNameSize
  }, /*#__PURE__*/React.createElement("h2", {
    "data-aui": "product-card-name",
    "data-testid": "catalog-product-card-name"
  }, productName)), /*#__PURE__*/React.createElement(ProductPrice, {
    description: price.description,
    discountPrice: price === null || price === void 0 ? void 0 : price.discountPrice,
    discountText: price === null || price === void 0 ? void 0 : price.discountText,
    originalPrice: price.originalPrice,
    variant: price.variant
  }), memberPrice && /*#__PURE__*/React.createElement(ProductPrice, {
    description: memberPrice.description,
    discountText: memberPrice.discountText,
    originalPrice: memberPrice.originalPrice,
    variant: memberPrice.variant
  }), (promoMessaging === null || promoMessaging === void 0 ? void 0 : promoMessaging.message) && /*#__PURE__*/React.createElement(ProductDetail, {
    variant: "small"
  }, /*#__PURE__*/React.createElement("div", {
    className: "promo-badge"
  }, /*#__PURE__*/React.createElement("span", {
    className: "promo-info--".concat(promoMessaging.type === 'tiered' ? 'bogo' : promoMessaging.type)
  }, promoMessaging.message))));
}
ProductCardDetails.propTypes = productCardDetails;function ProductCardLink(_ref) {
  var children = _ref.children,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    url = _ref.url;
  return /*#__PURE__*/React.createElement("a", {
    className: style['product-content-link'],
    href: addUrlParameters(url, PRODUCT_CARD_URL_ANALYTICS_PARAMETERS),
    onClick: onClick
  }, children);
}
ProductCardLink.propTypes = productCardLink;function ProductCardShortDescriptor(_ref) {
  var shortDescriptors = _ref.shortDescriptors;
  return /*#__PURE__*/React.createElement(ProductDetail, {
    variant: "small"
  }, shortDescriptors.join(' | '));
}
ProductCardShortDescriptor.propTypes = productCardShortDescriptor;function ProductDetailsSection(_ref) {
  var badges = _ref.badges,
    memberPrice = _ref.memberPrice,
    price = _ref.price,
    productName = _ref.productName,
    promoMessaging = _ref.promoMessaging,
    shortDescriptors = _ref.shortDescriptors,
    brand = _ref.brand,
    departmentName = _ref.departmentName,
    handleProductCardClick = _ref.handleProductCardClick,
    productPageUrl = _ref.productPageUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: style['product-details-wrapper']
  }, /*#__PURE__*/React.createElement(ProductCardLink, {
    onClick: handleProductCardClick,
    url: productPageUrl
  }, /*#__PURE__*/React.createElement(ProductCardBadges, {
    badges: badges !== null && badges !== void 0 ? badges : []
  }), /*#__PURE__*/React.createElement(ProductCardDetails, {
    memberPrice: memberPrice,
    price: price,
    productName: productName,
    promoMessaging: promoMessaging
  }), (shortDescriptors === null || shortDescriptors === void 0 ? void 0 : shortDescriptors.length) > 0 && /*#__PURE__*/React.createElement(ProductCardShortDescriptor, {
    brand: brand,
    departmentName: departmentName,
    shortDescriptors: shortDescriptors
  })));
}
ProductDetailsSection.propTypes = productDetailsSection;function SwatchTile(_ref) {
  var id = _ref.id,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? undefined : _ref$image,
    _ref$isChecked = _ref.isChecked,
    isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
    _ref$isLabelVisible = _ref.isLabelVisible,
    isLabelVisible = _ref$isLabelVisible === void 0 ? true : _ref$isLabelVisible,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? undefined : _ref$label,
    name = _ref.name,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? undefined : _ref$onChange,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? undefined : _ref$onClick,
    _ref$showPlaceholder = _ref.showPlaceholder,
    showPlaceholder = _ref$showPlaceholder === void 0 ? true : _ref$showPlaceholder,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? undefined : _ref$state,
    type = _ref.type,
    value = _ref.value,
    swatch = _ref.swatch,
    handleSwatchHover = _ref.handleSwatchHover;
  var preLoadedImage = showPlaceholder ? SMALLEST_POSSIBLE_BLANK_IMAGE : image;
  var inputBehaviorProp = typeof onChange === 'function' ? {
    onChange: onChange
  } : {
    readOnly: true
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "swtg-input-inner-wrapper",
    "data-state": state,
    "data-testid": "catalog-product-card-swatch-tile",
    onBlur: function onBlur() {
      return handleSwatchHover(null);
    },
    onFocus: function onFocus() {
      return handleSwatchHover(swatch);
    },
    onMouseOut: function onMouseOut() {
      return handleSwatchHover(null);
    },
    onMouseOver: function onMouseOver() {
      return handleSwatchHover(swatch);
    }
  }, /*#__PURE__*/React.createElement("input", _extends({
    checked: isChecked,
    className: "swtg-input",
    id: id,
    name: name,
    onClick: onClick,
    type: type,
    value: value
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, inputBehaviorProp)), /*#__PURE__*/React.createElement("div", {
    className: "swtg-input-tile-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "swtg-image-outer-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "swtg-image-inner-wrapper",
    style: isChecked ? {
      border: '2px solid #374e62'
    } : {}
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    "data-testid": "catalog-product-card-swatch-tile-image",
    src: preLoadedImage,
    width: "19"
  }))), /*#__PURE__*/React.createElement("label", {
    className: label && isLabelVisible ? 'swtg-label' : 'screen-reader-text',
    "data-label-visible": label && isLabelVisible ? 'true' : 'false',
    htmlFor: id
  }, label)));
}
SwatchTile.propTypes = swatchTile;/**
 * A React component for rendering HTML content from TMNTs.
 *
 * **Important:** User-provided data must never be passed to this component
 *
 * @param {Object} props - The component props.
 * @param {string} props.property - The TMNT key.
 * @param {string} props.value - The HTML string to be rendered.
 * @returns {JSX.Element} A span element with the rendered HTML content.
 */
function TmntHtml(_ref) {
  var property = _ref.property,
    value = _ref.value;
  return /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: value
    },
    "data-property": property
  });
}
TmntHtml.propTypes = {
  property: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};function SwatchTileGroup(_ref) {
  var children = _ref.children,
    elementChangeWarning = _ref.elementChangeWarning,
    _ref$hasVisibleLegend = _ref.hasVisibleLegend,
    hasVisibleLegend = _ref$hasVisibleLegend === void 0 ? false : _ref$hasVisibleLegend,
    _ref$horizontalAlignm = _ref.horizontalAlignment,
    horizontalAlignment = _ref$horizontalAlignm === void 0 ? null : _ref$horizontalAlignm,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? null : _ref$layout,
    legend = _ref.legend,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    _ref$verticalAlignmen = _ref.verticalAlignment,
    verticalAlignment = _ref$verticalAlignmen === void 0 ? null : _ref$verticalAlignmen;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    "aria-live": "assertive",
    className: "screen-reader-text"
  }, /*#__PURE__*/React.createElement(TmntHtml, {
    property: elementChangeWarning.key || '',
    value: elementChangeWarning.value || ''
  })), /*#__PURE__*/React.createElement("div", {
    className: "swatch-tile-group",
    "data-horizontal-alignment": horizontalAlignment,
    "data-layout": layout,
    "data-size": size,
    "data-testid": "swatch-tile-group",
    "data-vertical-alignment": verticalAlignment
  }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: hasVisibleLegend ? 'h4' : 'screen-reader-text'
  }, legend), /*#__PURE__*/React.createElement("div", {
    className: "swtg-input-outer-wrapper",
    "data-testid": "swtg-input-outer-wrapper"
  }, children))));
}
SwatchTileGroup.propTypes = swatchTileGroup;var DESKTOP_SWATCH_LIMIT = 6;
var MOBILE_SWATCH_LIMIT = 4;
var getSwatchLimit = function getSwatchLimit(isDesktop) {
  return isDesktop ? DESKTOP_SWATCH_LIMIT : MOBILE_SWATCH_LIMIT;
};function ProductSwatches(_ref) {
  var _ref$handleSwatchHove = _ref.handleSwatchHover,
    handleSwatchHover = _ref$handleSwatchHove === void 0 ? function () {} : _ref$handleSwatchHove,
    elementChangeWarning = _ref.elementChangeWarning,
    imageHostName = _ref.imageHostName,
    _ref$isDesktop = _ref.isDesktop,
    isDesktop = _ref$isDesktop === void 0 ? false : _ref$isDesktop,
    _ref$limitSwatches = _ref.limitSwatches,
    limitSwatches = _ref$limitSwatches === void 0 ? false : _ref$limitSwatches,
    productPageUrl = _ref.productPageUrl,
    productId = _ref.productId,
    productName = _ref.productName,
    _ref$showPlaceholder = _ref.showPlaceholder,
    showPlaceholder = _ref$showPlaceholder === void 0 ? true : _ref$showPlaceholder,
    swatchList = _ref.swatchList,
    handleSwatchClick = _ref.handleSwatchClick;
  var swatchLimit = getSwatchLimit(isDesktop);
  var swatchTiles = swatchList.map(function (swatch) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: swatch.id
    }, imageHostName && /*#__PURE__*/React.createElement(SwatchTile, {
      handleSwatchHover: handleSwatchHover,
      id: "".concat(productId, "__").concat(swatch.id, "__swatch"),
      image: getImageUrl(imageHostName, swatch.swatchImage, IMAGE_SIZE_POLICY.XSMALL),
      isChecked: swatch.product.id === productId,
      isLabelVisible: false,
      label: "".concat(swatch.name, " swatch"),
      name: productId,
      onClick: function onClick(e) {
        return handleSwatchClick(e.currentTarget.value);
      },
      showPlaceholder: showPlaceholder,
      swatch: swatch,
      type: "button",
      value: swatch.product.id
    }));
  });
  var getAdditionalSwatchCount = function getAdditionalSwatchCount() {
    var additionalSwatchText = "+".concat(swatchList.length - swatchLimit);
    return isDesktop ? /*#__PURE__*/React.createElement("div", {
      className: style.swatchLength
    }, additionalSwatchText) : /*#__PURE__*/React.createElement("a", {
      className: style.swatchLength,
      href: productPageUrl
    }, additionalSwatchText);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(style.swatches),
    "data-aui": "product-card-swatches"
  }, /*#__PURE__*/React.createElement(SwatchTileGroup, {
    legend: "".concat(productName, " swatches"),
    elementChangeWarning: elementChangeWarning
  }, swatchTiles.slice(0, limitSwatches ? Math.min(swatchLimit, swatchTiles.length) : swatchTiles.length), limitSwatches && swatchList.length > swatchLimit && getAdditionalSwatchCount()));
}
ProductSwatches.propTypes = productSwatches;function SocialProofBadge(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'anf' : _ref$brand,
    _ref$isDesktop = _ref.isDesktop,
    isDesktop = _ref$isDesktop === void 0 ? false : _ref$isDesktop,
    _ref$socialProofMessa = _ref.socialProofMessage,
    socialProofMessage = _ref$socialProofMessa === void 0 ? '' : _ref$socialProofMessa;
  if (!socialProofMessage || brand === 'hol' && !isDesktop) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: style.socialProofingBadgeContainer
  }, /*#__PURE__*/React.createElement(Badge, null, /*#__PURE__*/React.createElement(Icon, {
    icon: "flame-filled"
  }), socialProofMessage));
}
SocialProofBadge.propTypes = socialProofBadge;/**
 * The purpose of this to resolve SSR issue with some code that relies on window being defined.
 */

var win;
if (typeof window !== 'undefined') {
  win = window;
} else {
  // NOTE: we may need to put some stuff in here in the future
  win = {};
}
var $window = win;/**
 * Get the current page type from $window.digitalData
 * Only be called from an event handler
 * Otherwise needs to be wrapped in a useEffect
 * @returns {String} Name of current page type
 */
var getPageType = function getPageType() {
  var _$window$digitalData;
  var pageType = $window === null || $window === void 0 || (_$window$digitalData = $window.digitalData) === null || _$window$digitalData === void 0 ? void 0 : _$window$digitalData.get('page.pageKind' );
  return typeof pageType === 'string' ? pageType.replace(/ /g, '_') : '';
};var buildTreatments = function buildTreatments(treatment) {
  var _treatment$control, _treatment$testId;
  return _objectSpread2(_objectSpread2({}, treatment), {}, {
    control: (_treatment$control = treatment.control) !== null && _treatment$control !== void 0 ? _treatment$control : '',
    testId: (_treatment$testId = treatment.testId) !== null && _treatment$testId !== void 0 ? _treatment$testId : ''
  });
};
var runAnalyticsForQuickView = function runAnalyticsForQuickView(_ref) {
  var _placementObj$treatme, _placementObj$treatme2;
  var placementObj = _ref.placementObj,
    productIndex = _ref.productIndex;
  if (!placementObj || typeof productIndex === 'undefined') {
    return;
  }
  var analyticsData = collectOnClickAnalyticsData({
    id: placementObj.id,
    name: placementObj.name,
    treatments: (_placementObj$treatme = (_placementObj$treatme2 = placementObj.treatments) === null || _placementObj$treatme2 === void 0 ? void 0 : _placementObj$treatme2.map(buildTreatments)) !== null && _placementObj$treatme !== void 0 ? _placementObj$treatme : []
  }, productIndex);
  runAnalyticsOnClick(analyticsData);
};var dataText = 'swatch_hover';
var eventType = 'click';
var triggerDigitalData = function triggerDigitalData(eventName) {
  var eventDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $window.digitalData.trigger(eventName, eventDetails);
};
var setDigitalData = function setDigitalData(dataKey, data) {
  $window.digitalData.set(dataKey, data);
};
var triggerHoverAnalytics = function triggerHoverAnalytics() {
  triggerDigitalData("".concat(getPageType(), "_").concat(dataText, "_").concat(eventType), {
    event_type: eventType,
    data_text: dataText,
    data_action: 'hover'
  });
};
var triggerQuickviewAnalytics = function triggerQuickviewAnalytics(_ref) {
  var algonomyOnClickAnalytics = _ref.algonomyOnClickAnalytics,
    categoryId = _ref.categoryId,
    isMiniGrid = _ref.isMiniGrid,
    socialProofMessage = _ref.socialProofMessage,
    isMfeQuickview = _ref.isMfeQuickview;
  runAnalyticsForQuickView(algonomyOnClickAnalytics);
  if (!isMfeQuickview) {
    if (socialProofMessage) {
      setDigitalData('product.afSource', 'social proofing');
    } else {
      // Unset data in case it was set previously
      setDigitalData('product.afSource', undefined);
    }
    if (isMiniGrid && categoryId) {
      setDigitalData('product.productViewMethod', "mini grid - ".concat(categoryId));
      setDigitalData('page.pageViewMethod', 'modal - quick view');
      var analyticsQVEvent = new CustomEvent('analytics.quick_view');
      triggerDigitalData(analyticsQVEvent);
    }
  }
};
var triggerMiniGridAnalytics = function triggerMiniGridAnalytics(categoryId) {
  setDigitalData('product.productViewMethod', "mini grid - ".concat(categoryId));
  setDigitalData('page.pageViewMethod', 'page load');
  var analyticsPDEvent = new CustomEvent('analytics.product_detail');
  triggerDigitalData(analyticsPDEvent);
};var loadImage = function loadImage() {
  var imageUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var fetchPriority = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return new Promise(function (resolve, reject) {
    var img = document.createElement('img');
    if (fetchPriority) img.fetchPriority = fetchPriority;
    img.onload = function () {
      resolve(img);
    };
    img.onerror = function () {
      reject(imageUrl);
    };
    img.onabort = function () {
      reject(imageUrl);
    };
    img.src = imageUrl;
  });
};

// https://stackoverflow.com/questions/42615556/how-to-preload-images-in-react-js
// Added fetchPriority to try to make sure PFO images load before others on scroll
var loadImages = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var imageUrls,
      fetchPriority,
      imagePromises,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          imageUrls = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
          fetchPriority = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
          imagePromises = [];
          imageUrls.forEach(function (imageUrl) {
            imagePromises.push(loadImage(imageUrl, fetchPriority));
          });
          return _context.abrupt("return", Promise.allSettled(imagePromises));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadImages() {
    return _ref.apply(this, arguments);
  };
}();var isBrowser = typeof window !== 'undefined';var useIntersection = function useIntersection(ref, options) {
  var _a = useState(null),
    intersectionObserverEntry = _a[0],
    setIntersectionObserverEntry = _a[1];
  useEffect(function () {
    if (ref.current && typeof IntersectionObserver === 'function') {
      var handler = function handler(entries) {
        setIntersectionObserverEntry(entries[0]);
      };
      var observer_1 = new IntersectionObserver(handler, options);
      observer_1.observe(ref.current);
      return function () {
        setIntersectionObserverEntry(null);
        observer_1.disconnect();
      };
    }
    return function () {};
  }, [ref.current, options.threshold, options.root, options.rootMargin]);
  return intersectionObserverEntry;
};var useSessionStorage = function useSessionStorage(key, initialValue, raw) {
  if (!isBrowser) {
    return [initialValue, function () {}];
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var _a = useState(function () {
      try {
        var sessionStorageValue = sessionStorage.getItem(key);
        if (typeof sessionStorageValue !== 'string') {
          sessionStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue));
          return initialValue;
        } else {
          return raw ? sessionStorageValue : JSON.parse(sessionStorageValue || 'null');
        }
      } catch (_a) {
        // If user is in private mode or has storage restriction
        // sessionStorage can throw. JSON.parse and JSON.stringify
        // can throw, too.
        return initialValue;
      }
    }),
    state = _a[0],
    setState = _a[1];
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(function () {
    try {
      var serializedState = raw ? String(state) : JSON.stringify(state);
      sessionStorage.setItem(key, serializedState);
    } catch (_a) {
      // If user is in private mode or has storage restriction
      // sessionStorage can throw. Also JSON.stringify can throw.
    }
  });
  return [state, setState];
};var useFirstScrollIntoView = function useFirstScrollIntoView(onFirstScrollIntoView) {
  var ref = useRef();
  var intersection = useIntersection(ref, {
    root: null,
    rootMargin: "".concat(SCROLL_THRESHOLD, " 0px ").concat(SCROLL_THRESHOLD, " 0px"),
    threshold: 0
  });
  var hasScrolledIntoView = useRef();
  useEffect(function () {
    if (!hasScrolledIntoView.current && intersection !== null && intersection !== void 0 && intersection.isIntersecting && onFirstScrollIntoView) {
      onFirstScrollIntoView();
      hasScrolledIntoView.current = true;
    }
  }, [intersection, onFirstScrollIntoView]);
  return {
    ref: ref
  };
};var useImagePreloading = function useImagePreloading(swatchList, imageHostName, imageSet, setIsHovered, setHeight, isDesktop) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imagesLoaded = _useState2[0],
    setImagesLoaded = _useState2[1];
  var swatchLimit = getSwatchLimit(isDesktop);

  // On first scroll into view:
  // Load all swatch tile images
  // Load first `swatchLimit` swatch PFO images
  // Load product's PFO and PH images
  var _useFirstScrollIntoVi = useFirstScrollIntoView(imageHostName ? /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var swatchImageUrls, primaryFaceOutUrls, secondaryImageUrls;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            swatchImageUrls = [];
            if (isDesktop) {
              swatchList.forEach(function (swatch, index) {
                swatchImageUrls.push(getImageUrl(imageHostName, swatch.swatchImage, IMAGE_SIZE_POLICY.XSMALL));
                if (index < swatchLimit) {
                  swatchImageUrls.push(getImageUrl(imageHostName, swatch.product.imageSet.primaryFaceOutImage, IMAGE_SIZE_POLICY.MEDIUM));
                }
              });
            }
            primaryFaceOutUrls = [getImageUrl(imageHostName, imageSet.primaryFaceOutImage, IMAGE_SIZE_POLICY.MEDIUM)];
            secondaryImageUrls = [getImageUrl(imageHostName, imageSet.primaryHoverImage, IMAGE_SIZE_POLICY.MEDIUM)].concat(swatchImageUrls);
            Promise.allSettled([loadImages(primaryFaceOutUrls, 'High'), loadImages(secondaryImageUrls)]).then(function () {
              return setImagesLoaded(true);
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })) : null),
    productCardRef = _useFirstScrollIntoVi.ref;

  // On first hover or focus, load PFO images for remaining swatches
  var hasPreloadedAdditionalPrimaryImages = useRef(false);
  var preloadAdditionalPrimaryImages = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var swatchImageUrls;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(isDesktop && !hasPreloadedAdditionalPrimaryImages.current && imageHostName)) {
              _context2.next = 6;
              break;
            }
            hasPreloadedAdditionalPrimaryImages.current = true;
            swatchImageUrls = swatchList.slice(Math.min(swatchLimit, swatchList.length)).map(function (swatch) {
              return getImageUrl(imageHostName, swatch.product.imageSet.primaryFaceOutImage, IMAGE_SIZE_POLICY.MEDIUM);
            });
            _context2.next = 5;
            return loadImages(swatchImageUrls);
          case 5:
            setHeight(productCardRef.current.scrollHeight);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function preloadAdditionalPrimaryImages() {
      return _ref2.apply(this, arguments);
    };
  }();
  var setIsHoveredWithImagePreloading = function setIsHoveredWithImagePreloading(value) {
    if (value) {
      preloadAdditionalPrimaryImages();
    }
    setIsHovered(value);
  };
  return {
    productCardRef: productCardRef,
    setIsHoveredWithImagePreloading: setIsHoveredWithImagePreloading,
    imagesLoaded: imagesLoaded
  };
};var useQuickViewEvent = function useQuickViewEvent(_ref) {
  var algonomyOnClickAnalytics = _ref.algonomyOnClickAnalytics,
    isMfeQuickview = _ref.isMfeQuickview,
    isMiniGrid = _ref.isMiniGrid,
    categoryId = _ref.categoryId,
    _ref$product = _ref.product,
    collection = _ref$product.collection,
    defaultSwatchSequence = _ref$product.defaultSwatchSequence,
    productId = _ref$product.productId,
    imageSet = _ref$product.imageSet,
    productName = _ref$product.productName,
    socialProofMessage = _ref$product.socialProofMessage,
    brand = _ref.brand,
    faceoutImageType = _ref.faceoutImageType,
    setIsQuickviewOpen = _ref.setIsQuickviewOpen;
  var triggerQuickView = useCallback(function (event) {
    triggerQuickviewAnalytics({
      algonomyOnClickAnalytics: algonomyOnClickAnalytics,
      categoryId: categoryId,
      isMiniGrid: isMiniGrid,
      isMfeQuickview: isMfeQuickview,
      socialProofMessage: socialProofMessage
    });
    var quickviewEventOld = new CustomEvent('quickview:openModal', {
      detail: {
        productId: productId,
        collectionId: collection,
        seq: defaultSwatchSequence,
        productName: productName,
        imageId: imageSet.primaryFaceOutImage,
        productBrand: brand,
        faceout: faceoutImageType,
        returnFocus: event.currentTarget,
        origin: isMiniGrid ? 'mini grid' : '',
        categoryId: categoryId !== null && categoryId !== void 0 ? categoryId : '',
        afsource: socialProofMessage ? 'social proofing' : ''
      }
    });
    var quickviewEventNew = new CustomEvent('quickview:mfe:openModal', {
      detail: {
        productId: productId,
        collectionId: collection,
        seq: defaultSwatchSequence,
        returnFocus: event.currentTarget,
        faceout: faceoutImageType
      }
    });

    /**
     * There's a possibility that something goes wrong and the QV doesn't open,
     * which will mess up our state.
     * This is the best we can do since we're not getting any acknowledgement
     * as to whether or not the QV opened in response to our event.
     */
    setIsQuickviewOpen(true);
    try {
      window.digitalData.set('page.pageViewMethod', 'modal-quickview');
      window.digitalData.set('product.productViewMethod', 'navigation-grid');
      var qvEventDispatchTarget = isMfeQuickview ? document : $window;
      qvEventDispatchTarget.dispatchEvent(isMfeQuickview ? quickviewEventNew : quickviewEventOld);
    } catch (error) {
      // TODO: Log this?
      setIsQuickviewOpen(false);
    }
  }, [algonomyOnClickAnalytics, brand, categoryId, collection, defaultSwatchSequence, faceoutImageType, isMfeQuickview, imageSet.primaryFaceOutImage, isMiniGrid, productName, productId, socialProofMessage, setIsQuickviewOpen]);
  return {
    triggerQuickView: triggerQuickView
  };
};var useSwatchHover = function useSwatchHover(_ref) {
  var hoveredSwatchId = _ref.hoveredSwatchId,
    setHoveredSwatch = _ref.setHoveredSwatch,
    hadSwatchInteraction = _ref.hadSwatchInteraction,
    onSwatchInteraction = _ref.onSwatchInteraction;
  var handleSwatchHover = function handleSwatchHover(newHoveredSwatch) {
    var isDifferentSwatch = (newHoveredSwatch === null || newHoveredSwatch === void 0 ? void 0 : newHoveredSwatch.id) !== hoveredSwatchId;

    // Only update state if there is a new swatch
    // This is needed because object comparison (swatch vs swatch) is shallow
    if (isDifferentSwatch) {
      setHoveredSwatch(newHoveredSwatch);
    }
    if ($window.digitalData && newHoveredSwatch && isDifferentSwatch && !hadSwatchInteraction) {
      triggerHoverAnalytics();
      onSwatchInteraction();
    }
  };
  return {
    handleSwatchHover: handleSwatchHover
  };
};var useSetVisitedProduct = function useSetVisitedProduct(_ref) {
  var kic = _ref.kic,
    productPageUrl = _ref.productPageUrl;
  var _useSessionStorage = useSessionStorage('productToFocus', {}),
    _useSessionStorage2 = _slicedToArray(_useSessionStorage, 2),
    productToFocus = _useSessionStorage2[0],
    setProductToFocus = _useSessionStorage2[1];
  var setHistory = useCallback(function () {
    var historyState = _typeof(window.history.state) === 'object' && !!window.history.state ? window.history.state : {};
    window.history.replaceState(_objectSpread2(_objectSpread2({}, historyState), {}, {
      productToFocus: 'true'
    }), '', window.location.pathname + window.location.search);
  }, []);
  var handleOpenProduct = useCallback(function (event) {
    event.preventDefault();
    setHistory();
    setProductToFocus(_objectSpread2(_objectSpread2({}, productToFocus), {}, {
      productId: kic
    }));
    $window.location.href = productPageUrl;
  }, [kic, productPageUrl, setHistory, productToFocus, setProductToFocus]);
  return {
    handleOpenProduct: handleOpenProduct
  };
};/**
 * ProductCard component renders product cards with images, details, swatches, and action buttons.
 *
 * @param {Object} prop - the props object
 * @param {Object} props.algonomyOnClickAnalytics - Analytics data for Algonomy click events.
 * @param {string} props.brand - the brand
 * @param {string} props.categoryId - The category ID
 * @param {string} props.className - Additional class names for the product card
 * @param {string} props.clickBehavior - The click behavior for the product card
 * @param {boolean} props.deferImageLoad - Whether to defer image loading
 * @param {boolean} props.hadSwatchInteraction - Whether there was a swatch interaction
 * @param {Function} props.handleSavesClick - Callback for save button click
 * @param {Function} props.handleSwatchClick - Callback for swatch click
 * @param {string} props.imageHostName - The hostname for the product images
 * @param {boolean} props.isDesktop - Whether the view is in desktop or mobile
 * @param {boolean} props.isMiniGrid - Whether the product card is in a mini grid layout
 * @param {boolean} props.isMiniGridSpotlightCard - Checking for mini grid spotlight card
 * @param {boolean} props.isSaved - Whether the product is saved
 * @param {string} props.noImageFoundImgUrl - The URL for the "no image found" placeholder
 * @param {Function} props.onSwatchInteraction - Callback for swatch interaction
 * @param {Object} props.product - The product data
 * @param {Object} props.text - Translated text for the product card
 */
function ProductCard(_ref) {
  var _imageSet$primaryFace, _swatchList$find$name, _swatchList$find;
  var _ref$algonomyOnClickA = _ref.algonomyOnClickAnalytics,
    algonomyOnClickAnalytics = _ref$algonomyOnClickA === void 0 ? {} : _ref$algonomyOnClickA,
    brand = _ref.brand,
    _ref$categoryId = _ref.categoryId,
    categoryId = _ref$categoryId === void 0 ? '' : _ref$categoryId,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$clickBehavior = _ref.clickBehavior,
    clickBehavior = _ref$clickBehavior === void 0 ? CLICK_BEHAVIORS.productPage : _ref$clickBehavior,
    _ref$deferImageLoad = _ref.deferImageLoad,
    deferImageLoad = _ref$deferImageLoad === void 0 ? true : _ref$deferImageLoad,
    _ref$hadSwatchInterac = _ref.hadSwatchInteraction,
    hadSwatchInteraction = _ref$hadSwatchInterac === void 0 ? false : _ref$hadSwatchInterac,
    handleSavesClick = _ref.handleSavesClick,
    handleSwatchClick = _ref.handleSwatchClick,
    imageHostName = _ref.imageHostName,
    _ref$isDesktop = _ref.isDesktop,
    isDesktop = _ref$isDesktop === void 0 ? false : _ref$isDesktop,
    _ref$isMiniGrid = _ref.isMiniGrid,
    isMiniGrid = _ref$isMiniGrid === void 0 ? false : _ref$isMiniGrid,
    _ref$isMiniGridSpotli = _ref.isMiniGridSpotlightCard,
    isMiniGridSpotlightCard = _ref$isMiniGridSpotli === void 0 ? false : _ref$isMiniGridSpotli,
    _ref$isMfeQuickview = _ref.isMfeQuickview,
    isMfeQuickview = _ref$isMfeQuickview === void 0 ? false : _ref$isMfeQuickview,
    _ref$isSaved = _ref.isSaved,
    isSaved = _ref$isSaved === void 0 ? false : _ref$isSaved,
    noImageFoundImgUrl = _ref.noImageFoundImgUrl,
    _ref$onSwatchInteract = _ref.onSwatchInteraction,
    onSwatchInteraction = _ref$onSwatchInteract === void 0 ? function () {} : _ref$onSwatchInteract,
    _ref$product = _ref.product,
    badges = _ref$product.badges,
    collection = _ref$product.collection,
    defaultSwatchSequence = _ref$product.defaultSwatchSequence,
    departmentName = _ref$product.departmentName,
    productId = _ref$product.id,
    imageSet = _ref$product.imageSet,
    kic = _ref$product.kic,
    memberPrice = _ref$product.memberPrice,
    name = _ref$product.name,
    price = _ref$product.price,
    productPageUrl = _ref$product.productPageUrl,
    promoMessaging = _ref$product.promoMessaging,
    shortDescriptors = _ref$product.shortDescriptors,
    socialProofMessage = _ref$product.socialProofMessage,
    swatchList = _ref$product.swatchList,
    _ref$text = _ref.text,
    elementChangeWarning = _ref$text.elementChangeWarning,
    quickViewLabel = _ref$text.quickViewLabel,
    saveButtonSave = _ref$text.saveButtonSave,
    saveButtonSaved = _ref$text.saveButtonSaved,
    _ref$shouldSetVisited = _ref.shouldSetVisitedProduct,
    shouldSetVisitedProduct = _ref$shouldSetVisited === void 0 ? false : _ref$shouldSetVisited;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isQuickviewOpen = _useState4[0],
    setIsQuickviewOpen = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    hoveredSwatch = _useState6[0],
    setHoveredSwatch = _useState6[1];
  var faceoutImageType = (_imageSet$primaryFace = imageSet.primaryFaceOutImage) === null || _imageSet$primaryFace === void 0 ? void 0 : _imageSet$primaryFace.replace(/[A-Z\d\-_]/g, '');
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    height = _useState8[0],
    setHeight = _useState8[1];
  var _useImagePreloading = useImagePreloading(swatchList, imageHostName, imageSet, setIsHovered, setHeight, isDesktop),
    productCardRef = _useImagePreloading.productCardRef,
    setIsHoveredWithImagePreloading = _useImagePreloading.setIsHoveredWithImagePreloading,
    imagesLoaded = _useImagePreloading.imagesLoaded;
  var _useQuickView = useQuickViewEvent({
      algonomyOnClickAnalytics: algonomyOnClickAnalytics,
      brand: brand,
      categoryId: categoryId,
      faceoutImageType: faceoutImageType,
      isMiniGrid: isMiniGrid,
      isMfeQuickview: isMfeQuickview,
      product: {
        collection: collection,
        defaultSwatchSequence: defaultSwatchSequence,
        productId: productId,
        imageSet: imageSet,
        productName: name,
        socialProofMessage: socialProofMessage
      },
      setIsQuickviewOpen: setIsQuickviewOpen
    }),
    triggerQuickView = _useQuickView.triggerQuickView;
  var _useSwatchHover = useSwatchHover({
      hadSwatchInteraction: hadSwatchInteraction,
      hoveredSwatchId: hoveredSwatch === null || hoveredSwatch === void 0 ? void 0 : hoveredSwatch.id,
      onSwatchInteraction: onSwatchInteraction,
      setHoveredSwatch: setHoveredSwatch
    }),
    handleSwatchHover = _useSwatchHover.handleSwatchHover;
  var _useSetVisitedProduct = useSetVisitedProduct({
      kic: kic,
      productPageUrl: productPageUrl
    }),
    handleOpenProduct = _useSetVisitedProduct.handleOpenProduct;
  var selectedSwatchName = (_swatchList$find$name = swatchList === null || swatchList === void 0 || (_swatchList$find = swatchList.find(function (swatch) {
    return swatch.product.id === productId;
  })) === null || _swatchList$find === void 0 ? void 0 : _swatchList$find.name) !== null && _swatchList$find$name !== void 0 ? _swatchList$find$name : '';
  var handleCardHover = function handleCardHover(value) {
    // Disable hover functionality for mobile
    if (isDesktop) {
      setIsHoveredWithImagePreloading(value);
    }
  };
  var handleCardFocus = function handleCardFocus() {
    handleCardHover(true);
    setIsQuickviewOpen(false);
  };
  var handleCardBlur = function handleCardBlur(e) {
    /**
     * Consider the card still focused if it or any of its focusable
     * descendants are next to be focused. This is particularly important so
     * that all swatches remain existent/focusable as you tab through them
     */
    handleCardHover(productCardRef.current.contains(e.relatedTarget));
  };
  var handleProductCardClick = function handleProductCardClick(event) {
    if (clickBehavior === CLICK_BEHAVIORS.quickview) {
      event.preventDefault();
      triggerQuickView(event);
    } else if (clickBehavior === CLICK_BEHAVIORS.productPage) {
      if (shouldSetVisitedProduct) {
        handleOpenProduct(event);
      }
      if (isMiniGrid && categoryId) {
        triggerMiniGridAnalytics();
      }
    }
  };
  return /*#__PURE__*/React.createElement("li", {
    ref: productCardRef,
    className: classNames(style.productCard, style[brand], className, _defineProperty(_defineProperty(_defineProperty({}, style.hover, isHovered), miniGridStyle.spotlightCard, isMiniGridSpotlightCard), style.topBadge, socialProofMessage)),
    "data-aui": "product-card",
    "data-intlkic": kic,
    "data-testid": "catalog-product-card",
    onBlur: handleCardBlur,
    onFocus: handleCardFocus,
    onMouseEnter: function onMouseEnter() {
      return handleCardHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return handleCardHover(false);
    },
    style: {
      maxHeight: isHovered ? height : null
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.template, " product-template")
  }, /*#__PURE__*/React.createElement(SocialProofBadge, {
    brand: brand,
    isDesktop: isDesktop,
    socialProofMessage: socialProofMessage
  }), /*#__PURE__*/React.createElement("div", {
    className: style['product-image-section']
  }, /*#__PURE__*/React.createElement(ProductCardImages, {
    forceLifestyleImage: isMiniGridSpotlightCard,
    hoveredSwatch: hoveredSwatch,
    imageHostName: imageHostName,
    imageSet: imageSet,
    noImageFoundImgUrl: noImageFoundImgUrl,
    onClick: handleProductCardClick,
    productName: name,
    productPageUrl: productPageUrl,
    selectedSwatchName: selectedSwatchName,
    showPlaceholder: deferImageLoad && !imagesLoaded
  }), /*#__PURE__*/React.createElement(ProductCardButtons, {
    isSaved: isSaved,
    onQuickViewClick: triggerQuickView,
    onSaveClick: handleSavesClick,
    showQuickView: !isDesktop || isHovered || isQuickviewOpen,
    isDesktop: isDesktop,
    quickViewLabel: quickViewLabel,
    saveLabel: saveButtonSave,
    savedLabel: saveButtonSaved
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(style.content, " product-content")
  }, (swatchList === null || swatchList === void 0 ? void 0 : swatchList.length) > 0 && /*#__PURE__*/React.createElement(ProductSwatches, {
    handleSwatchHover: handleSwatchHover,
    elementChangeWarning: elementChangeWarning,
    imageHostName: imageHostName,
    isDesktop: isDesktop,
    limitSwatches: !isHovered,
    productId: productId,
    productName: name,
    productPageUrl: addUrlParameters(productPageUrl, PRODUCT_CARD_SWATCH_URL_ANALYTICS_PARAMETERS),
    handleSwatchClick: handleSwatchClick,
    showPlaceholder: deferImageLoad && !imagesLoaded,
    swatchList: swatchList
  }), /*#__PURE__*/React.createElement(ProductDetailsSection, {
    badges: badges,
    brand: brand,
    departmentName: departmentName,
    handleProductCardClick: handleProductCardClick,
    memberPrice: memberPrice,
    price: price,
    productName: name,
    productPageUrl: productPageUrl,
    promoMessaging: promoMessaging,
    shortDescriptors: shortDescriptors
  }))));
}
ProductCard.propTypes = productCardProps;var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query Product($productId: String!) {\n    product(productId: $productId) {\n      id\n      productPageUrl\n    }\n  }\n"])));
gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query Product($productId: String!) {\n    product(productId: $productId) {\n      badges {\n        text\n        theme\n      }\n      collection\n      defaultSwatchSequence\n      departmentName\n      id\n      imageSet {\n        primaryFaceOutImage\n        primaryHoverImage\n        prodImage\n        modelImage\n      }\n      kic\n      memberPrice {\n        description\n        originalPrice\n        discountText\n        variant\n      }\n      name\n      price {\n        description\n        originalPrice\n        discountPrice\n        discountText\n        variant\n      }\n      productPageUrl\n      shortDescriptors\n      swatchList {\n        id\n        name\n        sequence\n        swatchImage\n        product {\n          id\n          imageSet {\n            primaryFaceOutImage\n          }\n        }\n      }\n    }\n  }\n"])));
var TEXT_DATA = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  query Text($pairKey: String!, $replacements: [String]) {\n    textFor {\n      pairWithReplacements(pairKey: $pairKey, replacements: $replacements) {\n        key\n        value\n      }\n    }\n  }\n"])));
var getProductDataQuery = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  query Product($productId: String!) {\n    product(productId: $productId) {\n      id\n      productPageUrl\n    }\n  }\n"])));
var addToListMutation = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\nmutation addToMySaves(\n  $productId: String!, \n  $kic: String!, \n  $collectionId: String, \n  $swatchSequence: String, \n  $longSku: String, \n  $colorCode: String\n) {\n  addToMySaves(\n    productId: $productId, \n    kic: $kic, \n    collectionId: $collectionId, \n    swatchSequence: $swatchSequence, \n    longSku: $longSku, \n    colorCode: $colorCode\n  ) {\n    success\n    isFirstTimeSave\n    errors {\n      message {\n          key\n          value\n      }\n      status\n    }\n  }\n}\n"])));
var removeFromListMutation = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\nmutation removeFromMySaves(\n  $productId: String!, \n  $kic: String!, \n  $collectionId: String, \n  $swatchSequence: String, \n  $longSku: String, \n  $colorCode: String\n) {\n  removeFromMySaves(\n    productId: $productId, \n    kic: $kic, \n    collectionId: $collectionId, \n    swatchSequence: $swatchSequence, \n    longSku: $longSku, \n    colorCode: $colorCode\n  ) {\n    success\n    errors {\n      message {\n          key\n          value\n      }\n      status\n    }\n  }\n}\n"])));
var getStoreAttributeData = gql(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  query StoreAttribute {\n    config {\n      hasMfeMySavesEnabled: genericType(name: \"hasMfeMySavesEnabled\")\n    }\n  }\n"])));//  @ts-check

/**
 * Returns the translated text for the given TMNT array.
 * Returns fallback text if query fails.
 * @param {String} pairKey - TMNT key to be translated.
 * @param {Object} options - Object of options for the query.
 * @param {Array} options.replacements - Array of replacements to be used in the query.
 * @param {String} options.fallback - English default text.
 * @param {Boolean} options.skip - Boolean to skip the query.
 * @returns {Object} Object of translated text for the given TMNT array.
 */
var useTranslatedText = function useTranslatedText() {
  var _textData$textFor;
  var pairKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    replacements: [],
    fallback: '',
    skip: false
  };
  var _options$replacements = options.replacements,
    replacements = _options$replacements === void 0 ? [] : _options$replacements,
    _options$fallback = options.fallback,
    fallback = _options$fallback === void 0 ? '' : _options$fallback,
    _options$skip = options.skip,
    skip = _options$skip === void 0 ? false : _options$skip;
  var _useQuery = useQuery(TEXT_DATA, {
      variables: {
        pairKey: pairKey,
        replacements: replacements
      },
      skip: skip
    }),
    loading = _useQuery.loading,
    textData = _useQuery.data;
  var _ref = (textData === null || textData === void 0 || (_textData$textFor = textData.textFor) === null || _textData$textFor === void 0 ? void 0 : _textData$textFor.pairWithReplacements) || {},
    tmntKey = _ref.key,
    tmntValue = _ref.value;
  var resolvedTmntValue = tmntValue && tmntValue !== EMPTY_TMNT ? tmntValue : fallback;
  var translatedTextObject = {
    key: tmntKey || pairKey,
    value: resolvedTmntValue
  };
  if (loading) return {
    key: pairKey,
    value: ''
  };
  return translatedTextObject;
};var getMySavesFromLocalStorage = function getMySavesFromLocalStorage() {
  var savesListInStorage = localStorage.getItem('savesList');
  var mySavesObject = null;
  if (savesListInStorage) {
    mySavesObject = JSON.parse(savesListInStorage);
    if (mySavesObject.timeStamp <= new Date().getTime()) {
      mySavesObject = null;
    }
  }
  return mySavesObject;
};var fetchGuestSession = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(store) {
    var _AbortSignal;
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetch("/api/ecomm/".concat(store, "/session/guest"), _objectSpread2({
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            dataType: 'json'
          }, (_AbortSignal = AbortSignal) !== null && _AbortSignal !== void 0 && _AbortSignal.timeout ? {
            signal: AbortSignal.timeout(API_TIMEOUT)
          } : {}));
        case 2:
          response = _context.sent;
          if (response.ok) {
            _context.next = 5;
            break;
          }
          throw new Error("Network Error: ".concat(response.status, " ").concat(response.statusText, "."));
        case 5:
          return _context.abrupt("return", response.json());
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchGuestSession(_x) {
    return _ref.apply(this, arguments);
  };
}();var useSessionCookies = function useSessionCookies() {
  var getCookies = function getCookies() {
    return api.get() || {};
  };
  var isStorePreview = function isStorePreview() {
    var cookies = getCookies();
    return !cookies ? false : Object.keys(cookies).some(function (key) {
      return key.includes('WCP');
    });
  };
  var getPersistentUserId = function getPersistentUserId(storeId) {
    var cookies = getCookies();
    var cookie = cookies.WCP_PERSISTENT || cookies.WC_PERSISTENT;
    if (!cookie) return null;
    var match = cookie.match(new RegExp("".concat(storeId, "_[-{0-9}]*[0-9]+")));
    if (!match) return null;
    var userId = match[0].split('_')[1];
    return userId !== '-1002' ? userId : null;
  };
  var pullUserIdAndStoreFromUserActivityCookie = function pullUserIdAndStoreFromUserActivityCookie(cookie) {
    return decodeURIComponent(cookie).split(',');
  };
  var getActiveUserId = function getActiveUserId(storeId) {
    var cookies = getCookies();
    var cookieSubKey = isStorePreview() ? 'WCP_USERACTIVITY' : 'WC_USERACTIVITY';
    var activityCookies = Object.entries(cookies).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key.includes(cookieSubKey);
    }).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        cookie = _ref4[1];
      return pullUserIdAndStoreFromUserActivityCookie(cookie);
    });
    if (!activityCookies.length) {
      return null;
    }
    var _ref5 = activityCookies.find(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
          currentStoreId = _ref8[1];
        return currentStoreId === (storeId === null || storeId === void 0 ? void 0 : storeId.toString());
      }) || [null],
      _ref6 = _slicedToArray(_ref5, 1),
      userId = _ref6[0];
    return userId === '-1002' ? null : userId;
  };
  var getSessionId = function getSessionId(storeId) {
    var _getPersistentUserId;
    return (_getPersistentUserId = getPersistentUserId(storeId)) !== null && _getPersistentUserId !== void 0 ? _getPersistentUserId : getActiveUserId(storeId);
  };
  return {
    getSessionId: getSessionId
  };
};/**
 * Custom hook to determine the user's state based on session and cookie data.
 *
 * @param {string} storeId - The store ID used to retrieve the session ID.
 * @returns {Object} An object containing functions to determine the user's state.
 * @returns {Function} return.isGenericUser - Checks if the user is a generic user.
 * @returns {Function} return.isLoggedIn - Checks if the user is logged in.
 * @returns {Function} return.isGuestUser - Checks if the user is a guest.
 */
var useUserState = function useUserState(storeId) {
  var _useSessionCookies = useSessionCookies(),
    getSessionId = _useSessionCookies.getSessionId;
  var userId = getSessionId(storeId);
  var isGeneric = !userId;
  var userType = api.get('userType');
  var isGenericUser = function isGenericUser() {
    return isGeneric;
  };
  var isLoggedIn = function isLoggedIn() {
    return !isGeneric && userType === 'R';
  };
  var isGuestUser = function isGuestUser() {
    return !isGeneric && !isLoggedIn();
  };
  return {
    isGenericUser: isGenericUser,
    isGuestUser: isGuestUser,
    isLoggedIn: isLoggedIn
  };
};function getSettings(addToList, removeFromList) {
  return {
    ADDING: {
      mutationToMake: addToList,
      listDataType: 'addToMySaves',
      analyticsVariation: 'addTo'
    },
    REMOVING: {
      mutationToMake: removeFromList,
      listDataType: 'removeFromMySaves',
      analyticsVariation: 'removeFrom'
    }
  };
}
var useUpdateMySaves = function useUpdateMySaves(_ref) {
  var _storeAttributeData$c;
  var productId = _ref.productId,
    kic = _ref.kic,
    collectionId = _ref.collectionId,
    swatchSequence = _ref.swatchSequence,
    longSku = _ref.longSku,
    colorCode = _ref.colorCode,
    price = _ref.price,
    brand = _ref.brand,
    categoryId = _ref.categoryId,
    name = _ref.name,
    isMiniGrid = _ref.isMiniGrid,
    mySavesItems = _ref.mySavesItems,
    refetch = _ref.refetch,
    store = _ref.store,
    storeId = _ref.storeId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCurrentProductSaved = _useState2[0],
    setIsCurrentProductSaved = _useState2[1];
  var _useState3 = useState(typeof mySavesItems[productId] !== 'undefined'),
    _useState4 = _slicedToArray(_useState3, 2),
    isSaved = _useState4[0],
    setSaved = _useState4[1];
  var _useQuery = useQuery(getStoreAttributeData),
    storeAttributeData = _useQuery.data;
  var hasMfeMySavesEnabled = storeAttributeData === null || storeAttributeData === void 0 || (_storeAttributeData$c = storeAttributeData.config) === null || _storeAttributeData$c === void 0 || (_storeAttributeData$c = _storeAttributeData$c.hasMfeMySavesEnabled) === null || _storeAttributeData$c === void 0 ? void 0 : _storeAttributeData$c.value;
  var _useUserState = useUserState(storeId),
    isGenericUser = _useUserState.isGenericUser;
  var _useMutation = useMutation(addToListMutation),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    addToList = _useMutation2[0];
  var _useMutation3 = useMutation(removeFromListMutation),
    _useMutation4 = _slicedToArray(_useMutation3, 1),
    removeFromList = _useMutation4[0];
  var settings = useMemo(function () {
    return getSettings(addToList, removeFromList);
  }, [addToList, removeFromList]);
  useEffect(function () {
    if (!hasMfeMySavesEnabled) {
      var _mySavesObject$list;
      var mySavesObject = getMySavesFromLocalStorage();
      var savedStatus = !!(mySavesObject !== null && mySavesObject !== void 0 && (_mySavesObject$list = mySavesObject.list) !== null && _mySavesObject$list !== void 0 && _mySavesObject$list[productId]);
      setIsCurrentProductSaved(savedStatus);
    } else {
      setSaved(typeof mySavesItems[productId] !== 'undefined');
    }
  }, [hasMfeMySavesEnabled, productId, mySavesItems]);
  var sendAnalyticsData = function sendAnalyticsData(analyticTriggerVariation) {
    $window === null || $window === void 0 || $window.dispatchEvent(new CustomEvent("analytics.".concat(analyticTriggerVariation, "WishListSuccess"), {
      detail: {
        collectionId: collectionId,
        longSku: longSku,
        colorCode: colorCode
      }
    }));
    if ($window.digitalData) {
      var _price$priceFlag, _price$originalPrice, _price$discountPrice, _price$priceFlag2, _price$originalPrice2, _price$discountPrice2;
      var eventData = isMiniGrid ? {
        brand: brand !== null && brand !== void 0 ? brand : 'null',
        category_id: categoryId !== null && categoryId !== void 0 ? categoryId : 'null',
        collection_id: collectionId !== null && collectionId !== void 0 ? collectionId : 'null',
        key_item_color: kic !== null && kic !== void 0 ? kic : 'null',
        long_sku: 'null',
        price_flag: (_price$priceFlag = price.priceFlag) !== null && _price$priceFlag !== void 0 ? _price$priceFlag : 'null',
        price_list_local: (_price$originalPrice = price.originalPrice) !== null && _price$originalPrice !== void 0 ? _price$originalPrice : 'null',
        price_list_usd: 'null',
        price_offer_local: (_price$discountPrice = price.discountPrice) !== null && _price$discountPrice !== void 0 ? _price$discountPrice : 'null',
        price_offer_usd: 'null',
        product_id: productId !== null && productId !== void 0 ? productId : 'null',
        product_name: name !== null && name !== void 0 ? name : 'null',
        short_sku: 'null'
      } : {
        product_id: productId !== null && productId !== void 0 ? productId : 'null',
        collection_id: collectionId !== null && collectionId !== void 0 ? collectionId : 'null',
        price_flag: (_price$priceFlag2 = price.priceFlag) !== null && _price$priceFlag2 !== void 0 ? _price$priceFlag2 : 'null',
        key_item_color: kic !== null && kic !== void 0 ? kic : 'null',
        price_list_local: (_price$originalPrice2 = price.originalPrice) !== null && _price$originalPrice2 !== void 0 ? _price$originalPrice2 : 'null',
        price_offer_local: (_price$discountPrice2 = price.discountPrice) !== null && _price$discountPrice2 !== void 0 ? _price$discountPrice2 : 'null',
        short_sku: 'null',
        long_sku: longSku !== null && longSku !== void 0 ? longSku : 'null',
        product_name: name !== null && name !== void 0 ? name : 'null',
        price_list_usd: 'null',
        price_offer_usd: 'null'
      };
      $window.digitalData.trigger(analyticTriggerVariation === 'addTo' ? 'analytics.save_for_later' : 'analytics.remove_from_saves', eventData);
    }
  };
  var executeMutation = function executeMutation() {
    var setting = isSaved ? settings.REMOVING : settings.ADDING;
    setSaved(function (currIsSaved) {
      return !currIsSaved;
    });
    setting.mutationToMake({
      variables: {
        productId: productId,
        kic: kic,
        collectionId: collectionId,
        swatchSequence: swatchSequence,
        longSku: longSku,
        colorCode: colorCode
      },
      onCompleted: function () {
        var _onCompleted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return refetch();
              case 2:
                if (setting.listDataType === 'addToMySaves') {
                  $window.dispatchEvent(new CustomEvent('crs:mySaveSuccess', {
                    detail: {
                      isFirstTimeSave: data[setting.listDataType].isFirstTimeSave
                    }
                  }));
                }
                sendAnalyticsData(setting.analyticsVariation);
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function onCompleted(_x) {
          return _onCompleted.apply(this, arguments);
        }
        return onCompleted;
      }(),
      onError: function onError() {
        setSaved(function (currIsSaved) {
          return !currIsSaved;
        });
      }
    });
  };
  var handleSavesClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            if (!isGenericUser()) {
              _context2.next = 4;
              break;
            }
            _context2.next = 4;
            return fetchGuestSession(store);
          case 4:
            executeMutation();
            // eslint-disable-next-line no-empty
            _context2.next = 9;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function handleSavesClick() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleSavesClickLegacy = function handleSavesClickLegacy() {
    var eventType = isCurrentProductSaved ? "mfe:productRemoveSave".concat(isMiniGrid ? 'MiniGrid' : '') : "mfe:productAddSave".concat(isMiniGrid ? 'MiniGrid' : '');
    var saveEvent = new CustomEvent(eventType, {
      detail: {
        productId: productId,
        kic: kic,
        collectionId: collectionId,
        swatchSequence: swatchSequence,
        longsku: '',
        colorCode: colorCode
      }
    });
    $window.dispatchEvent(saveEvent);
    if (isMiniGrid && $window.digitalData) {
      var _price$priceFlag3, _price$originalPrice3, _price$discountPrice3;
      var eventData = {
        brand: brand !== null && brand !== void 0 ? brand : 'null',
        category_id: categoryId !== null && categoryId !== void 0 ? categoryId : 'null',
        collection_id: collectionId !== null && collectionId !== void 0 ? collectionId : 'null',
        key_item_color: kic !== null && kic !== void 0 ? kic : 'null',
        long_sku: 'null',
        price_flag: (_price$priceFlag3 = price.priceFlag) !== null && _price$priceFlag3 !== void 0 ? _price$priceFlag3 : 'null',
        price_list_local: (_price$originalPrice3 = price.originalPrice) !== null && _price$originalPrice3 !== void 0 ? _price$originalPrice3 : 'null',
        price_list_usd: 'null',
        price_offer_local: (_price$discountPrice3 = price.discountPrice) !== null && _price$discountPrice3 !== void 0 ? _price$discountPrice3 : 'null',
        price_offer_usd: 'null',
        product_id: productId !== null && productId !== void 0 ? productId : 'null',
        product_name: name !== null && name !== void 0 ? name : 'null',
        short_sku: 'null'
      };
      $window.digitalData.trigger(isCurrentProductSaved ? 'analytics.remove_from_saves' : 'analytics.save_for_later', eventData);
    }
    setIsCurrentProductSaved(!isCurrentProductSaved);
  };
  return hasMfeMySavesEnabled ? {
    isSaved: isSaved,
    handleSavesClick: handleSavesClick
  } : {
    isSaved: isCurrentProductSaved,
    handleSavesClick: handleSavesClickLegacy
  };
};/**
 * ProductCardDataWrapper component handles queries for the ProductCard component.
 *
 * @param {Object} prop - the props object
 * @param {Object} props.algonomyOnClickAnalytics - Analytics data for Algonomy click events.
 * @param {string} props.className - Additional class names for the product card
 * @param {string} props.clickBehavior - The click behavior for the product card
 * @param {boolean} props.deferImageLoad - Whether to defer image loading
 * @param {boolean} props.hadSwatchInteraction - Whether there was a swatch interaction
 * @param {string} props.imageHostName - The hostname for the product images
 * @param {boolean} props.isDesktop - Whether the view is in desktop or mobile
 * @param {boolean} props.isMfeQuickview - Whether the quickview is the new MFE one or not
 * @param {boolean} props.isMiniGrid - Whether the product card is in a mini grid layout
 * @param {boolean} props.isMiniGridSpotlightCard - Checking for mini grid spotlight card
 * @param {Object} props.mySavesItems - The saved items for the user
 * @param {string} props.noImageFoundImgUrl - The URL for the "no image found" placeholder
 * @param {Function} props.onSwatchInteraction - Callback for swatch interaction
 * @param {Object} props.product - The product data
 * @param {Function} props.refetch - Function to refetch the product data
 * @param {string} props.store - The store identifier
 * @param {string} props.storeId - The store ID
 */
function ProductCardDataWrapper(_ref) {
  var _ref$algonomyOnClickA = _ref.algonomyOnClickAnalytics,
    algonomyOnClickAnalytics = _ref$algonomyOnClickA === void 0 ? {} : _ref$algonomyOnClickA,
    brand = _ref.brand,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$clickBehavior = _ref.clickBehavior,
    clickBehavior = _ref$clickBehavior === void 0 ? CLICK_BEHAVIORS.productPage : _ref$clickBehavior,
    _ref$deferImageLoad = _ref.deferImageLoad,
    deferImageLoad = _ref$deferImageLoad === void 0 ? true : _ref$deferImageLoad,
    _ref$hadSwatchInterac = _ref.hadSwatchInteraction,
    hadSwatchInteraction = _ref$hadSwatchInterac === void 0 ? false : _ref$hadSwatchInterac,
    imageHostName = _ref.imageHostName,
    _ref$isDesktop = _ref.isDesktop,
    isDesktop = _ref$isDesktop === void 0 ? false : _ref$isDesktop,
    _ref$isMfeQuickview = _ref.isMfeQuickview,
    isMfeQuickview = _ref$isMfeQuickview === void 0 ? false : _ref$isMfeQuickview,
    _ref$isMiniGrid = _ref.isMiniGrid,
    isMiniGrid = _ref$isMiniGrid === void 0 ? false : _ref$isMiniGrid,
    _ref$isMiniGridSpotli = _ref.isMiniGridSpotlightCard,
    isMiniGridSpotlightCard = _ref$isMiniGridSpotli === void 0 ? false : _ref$isMiniGridSpotli,
    _ref$mySavesItems = _ref.mySavesItems,
    mySavesItems = _ref$mySavesItems === void 0 ? {} : _ref$mySavesItems,
    noImageFoundImgUrl = _ref.noImageFoundImgUrl,
    _ref$onSwatchInteract = _ref.onSwatchInteraction,
    onSwatchInteraction = _ref$onSwatchInteract === void 0 ? function () {} : _ref$onSwatchInteract,
    product = _ref.product,
    _ref$refetch = _ref.refetch,
    refetch = _ref$refetch === void 0 ? function () {} : _ref$refetch,
    store = _ref.store,
    storeId = _ref.storeId,
    shouldSetVisitedProduct = _ref.shouldSetVisitedProduct;
  var getSwatchAnalyticsData = function getSwatchAnalyticsData() {
    var _treatments$;
    // Use default analytics parameters if algonomyOnClickAnalytics is an empty object
    if (Object.keys(algonomyOnClickAnalytics).length === 0) {
      return PRODUCT_CARD_SWATCH_URL_ANALYTICS_PARAMETERS;
    }
    var _algonomyOnClickAnaly = algonomyOnClickAnalytics.placementObj,
      placementObj = _algonomyOnClickAnaly === void 0 ? {} : _algonomyOnClickAnaly;
    var _placementObj$name = placementObj.name,
      name = _placementObj$name === void 0 ? '' : _placementObj$name,
      _placementObj$treatme = placementObj.treatments,
      treatments = _placementObj$treatme === void 0 ? [] : _placementObj$treatme;
    var testId = treatments && Array.isArray(treatments) && treatments.length > 0 ? ((_treatments$ = treatments[0]) === null || _treatments$ === void 0 ? void 0 : _treatments$.testId) || '' : '';
    var prodvm = "recommendations-".concat(name, "-").concat(testId);
    var dataText = 'recommendations-swatch';
    var dataAction = 'click';
    var pagefm = 'navigation-swatch';
    return {
      pagefm: pagefm,
      prodvm: prodvm,
      dataText: dataText,
      dataAction: dataAction
    };
  };
  var _useLazyQuery = useLazyQuery(getProductDataQuery, {
      ssr: false,
      onCompleted: function onCompleted(data) {
        var productSwatchAnalytics = getSwatchAnalyticsData();
        window.location.assign(addUrlParameters(data.product.productPageUrl, productSwatchAnalytics));
      }
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 1),
    getProductData = _useLazyQuery2[0];
  var handleSwatchClick = function handleSwatchClick(swatchId) {
    var productSwatchAnalytics = getSwatchAnalyticsData();
    if (swatchId === product.id) {
      window.location.assign(addUrlParameters(product.productPageUrl, productSwatchAnalytics));
    } else {
      getProductData({
        variables: {
          productId: swatchId
        }
      });
    }
  };
  var productId = product.id,
    kic = product.kic,
    collection = product.collection,
    defaultSwatchSequence = product.defaultSwatchSequence,
    price = product.price,
    categoryId = product.categoryId,
    name = product.name;
  var _useUpdateMySaves = useUpdateMySaves({
      productId: productId,
      kic: kic,
      collectionId: collection,
      swatchSequence: defaultSwatchSequence,
      longsku: '',
      colorCode: defaultSwatchSequence,
      price: price,
      brand: brand,
      categoryId: categoryId,
      name: name,
      isMiniGrid: isMiniGrid,
      mySavesItems: mySavesItems,
      refetch: refetch,
      store: store,
      storeId: storeId
    }),
    handleSavesClick = _useUpdateMySaves.handleSavesClick,
    isSaved = _useUpdateMySaves.isSaved;
  var text = {
    elementChangeWarning: useTranslatedText('elementChangeWarning', {
      fallback: 'Activating this element will cause content on the page to be updated.'
    }),
    quickViewLabel: useTranslatedText('quickview', {
      fallback: 'Quickview'
    }),
    saveButtonSave: useTranslatedText('saveButtonSave', {
      fallback: 'Save'
    }),
    saveButtonSaved: useTranslatedText('saveButtonSaved', {
      fallback: 'Saved'
    })
  };
  return /*#__PURE__*/React.createElement(ProductCard, {
    algonomyOnClickAnalytics: algonomyOnClickAnalytics,
    brand: brand,
    categoryId: categoryId,
    className: className,
    clickBehavior: clickBehavior,
    deferImageLoad: deferImageLoad,
    hadSwatchInteraction: hadSwatchInteraction,
    handleSavesClick: handleSavesClick,
    handleSwatchClick: handleSwatchClick,
    imageHostName: imageHostName,
    isDesktop: isDesktop,
    isMfeQuickview: isMfeQuickview,
    isMiniGrid: isMiniGrid,
    isMiniGridSpotlightCard: isMiniGridSpotlightCard,
    isSaved: isSaved,
    noImageFoundImgUrl: noImageFoundImgUrl,
    onSwatchInteraction: onSwatchInteraction,
    product: product,
    shouldSetVisitedProduct: shouldSetVisitedProduct,
    text: text
  });
}
ProductCardDataWrapper.propTypes = productCardDataWrapperProps;export{AddToBagRecommendationsContextProvider,BubbleRecItem,BubbleRecommendations,CONSENT_IDENTIFIERS,CategoryRecommendationsContextProvider,Content,DesignSystemRenderer as DSLayout,GET_MICROFRONTEND_CLIENT,GenericRecommendationsContextProvider,MicroFrontend,MyListRecommendationsContextProvider,NullSearchRecommendationsContextProvider,PDPRecommendationsContextProvider,PickedForYouRecommendationsContextProvider,ProductCard,ProductCardDataWrapper,QuickviewRecommendationsContextProvider,RECOMMENDATIONS_DATA_QUERY,RECOMMENDATIONS_QUERY,RecommendationSlider,RecommendationSliders,Recommendations,RecommendationsContext,SearchRecommendationsContextProvider,Slider,collectOnClickAnalyticsData,collectOnLoadAnalyticsData,fragments,getCacheId,getFrontendId,getProdvmFromDatabridge,getXSegCookieKeyValue,handlePDPAnalytics,handlePDPAnalyticsGlobal,handleQuickViewClickAnalytics,onRecommendationsQueryCompleted,onRecommendedProductClick,onRecommendedProductSwatchClick,onSwatchClickHandler,runAnalyticsOnClick,runAnalyticsOnLoad,runAnalyticsUniversalScrollEvent,useCategoryId,useConsentFromDatabridge,useDatabridge,useDatabridgeSubscribe,useElementOnScreen,useFocusSource,useIsExternalUser,useLoudCrowdScript,useMyListItems,useSearchTerm,useSlider,useUserConsent};//# sourceMappingURL=index.js.map
